<div class="dialog-header mb-3" *ngIf="data.type == 1" [class.resend__sub__link]="data.actionClass == 'resend__sub__link'">
  <h2 style="margin-left: 0px !important; display: flex !important; justify-content: space-between;" mat-dialog-title class="px-4">{{data.title}}
    <mat-icon *ngIf="data.actionClass !== 'resend__sub__link'" (click)="dialogRef.close(resaonValue>=0 ? {result:0,reason:null} : 0)" class="close pull-right">close</mat-icon>
    <svg class="cross" *ngIf="data.actionClass == 'resend__sub__link'" style="border: 1px solid black; border-radius:50%" (click)="dialogRef.close()" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 27L27 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M27 27L13 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </h2>
  <div mat-dialog-content>
    <h5 *ngIf="!data.showCheckbox"><strong>{{data.desc}}</strong></h5>
    <h5 *ngIf="data.showCheckbox" class="font--modify"><strong [innerHtml]="data.desc"></strong></h5>

    <mat-checkbox class="apply-cont checkbox-cls checkbox--modify m-0" *ngIf="data.actionClass == 'resend__sub__link' && data.showCheckbox" [(ngModel)]="notify_checkbox" name="terms">
      <small class="mb-0 mt-2">Notify the customer of this cancellation via email</small>
    </mat-checkbox>
    <div class="form-group mt-3">
        <label>Note*</label>
         <textarea required [(ngModel)]="cancelNotes" class="form-control"  maxlength="200" ></textarea>
    </div>
  </div>
  <!-- (blur)="trmiValuesEvent($event)" -->
  <!-- <div class="d-flex -justify-content-between " style="padding-right:16px !important;" mat-dialog-actions [ngClass]="data.actionClass == 'resend__sub__link' ? 'ms-2' : 'ms-3' " [class.button--wrapper--modify]="data.showCheckbox">
    <button class="button--modify" button-primary-auth [ngClass]="data.actionClass" (click)="confirmAction()">{{data.action}}</button>
    <button class="cancel__button ms-3" button-primary-auth (click)="dialogRef.close()" *ngIf="data.showCheckbox">Cancel</button>
  </div> -->

  <div class="d-flex justify-content-between mx-3" style="padding-right:16px !important;" mat-dialog-actions [ngClass]="data.actionClass == 'resend__sub__link' ? 'ms-2' : 'ms-3' " [class.button--wrapper--modify]="data.showCheckbox">
    <!-- <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button> -->

    <div class="dropdown w-100 mb-4" *ngIf="data.reasons">
      <div class='wrap m-h-56 h-100 h-56 border_10 d-block'>
        <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
          <div class="w-100 h-100">
            <select id="img_logo_emp" [(ngModel)]="resaonValue" (change)="other_reason=''"
              class="select-text pt-3 px-3 mt-1 input_field px-3 pt-3 fw-bold m-h-56 h-100 w-100" required>
              <option class="w-100 py-3 px-2 d-none" selected>
              </option>
              <ng-container *ngFor="let resaon of data.reasons;let i = index;">
                <option class="w-100 py-3 px-2" [value]="i">
                  {{resaon}}
                </option>
              </ng-container>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
            <span class="select-bar-1"></span>
            <label class="select-label f-c-p-3">Please select reason</label>
          </div>
        </div>
      </div>

      <div>
        <div class="w-100 mi-w-180" *ngIf="resaonValue && resaonValue == (data.reasons.length -1)">
          <div class="custom-form mt-3">
            <input type="text" class="input_field px-3 pt-3" name="other_reason" [(ngModel)]="other_reason" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Reason
              </span>
            </label>
          </div>
        </div>
      </div>

    </div>
    <button button-primary-auth [ngClass]="data.actionClass" (click)="confirmAction()" [disabled]="(!cancelNotes || cancelNotes.trim().length === 0) || data.reasons && data.reasons.length && (!resaonValue || (resaonValue == 5 && !other_reason))">{{data.action}}</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 2">
  <h2 mat-dialog-title> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <h4><strong>{{data.desc}}</strong></h4>
    <br />
    <div>
      <p *ngIf="data && data.send_data && data.send_data.patient_email" style="word-break: break-all;">
        Customer Email: <strong>{{data.send_data.patient_email}}</strong>
      </p>
      <p *ngIf="data && data.send_data &&  data.send_data.patient_mobile">
        Customer Mobile: <strong>{{data.send_data.patient_mobile}}</strong>
      </p>
    </div>
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button (click)="confirmAction()">{{data.action}}</button>
  </div>
</div>
<div class="dialog-header view-plans" *ngIf="data.type == 3">
  <h2 mat-dialog-title> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div class="row mb-4">
      <div class="col-md-6 col-sm-12 col-lg-6">
        <div class="d-flex justify-content-start align-items-center flex-wrap common-info rounded p-2">
          <div class="box-item">
            <h5>Estimated Service Amount</h5>
            <span class="notranslate">${{data.send_data.plan_array[0].treatment_amount | number:'1.2-2'}}</span>
          </div>
          <div class="box-item">
            <h5>Estimated Payment Plan Amount</h5>
            <span class="notranslate">${{(data.send_data.plan_array[0].treatment_amount -
              (data.send_data.plan_array[0].downpayment?data.send_data.plan_array[0].downpayment:data.send_data.plan_array[0].downpayment_amount))
              | number:'1.2-2'}}</span>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 col-lg-6">
        <div class="d-flex justify-content-start align-items-center flex-wrap common-info rounded p-2">
          <div class="box-item">
            <h5>Down Payment</h5>
            <span class="notranslate">${{data.send_data.plan_array[0].downpayment?data.send_data.plan_array[0].downpayment:data.send_data.plan_array[0].downpayment_amount
              | number:'1.2-2'}}</span>
          </div>
          <div class="box-item">
            <h5>Enrollment Fee</h5>
            <span class="notranslate">${{ data.send_data.plan_array && data.send_data.plan_array[0].enrollment_fee ?
              data.send_data.plan_array[0].enrollment_fee : 30}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row plan_div" *ngIf="data.send_data && data.send_data.plan_array.length>0"
      style="height: 100%;overflow-y:auto;overflow-x: hidden;">
      <div
        [ngClass]="{'col-4': data.send_data.plan_array && data.send_data.plan_array.length > 1, 'col-12':  data.send_data.plan_array && data.send_data.plan_array.length == 1}"
        *ngFor="let plan of data.send_data.plan_array" style="box-shadow:none" class="mb-4">
        <div class="card border plan-box">
          <div class="card-header">
            <div class="mb-0 ps-3 pe-3 row justify-content-between position-relative">
              <div class="w-100">
                <h4>{{plan.month}} months</h4>
              </div>
              <div>
                <span
                  *ngIf="data.send_data.splitRequest.columnTwentyOne == plan.month && data.send_data.splitRequest.columnNineteen != 0 && data.send_data.splitRequest.columnEighteen == 0"
                  class="badge badge-warning ms-auto pull-right">Plan Selected,
                  Payment Plan Details Pending</span>
                <span
                  *ngIf="data.send_data.splitRequest.columnTwentyOne == plan.month && data.send_data.splitRequest.columnNineteen != 0 && data.send_data.splitRequest.columnEighteen != 0"
                  class="badge badge-success ms-auto pull-right">Selected</span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="text-center">
              <h3><strong class="notranslate">${{plan.recurring_amount | number: '1.2-2'}}</strong></h3>
              <h4><strong>per month</strong></h4>
            </div>
            <!-- <div>
              <span>Estimated Service Amount:</span>
              <span class="pull-right">${{plan.treatment_amount | number: '1.2-2'}}</span>
            </div> -->
            <!-- <div>
              <span>Down Payment:</span>
              <span class="pull-right">${{plan.downpayment?plan.downpayment:plan.downpayment_amount}}</span>
            </div> -->
            <!-- <div>
              <span>Estimated Financed Amount:</span>
              <span
                class="pull-right">${{(plan.treatment_amount - (plan.downpayment?plan.downpayment:plan.downpayment_amount)) | number: '1.2-2'}}</span>
            </div> -->
            <div>
              <span *ngIf="data.send_data.splitRequest.columnEight == 2">Upfront Payment:</span>
              <span *ngIf="data.send_data.splitRequest.columnEight == 1">First Recurring Due
                Today:</span>
              <span class="pull-right notranslate">${{plan.advance_interest_amount | number: '1.2-2'}}</span>
            </div>
            <div>
              <span>Interest Rate:</span>
              <span class="pull-right notranslate">{{plan.interest_rate_to_show ? plan.interest_rate_to_show : plan.interest_rate}}%
                <sup>{{(plan.interest_rate_to_show == plan.interest_rate ? (plan.interest_rate>0?'C':'') : 'F')}}</sup></span>
            </div>
            <div>
              <span>Transaction Fee:</span>
              <span *ngIf="getTransactionFee(plan, plan.recurring_amount?plan.recurring_amount:0)"
                class="pull-right notranslate">{{getTransactionFee(plan, plan.recurring_amount?plan.recurring_amount:0)}}
                per payment</span>
            </div>
            <!-- <div>
              <span>Enrollment Fee:</span>
              <span class="pull-right"> $30.00 </span>
            </div> -->
            <!-- <div>
              <span> Total Payable Amount:</span>
              <span class="pull-right">${{plan.amount?plan.amount:plan.remaining_amount | number: '1.2-2'}}</span>
            </div> -->
            <div>
              <span><strong>Total Payable Today:</strong></span>
              <span class="pull-right notranslate"><strong>${{plan.to_pay_today | number: '1.2-2'}}</strong></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 pt-3">
        <span class="text-muted"><b>F:</b> Flat Interest, <b>C:</b> Compound Interest</span>
      </div>
    </div>


  </div>
  <div class="d-flex justify-content-end">
    <button class="close_btn me-3" #closebtn (click)="dialogRef.close();closebtn.blur()">Close</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 4" [class.resend__sub__link]="data.actionClass == 'resend__sub__link'">
  <h2 mat-dialog-title style="margin-left: 0px !important;display: flex !important; justify-content: space-between;" > {{data.title}}
    <mat-icon *ngIf="data.actionClass !== 'resend__sub__link'" (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
    <svg class="cross" *ngIf="data.actionClass == 'resend__sub__link'" (click)="dialogRef.close()" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 27L27 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M27 27L13 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </h2>
  <div mat-dialog-content style="padding: 0 37px !important;">
    <h5 style="font-weight: 700; font-size:1em" *ngIf="data && data.send_data">
      Are you sure, you want to refund
      <span class="notranslate">${{data.send_data.amount + data.send_data.patient_transaction_fee | number:'1.2-2'}}</span>
      <span *ngIf="data.send_data.name"> to {{data.send_data.name}} at</span>
      <span *ngIf="data.send_data.patient_email || data.send_data.patient_mobile" style="word-break: break-word;" class="color__change">
        {{data.send_data.patient_email || data.send_data.patient_mobile}}</span>?
    </h5>
    <br />
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions style="padding:5px 37px !important;">
    <!-- <button class="cancel-button" (click)="dialogRef.close()">Cancel</button> -->
    <button class="send-button" (click)="confirmAction()">{{data.action}}</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 5" [class.resend__sub__link]="data.actionClass == 'resend__sub__link'">
  <h2 style="margin-left: 0px !important; display: flex !important; justify-content: space-between;" mat-dialog-title> {{data.title}}

    <svg class="cross" *ngIf="data.actionClass == 'resend__sub__link'" (click)="dialogRef.close()" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 27L27 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M27 27L13 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <mat-icon *ngIf="data.actionClass != 'resend__sub__link'" (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <form #resendLinkForm="ngForm" name="resendLinkForm" (submit)="resendLink(resendLinkForm)"
    class="container  form-cont">
    <div mat-dialog-content *ngIf="data && data.send_data">
      <h3 style="font-weight: 500;" *ngIf="data.desc">{{data.desc}} </h3>
      <br *ngIf="data.desc" />

      <!-- <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-12 p-0">
        <mat-label>Email</mat-label>
        <input [(ngModel)]="data.send_data.user_email" required name="user_email" #user_email="ngModel" matInput
          placeholder="Email Address" trim  email>
        <mat-error *ngIf="user_email.invalid" style="margin-top: 9px;  margin-left: -10px;">Please enter a valid email
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-12 p-0">
        <mat-label>Phone Number</mat-label>
        <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== '' "
          style="position: absolute; padding: 1.9px">+1</span>
        <input [ngStyle]="{'padding': data.send_data.user_phone !== '' ? '0px 22px' : '0px'}"
          [(ngModel)]="data.send_data.user_phone" name="user_phone" #user_phone="ngModel" matInput
          placeholder="Text Message (optional)" [mask]="mask">
      </mat-form-field> -->

      <div class="custom-form">
        <input class="input_field pt-3 ps-3" type="email" [(ngModel)]="data.send_data.user_email" required
          name="user_email" #user_email="ngModel" trim  />
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Email
          </span>
        </label>
      </div>

      <div class="mt-3">
        <div class="custom-form">
          <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== '' "
            class="pt-2 pe-1 fw-bold dollar_input"
            style="position: absolute;left: 14px;bottom: 8px;">+1
          </span>
          <input class="input_field pt-3"
            [ngStyle]="{'padding-left': data.send_data.user_phone  !== '' ? '40px' : '1rem'}"
            name="user_phone" [(ngModel)]="data.send_data.user_phone" [mask]="mask"
             />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Phone Number
            </span>
          </label>
        </div>
      </div>

      <div *ngIf="data.actionClass == 'resend__sub__link'" class="mt-3">
        <textarea type="text" class="form-control note-textarea" [(ngModel)]="resendNotes" placeholder="Message (optional)" style="min-height: 101px;"  (keypress)="mainService.handleInputSpace($event)" [ngModelOptions]="{standalone: true}">
            </textarea>
      </div>


      <div class="py-3">
        <div class="wrap m-h-56 h-100 h-56 d-block">
          <div class="select w-100 h-100 h-56">
            <select required [(ngModel)]="languageSelected" [ngModelOptions]="{standalone: true}"
              class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
              <option class="w-100 py-3 px-2" *ngFor="let d of languages" [value]="d.lan_code">
                {{d.lan_name}}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
            <label class="select-label f-c-p-3">Select Language</label>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between ms-3" mat-dialog-actions style="padding-left: 7px !important;">
      <button type="submit" button-primary-auth [disabled]="!resendLinkForm.valid">{{data.action}}</button>
    </div>
  </form>
</div>
<div class="dialog-header" *ngIf="data.type == 6" [class.resend__sub__link]="data.actionClass == 'resend__sub__link'">
  <h2 style="margin-left: 0px !important;" mat-dialog-title> {{data.title}}
    <svg class="cross" *ngIf="data.actionClass == 'resend__sub__link'" (click)="dialogRef.close()" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 27L27 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M27 27L13 13" stroke="#131921" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <mat-icon *ngIf="data.actionClass != 'resend__sub__link'" (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <form #sendReceiptForm="ngForm" name="sendReceiptForm" (submit)="sendReceiptLink(sendReceiptForm)"
    class="container form-cont">
    <div style="padding: 0px 22px;" *ngIf="data && data.send_data">
      <h4 style="font-weight: 500;" *ngIf="data.desc">{{data.desc}} </h4>
      <br *ngIf="data.desc" />

      <!-- <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-12 p-0 mb-2">
        <mat-label>Email</mat-label>
        <input class="mt-1" [(ngModel)]="data.send_data.user_email" required name="user_email" #user_email="ngModel"
          matInput placeholder="Email Address" trim  email>
        <mat-error *ngIf="user_email.invalid" style="margin-top: -2px;margin-left: -10px;">Please enter a valid email
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-12 p-0 mb-2">
        <mat-label>Phone Number</mat-label>
        <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== '' "
          style="position: absolute; padding: 2.9px; margin-top: 5px;">+1-</span>
        <input class="mt-1" [ngStyle]="{'padding': data.send_data.user_phone !== '' ? '0px 28px' : '0px'}"
          [(ngModel)]="data.send_data.user_phone" name="user_phone" #user_phone="ngModel" matInput
          placeholder="Text Message (optional)" [mask]="mask">
      </mat-form-field> -->

      <!-- <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-12 p-0">
        <mat-label>Select Language for Communication</mat-label>
        <mat-select [(ngModel)]="languageSelected"  [ngModelOptions]="{standalone: true}" required name="languageSelected">
          <mat-option *ngFor="let d of languages" [value]="d.lan_code">
            <span class="notranslate">{{d.lan_name}}</span>
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <div class="custom-form">
        <input class="input_field pt-3 ps-3" type="email" [(ngModel)]="data.send_data.user_email" required
          name="user_email" #user_email="ngModel" trim  />
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Email
          </span>
        </label>
      </div>

      <div class="mt-3">
        <div class="custom-form">
          <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== '' "
            class="pt-2 pe-1 fw-bold dollar_input"
            style="position: absolute;left: 14px;bottom: 8px;">+1
          </span>
          <input class="input_field pt-3"
            [ngStyle]="{'padding-left': data.send_data.user_phone  !== '' ? '40px' : '1rem'}"
            name="user_phone" [(ngModel)]="data.send_data.user_phone" [mask]="mask"
            required />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Phone Number
            </span>
          </label>
        </div>
      </div>

      <div class="py-3">
        <div class="wrap m-h-56 h-100 h-56 d-block">
          <div class="select w-100 h-100 h-56">
            <select required [(ngModel)]="languageSelected" [ngModelOptions]="{standalone: true}"
              class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
              <option class="w-100 py-3 px-2" *ngFor="let d of languages" [value]="d.lan_code">
                {{d.lan_name}}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
            <label class="select-label f-c-p-3">Select Language</label>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between" style="padding: 0px 22px;">
      <button class="send-button" type="submit">{{data.action}}</button>
    </div>
  </form>
</div>
<div class="dialog-header unset_width width_650" *ngIf="data.type == 7">
  <h2 mat-dialog-title>
    <span class="px-3" *ngIf="cancel_contract_step == 1">Cancel Contract </span>
    <span class="px-3" *ngIf="cancel_contract_step == 2">Choose Payment Method </span>
    <span class="px-3" *ngIf="cancel_contract_step == 3">Confirmation of Contract Cancelation </span>
    <span class="px-3" *ngIf="cancel_contract_step == 4 && payment_result.is_error == 0">{{payment_option.paymentType &&
      selected_option == 5 ? 'Transaction Initiated' : 'Contract Canceled Successfully'}}
    </span>
    <span class="px-3" *ngIf="cancel_contract_step == 4 && payment_result.is_error == 1">Payment Failed </span>
    <span class="px-3" *ngIf="cancel_contract_step == 5">Email/Text Sent Successfully </span>
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0">
    <!-- step 1-->
    <div *ngIf="cancel_contract_step == 1">
      <div class="row">
        <h5 class="col-12 py-2 px-4">Contract ID: {{contractData.contract_code}}</h5>
        <hr class="w-100" />
      </div>
      <div class="col-md-12 details">
        <div class="w-100">
          <div class="row">
            <div class="col-sm-4">
              <label>Service Amount:</label>
              <h6><b class="notranslate">${{contractData.treatment_amount | number:'1.2-2'}}</b></h6>
            </div>
            <div class="col-sm-4">
              <label>Down Payment Amount: </label>
              <h6><b class="notranslate">${{contractData.downpayment_amount | number:'1.2-2'}}</b></h6>
            </div>

            <div class="col-sm-4">
              <label>Payment Plan Amount:</label>
              <h6><b class="notranslate">${{contractData.financed_amount | number:'1.2-2'}}</b></h6>
            </div>

            <div class="col-sm-4">
              <label>Interest:</label>
              <h6 class="notranslate"><b>{{contractData.interest_rate | number:'1.2-2'}}%</b></h6>
            </div>

            <div class="col-sm-4">
              <label>Recurring Amount:</label>
              <h6><b class="notranslate">${{contractData.recurring_amount | number:'1.2-2'}}
                  <span *ngIf="contractData && getTransactionFee(contractData,contractData.recurring_amount)">
                    + {{getTransactionFee(contractData,contractData.recurring_amount)}}
                  </span>
                </b></h6>
            </div>
            <div class="col-sm-4">
              <label>Total Payments:</label>
              <h6><b>{{contractData.number_of_payments}}</b></h6>
            </div>
            <div class="col-sm-4">
              <label>Remaining Payments:</label>
              <h6><b>{{contractData.remaining_payments}}</b></h6>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- step 2-->
    <div *ngIf="cancel_contract_step == 2">
      <h5 class="ps-1 ms-1">Contract Cancelation Fee: $30</h5>
      <div class="row px-1 py-4">
        <div class="col-12 font-size-14">
          Who will be responsible for the payment?
        </div>
        <div class="col-12">
          <div class="row g-0 py-3">
            <div class="col-xs-6 col-6 text-start p-0">
              <mat-radio-group name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="1">Customer</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-xs-6 col-6 p-0">
              <mat-radio-group name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="2">Business</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <div class="card-select-radio" [ngClass]="{'bg-primary':selected_option == 1}">
                <div class="radio_div"
                  [ngClass]="{'text-light':selected_option == 1, 'dark-color':selected_option != 1}">
                  <mat-radio-group name="b" [(ngModel)]="selected_option">
                    <mat-radio-button [value]="1">
                      <b class="card-select-radio-text">Customer's Default Card <br>
                        <img src="/assets/img/svg/pay-white.svg" class="card-icon" *ngIf="selected_option == 1" />
                        <img src="/assets/img/svg/pay.svg" class="card-icon" *ngIf="selected_option != 1" />
                        {{contractData.default_card_last4}} </b>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <div class="card-select-radio" [ngClass]="{'bg-primary':selected_option == 4}">
                <div class="radio_div"
                  [ngClass]="{'text-light':selected_option == 4, 'dark-color':selected_option != 4}">
                  <mat-radio-group name="b" [(ngModel)]="selected_option">
                    <mat-radio-button [value]="4">
                      <b class="card-select-radio-text">Pay with a new card <br /> &nbsp;</b>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 2">
          <div class="row">
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <div class="card-select-radio" [ngClass]="{'bg-primary':selected_option == 3}">
                <div class="radio_div"
                  [ngClass]="{'text-light':selected_option == 3, 'dark-color':selected_option != 3}">
                  <mat-radio-group name="business" [(ngModel)]="selected_option">
                    <mat-radio-button [value]="3">
                      <b class="card-select-radio-text"> Pay from your Denefits<br /> account</b>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <div class="card-select-radio" [ngClass]="{'bg-primary':selected_option == 2}">
                <div class="radio_div"
                  [ngClass]="{'text-light':selected_option == 2, 'dark-color':selected_option != 2}">
                  <mat-radio-group name="business" [(ngModel)]="selected_option">
                    <mat-radio-button [value]="2">
                      <b class="card-select-radio-text"> Pay with a new card <br /> &nbsp;</b>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="text-start" style="display:flex;align-items:center;"
              [ngClass]="{'col-4': (contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'), 'col-6' : !(contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified')}">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="1">
                  <b class="card-select-radio-text">Customer’s Existing Card(s)</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="text-start p-0" style="display:flex;align-items:center;"
              [ngClass]="{'col-4': (contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'), 'col-6' : !(contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified')}">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="4">
                  <b class="card-select-radio-text">Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-4 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="5">
                  <b class="card-select-radio-text">Customer Bank Account ({{contractData.plaidAccount[0].last4}})</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-2"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">
          <mat-radio-group>
            <mat-radio-button *ngFor="let card of changePaymentDateCardList; let i=index" style="cursor:pointer"
              class="col-10 justify-content-between align-item-center border rounded p-2 mb-2" [value]="card.source_id"
              (click)="selPaymentCard(card);" [checked]="card.source_id==contractData.source_id">
              <div>
                <span>
                  <img style="width:24px;"
                    [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                    *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express';else no_card " />
                  <ng-template #no_card>
                    <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                  </ng-template>
                </span>
                <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
              </div>
              <div>
                <p *ngIf="card.last_error" class="col-12" style="font-size:12px;"
                  [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">{{card.last_error}}</p>
                <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                  style="font-size:12px;display: flex; align-items: center; flex-direction:row-reverse;">
                  <mat-icon class="check">check_circle_outline</mat-icon>Default
                </p>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-lg-12 col-xs-12 mt-2" *ngIf="payment_option.paymentType == 2">
          <div class="row">
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="3">
                  <b class="card-select-radio-text"> Pay from your <span class="notranslate">Denefits</span> account</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="2">
                  <b class="card-select-radio-text"> Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 2 && selected_option == 3">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          your Business connected bank account.</li>
      </ul>
    </div>
    <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 1 && selected_option == 1">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          the customer’s existing card(s) for this contract.</li>
      </ul>
    </div>
    <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 1 && selected_option == 5">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          the customer’s connected bank account for this contract.</li>
      </ul>
    </div>
    <div class="card-hidden mt-4" [ngClass]="{'show-card':cancel_contract_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
        (payment_option.paymentType == 1 && selected_option == 4))}" *ngIf="cancel_contract_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
        (payment_option.paymentType == 1 && selected_option == 4))">
      <div class="row me-0 ms-0">
        <div class="col-xs-12 col-md-6 form-cont">
          <div class="w-100">
            <label class="form-label d-block ">Card Holder Name</label>
            <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
              (focus)="getCard()" placeholder="Enter cardholder name" trim  maxlength="100" minlength="2"
              class="form-input" style="min-height: 56px !important;">
            <p *ngIf="cardholder_name.invalid" class="mat-error">Please enter a cardholder name</p>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <label class="form-label d-block ">Card Number</label>
          <div class="stripe-card" id="cancel_contract"></div>
        </div>
      </div>
      <div class="col-12">
        <ul style="list-style: disc;" class="px-3">
          <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
            the business new card.
          </li>
          <li style="font-size: 14px !important; font-weight: 400 !important;"
            *ngIf="payment_option.paymentType == 1 && selected_option == 4">
            Newly added card will not be used as default payment method for future payments for this contract.
          </li>
          <li style="font-size: 14px !important; font-weight: 400 !important;">We will not save the card for this
            contract.</li>
        </ul>
      </div>
    </div>

    <!-- step 3-->
    <div *ngIf="cancel_contract_step == 3" class="px-0">
      <div class="row m-0 bg-muted p-2">
        <div class="col-12">
          <div class="row m-b-10">
            <div class="col-4 ">Contract ID:</div>
            <div class="col-8 text-start">
              <span class="h5 text-bold">
                {{contractData.contract_code}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              Payable by:
            </div>
            <div class="col-8">
              <div style="display:flex;flex-direction: column;">
                <span class="h5 text-bold w-100" style="max-width:235px;">
                  <span *ngIf="payment_option.paymentType == 1">
                    {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                  </span>
                  <span *ngIf="payment_option.paymentType == 2">
                    {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                    contractData.doctor_last_name}}
                  </span>
                </span>

                <span *ngIf="selected_option == 1">
                  <span class="card-select-confirm w-100">
                    <span class="small">Customer's {{contractData.source_id == changePaymentDateCard.source_id ?
                      'Default' : ''}} Card</span> <br>
                    <img src="assets/img/svg/pay.svg" class="card-icon" /> XXXX XXXX XXXX
                    {{contractData.default_card_last4}}
                  </span>

                </span>
                <span class="ms-3" *ngIf="selected_option == 4">
                  <span class="card-select-confirm">
                    <span class="small">Customer's New Card</span> <br>
                    <img style="width:24px;"
                      [src]="payment_stripe_data.token.card.brand?'assets/img/svg/card-type/'+payment_stripe_data.token.card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                      *ngIf="payment_stripe_data.token.card.brand.toLowerCase() == 'mastercard' || payment_stripe_data.token.card.brand=='Discover' || payment_stripe_data.token.card.brand=='JCB' || payment_stripe_data.token.card.brand=='Visa' || payment_stripe_data.token.card.brand=='American Express';else no_card " />
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>&nbsp;&nbsp; XXXX XXXX XXXX
                    {{payment_stripe_data.token.card.last4}}
                  </span>
                </span>

                <span *ngIf="selected_option == 5">
                  <span class="card-select-confirm w-100">
                    <span class="small">Customer's Bank Account</span> <br>
                    <mat-icon>account_balance</mat-icon>XXXX XXXX {{contractData.plaidAccount[0].last4}}
                  </span>
                </span>

                <span class="mt-3" *ngIf="selected_option == 3">
                  <span class="card-select-confirm">
                    <span class="small"><span class="notranslate">Denefits</span> account</span>
                  </span>
                </span>
                <span class="ms-3" *ngIf="selected_option == 2">
                  <span class="card-select-confirm">
                    <span class="small">Your New Card</span> <br>
                    <img style="width:24px;"
                      [src]="payment_stripe_data.token.card.brand?'assets/img/svg/card-type/'+payment_stripe_data.token.card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                      *ngIf="payment_stripe_data.token.card.brand.toLowerCase() == 'mastercard' || payment_stripe_data.token.card.brand=='Discover' || payment_stripe_data.token.card.brand=='JCB' || payment_stripe_data.token.card.brand=='Visa' || payment_stripe_data.token.card.brand=='American Express';else no_card " />
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>&nbsp;&nbsp; XXXX XXXX XXXX
                    {{payment_stripe_data.token.card.last4}}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row py-3">
            <div class="col-4">Total Payable Today:</div>
            <div class="col-8">
              <span class="h5 text-bold notranslate">
                $30.00
              </span>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-12 py-2">
          <span>Reason*</span>
          <textarea class="w-100 p-1" [(ngModel)]="changeReason"></textarea>
        </div>
        <div class="col-xs-12 mt-4 px-3">
          <mat-checkbox class="apply-cont checkbox-cls" [(ngModel)]="payment_option.terms" name="terms">
            <small>By clicking on
              this box, you agree with our <a class="text-primary-custom" [routerLink]="['/terms/contracts-terms']"
                target="_blank">Terms &
                Conditions</a>.
              This acceptance will have the same legal effect as a handwritten signature. You agree that all
              information in this contract is true and has been fully disclosed and agreed upon between you and your
              customer prior to making this contract adjustment. You are responsible for all of the changes to this
              contract. In no event will <span class="notranslate">Denefits</span> be liable for any user errors. ANY ATTEMPTED MISUSE OR FRAUD MAY
              RESULT IN SUSPENSION OF ALL Protected PAYMENTS.
            </small>
          </mat-checkbox>

        </div>
      </div>
    </div>

    <!--step 4-->
    <div *ngIf="cancel_contract_step == 4">
      <div *ngIf="payment_result.is_error == 0">
        <div class="text-center">
          <h3 *ngIf="!(payment_option.paymentType && selected_option == 5)">
            Contract Canceled Successfully
          </h3>
          <h4 *ngIf="payment_option.paymentType && selected_option == 5">
            Thank you. We have initiated your transaction
          </h4>
          <img src="assets/img/svg/check.svg" width="90px" alt="">
          <p *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5)">Send the Canceled
            Contract details to your customer:</p>
          <div class="form-cont" *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5)">
            <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10">
              <mat-label>Email</mat-label>
              <input [(ngModel)]="send_email" name="email" #email="ngModel" matInput placeholder="Email Address"
                trim  email>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10">
              <mat-label>Phone Number</mat-label>
              <input [(ngModel)]="send_phone" name="phone" #phone="ngModel" matInput placeholder="Text Message"
                [mask]="mask">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="payment_result.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="">
          <h3 class="m-b-20">Payment Failed!</h3>
          <p>{{payment_result.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button mat-raised-button class="me-3" (click)="gotoNextStepCancelContract()">
              Retry
            </button>
            <button mat-raised-button (click)="cancel_contract_step = 2; payment_result = {};">
              Change Card
            </button>
          </div>
          <br>
          <div class="col-xs-12 col-sm-12 text-center">
            <span>Need Support?</span>
            <br>
            <button mat-raised-button class="mt-4 me-3" (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button style="width:161px !important" mat-raised-button class="me-3" (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button mat-raised-button class="me-3" (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
  <!--Step 5-->
  <div *ngIf="cancel_contract_step == 5">
    <div class="text-center">
      <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
      <p class="h4">Email/Text Sent Successfully</p>
    </div>
  </div>


  <!--all buttons -->
  <div class="d-flex justify-content-between px-4 mx-2" mat-dialog-actions>
    <div *ngIf="cancel_contract_step < 4">
      <button mat-stroked-button
        (click)="cancel_contract_step > 1 ? backCancelContractStep() : dialogRef.close()">{{cancel_contract_step == 1?
        'Cancel' :'Back'}}</button>
      <button mat-raised-button (click)="gotoNextStepCancelContract()" autocomplete="off" [disabled]="(cancel_contract_step == 2 && (!payment_option.paymentType || !selected_option)) ||
      (cancel_contract_step == 3 && (payment_option && !payment_option.terms))">
        <span *ngIf="cancel_contract_step == 1">Proceed to Cancel</span>
        <span *ngIf="cancel_contract_step == 2">Next</span>
        <span *ngIf="cancel_contract_step == 3">Pay Now</span></button>
    </div>
    <div *ngIf="cancel_contract_step == 5">
      <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
    </div>
    <div *ngIf="cancel_contract_step == 4">
      <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
      <button mat-raised-button
        *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5) && payment_result && payment_result.is_error == 0"
        (click)="sendContractPdf('cancel_contract_step')">Send</button>
    </div>
  </div>
</div>
<div class="dialog-header verify-user" *ngIf="data.type == 48">
  <h2 mat-dialog-title class="mat-dialog-title">
    <span class="px-3" *ngIf="edit_contract_step < 4">Edit Contract</span>
    <span class="px-3" *ngIf="edit_contract_step == 4">Financing Details</span>
    <span class="px-3" *ngIf="edit_contract_step == 5">Choose Payment Method</span>
    <span class="px-3" *ngIf="edit_contract_step == 6">Contract Edit Confirmation</span>
    <span class="px-3" *ngIf="edit_contract_step == 9">Update Service Cost Breakdown</span>
    <span class="px-3" *ngIf="edit_contract_step == 7 && editContractResult.is_error == 0">
      {{payment_option.paymentType && selected_option == 5 ? 'Transaction Initiated' : 'Contract Edited Successfully'}}
    </span>
    <span class="px-3" *ngIf="edit_contract_step == 7 && editContractResult.is_error == 1">Payment Failed</span>
    <span class="px-3" *ngIf="edit_contract_step == 8">Email/Text Sent Successfully</span>
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3" style="max-height: unset !important;">
    <!--Step 1-->
    <div *ngIf="edit_contract_step == 1">
      <div class="row">
        <h5 class="col-12 py-2 px-4">Contract ID: {{contractData.contract_code}}</h5>
        <hr class="w-100" />
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6" style="border-right:1px solid #c5c5c5">
          <div class="row ms-2">
            <div class="col-xs-12">
              <label>Current Service Amount:</label>
              <p class="text-bold m-b-10 notranslate">${{contractData.treatment_amount | number : '1.2-2'}}</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 finance-customer">
          <div>
            <label class="ms-3 d-flex align-items-center">
              <span class="pe-2">
                Enter the New Service Amount
              </span>
              <span
                [tooltip]="'Enter the new TOTAL amount for the finance contract. Do not enter the amount the customer has paid or the remaining balance.'"
                [customClass]="'dark-theme-tooltip'" [placement]="'right'">
                <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
              </span>
            </label>
            <div class="payment-custom-tooltip ms-0 col-sm-8">
              <span class="dollar ms-1">$</span>
              <input type="number" class="payment-custom-tooltip ms-0" required placeholder="0" focus-on="true"
                [(ngModel)]="edit_contract_data.treatment_amount" name="treatment_amount"
                min="edit_contract_data.minimum_amount" max="edit_contract_data.maximum_amount">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Step 2-->
    <div *ngIf="edit_contract_step == 2">
      <div class="row">
        <h5 class="col-12 py-2 px-4">Contract ID: {{contractData.contract_code}}</h5>
        <hr class="w-100" />
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6" style="border-right:1px solid #c5c5c5">
          <div class="ms-2">
            <div class="col-xs-12">
              <span class="f-s-12">Current Contract Term:</span>
              <p class="text-bold mb-1">{{contractData.number_of_payments}} Months</p>
              <p class="text-bold mb-1" style="font-size:16px">
                {{contractData.number_of_payments - contractData.remaining_payments}}
                <span class="f-s-12" style="font-weight:initial">Total Paid Payments</span>
              </p>
              <p class="text-bold mb-1" style="font-size:16px">
                {{contractData.remaining_payments}} <span class="f-s-12" style="font-weight:initial">Remaining
                  Payments</span></p>
              <p class="text-bold mb-1" style="font-size:16px">
                {{contractData.missing_payments}} <span class="f-s-12" style="font-weight:initial">Overdue
                  Payments</span>
              </p>
              <span class="d-flex align-items-center">
                <span class="pe-2">
                  <p class="text-bold mb-1" style="font-size:16px">
                    <span class="notranslate">${{contractData.old_recurring_amount_with_fee | number:'1.2-2'}}</span>
                    <span class="f-s-12" style="font-weight:initial">Current Recurring</span>
                  </p>
                </span>
                <span [tooltip]="'This includes Transaction fees.'" [customClass]="'dark-theme-tooltip'"
                  [placement]="'right'">
                  <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 p-r-0 finance-customer">
          <div>
            <label class="ms-3">

            </label>
            <label class="ms-3 d-flex align-items-center">
              <span class="pe-2">
                Enter the New Contract Term
              </span>
              <span
                [tooltip]="'Enter the total amount of months you want the contract to last. DO NOT subtract the number of payments that have already been made.'"
                [customClass]="'dark-theme-tooltip'" [placement]="'right'">
                <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
              </span>
            </label>
            <div class="col-sm-10">
              <div class="input-group pe-2" style="border: 1px solid rgba(0, 0, 0, 0.14);border-radius: 5px;">
                <input type="text" class="form-control" placeholder="0" required [(ngModel)]="edit_contract_data.tenure"
                  maxlength="2" (ngModelChange)="CalculateNewRecurringAmount();" focus-on="true"
                  (keypress)="enterNumberOnly($event)" trim  style="border: none;">
                <span class="custom-suffix py-2">Months</span>
              </div>
            </div>
          </div>
          <div class="text-center mt-3">
            <div class="col-sm-8">
              OR
            </div>
          </div>
          <div class="mt-2">
            <label class="ms-3 d-flex align-items-center">
              <span class="pe-2">
                Expected Recurring
              </span>
              <span [tooltip]="'Enter the recurring amount you want to pay for the contract.'"
                [customClass]="'dark-theme-tooltip'" [placement]="'right'">
                <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
              </span>
            </label>
            <div class="payment-custom-tooltip ms-0 col-sm-8">
              <span class="dollar ms-1">$</span>
              <input type="number" class="payment-custom-tooltip ms-0 notranslate" placeholder="0"
                [(ngModel)]="edit_contract_data.new_recurring_amount" (focus)="edit_contract_data.tenure = null" />
            </div>
            <label *ngIf="edit_contract_data.tenure && edit_contract_data.new_recurring_amount">
              New Term: {{edit_contract_data.tenure}}, New Recurring:
              <span class="notranslate">${{edit_contract_data.new_recurring_amount | number:'1.2-2'}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <!--Step 3-->
    <div *ngIf="edit_contract_step == 3">
      <div class="row m-0 text-center" focus-on="true">
        Are you sure you want to change the contract Service Amount to
        <span class="text-bold mx-1 d-flex align-items-center pe-2">
          <span class="pe-1 notr">
            ${{edit_contract_data.treatment_amount | number:'1.2-2'}}
          </span>
          <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
            [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </span>
        , New Recurring Amount to
        <span class="text-bold ms-1 me-1 notranslate">${{edit_contract_data.new_recurring_amount | number:'1.2-2'}}</span>
        and term to <span class="text-bold ms-1">{{edit_contract_data.tenure}} months?</span>
      </div>
    </div>
    <!--Step 4-->
    <div *ngIf="edit_contract_step == 4">
      <div class="col-xs-12 p-0">
        <div class="col-xs-12" style="padding:0 8px">
          <table class="w-100" focus-on="true">
            <tr>
              <td></td>
              <td class="text-bold text-center old-heading">Old Financing Details:</td>
              <td class="text-bold text-center new-heading">New Financing Details:</td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Service Amount:</td>
              <td class="f-s-18 text-center old-data m-t-5 notranslate">
                ${{edit_contract_data.oldFinanceDetails.treatment_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data notranslate">
                ${{edit_contract_data.newFinanceDetails.treatment_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Down Payment Amount:</td>
              <td class="f-s-18 text-center old-data notranslate">
                ${{edit_contract_data.oldFinanceDetails.downpayment_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data notranslate">
                ${{edit_contract_data.newFinanceDetails.downpayment_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Payment Plan Amount:</td>
              <td class="f-s-18 text-center old-data notranslate">
                ${{edit_contract_data.oldFinanceDetails.financed_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data notranslate">
                ${{edit_contract_data.newFinanceDetails.financed_amount | number:'1.2-2'}}
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Interest Rate:</td>
              <td class="f-s-18 text-center old-data notranslate">
                {{edit_contract_data.oldFinanceDetails.interest_rate | number:'1.2-2'}}%
                <sup>{{!contractData.interest_rate_to_show || (contractData.interest_rate
                  == contractData.interest_rate_to_show) ? (contractData.interest_rate>0?'C':'') : 'F'}}</sup>
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data notranslate">
                {{edit_contract_data.newFinanceDetails.interest_rate_to_show ||
                edit_contract_data.newFinanceDetails.interest_rate | number:'1.2-2'}}%
                <sup>{{!edit_contract_data.newFinanceDetails.interest_rate_to_show ||
                  (edit_contract_data.newFinanceDetails.interest_rate ==
                  edit_contract_data.newFinanceDetails.interest_rate_to_show) ? (edit_contract_data.newFinanceDetails.interest_rate>0?'C':'') :
                  'F'}}</sup>
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Recurring Amount:</td>
              <td class="f-s-18 text-center old-data text-bold">

                <span class="d-flex align-items-center justify-content-center">
                  <span class="me-1 notranslate">${{contractData.old_recurring_amount_with_fee | number:'1.2-2'}}</span>
                  <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
                    [placement]="'right'">
                    <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
                  </span>
                </span>

                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data text-bold">
                <span class="d-flex align-items-center justify-content-center">
                  <span class="me-1 notranslate"> ${{contractData.new_recurring_amount_with_fee | number:'1.2-2'}}</span>
                  <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
                    [placement]="'right'">
                    <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
                  </span>
                </span>
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Total Payments:</td>
              <td class="f-s-18 text-center old-data">
                {{edit_contract_data.oldFinanceDetails.number_of_payments}} months
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data">
                {{edit_contract_data.newFinanceDetails.number_of_payments}} months
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Remaining Payments:</td>
              <td class="f-s-18 text-center old-data text-bold">
                {{edit_contract_data.oldFinanceDetails.remaining_payments}} months
                <hr class="m-2">
              </td>
              <td class="f-s-18 text-center new-data text-bold">
                {{edit_contract_data.newFinanceDetails.remaining_payments}} months
                <hr class="m-2">
              </td>
            </tr>
            <tr>
              <td class="f-s-14 text-bold">Paid Payments:</td>
              <td class="f-s-18 text-center old-data text-bold"
                ng-class="{'left-bottom':contractData.contract_type !== 2}">
                {{edit_contract_data.oldFinanceDetails.number_of_payments -
                edit_contract_data.oldFinanceDetails.remaining_payments}} months
                <hr class="m-2" *ngIf="contractData.contract_type === 2">
              </td>
              <td class="f-s-18 text-center new-data text-bold"
                ng-class="{'right-bottom':contractData.contract_type !== 2}">
                {{edit_contract_data.newFinanceDetails.number_of_payments -
                edit_contract_data.newFinanceDetails.remaining_payments}} months
                <hr class="m-2" *ngIf="contractData.contract_type === 2">
              </td>
            </tr>
            <tr *ngIf="contractData.contract_type === 2">
              <td class="f-s-14 text-bold text-bold">Upfront Payment:</td>
              <td class="f-s-18 text-center old-data text-bold left-bottom">
                <span class="d-flex justify-content-center">
                  <span class="me-1 notranslate">${{contractData.old_upfront_with_fee | number:'1.2-2'}}</span>
                  <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
                    [placement]="'right'">
                    <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
                  </span>
                </span>
              </td>
              <td class="f-s-18 text-center new-data text-bold right-bottom">
                <span class="d-flex align-items-center">
                  <span class="me-1 notranslate">${{contractData.new_upfront_with_fee | number:'1.2-2'}}</span>
                  <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
                    [placement]="'right'">
                    <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
                  </span>
                </span>
              </td>
            </tr>
          </table>
          <p class="mt-3 mb-0">F: Flat Interest, C: Compound Interest</p>
        </div>
      </div>
    </div>
    <!--Step 5-->
    <div *ngIf="edit_contract_step == 5">
      <h5 class="ps-1 ms-1">
        Remaining Upfront Payment:
        <span class="text-bold m-l-5 notranslate">
          ${{edit_contract_data.newFinanceDetails.advance_interest_amount -
          edit_contract_data.oldFinanceDetails.advance_interest_amount | number:'1.2-2'}}
          <span *ngIf="contractData.remaining_upfront_transaction_fee">
            + {{contractData.remaining_upfront_transaction_fee}}
          </span>
        </span>
      </h5>
      <div class="row px-1 pt-4">
        <div class="col-12 font-size-14">
          Who will be responsible for the payment?
        </div>
        <div class="col-12">
          <div class="row g-0 py-3">
            <div class="col-xs-6 col-6 text-start p-0">
              <mat-radio-group name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="1">Customer</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-xs-6 col-6 p-0">
              <mat-radio-group name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="2">Business</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="text-start" style="display:flex;align-items:center;"
              [ngClass]="{'col-4': (contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'), 'col-6' : !(contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified')}">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="1">
                  <b class="card-select-radio-text">Customer’s Existing Card(s)</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="text-start p-0" style="display:flex;align-items:center;"
              [ngClass]="{'col-4': (contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'), 'col-6' : !(contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified')}">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="4">
                  <b class="card-select-radio-text">Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-4 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="5">
                  <b class="card-select-radio-text">Customer Bank Account ({{contractData.plaidAccount[0].last4}})</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-2"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">
          <mat-radio-group>
            <mat-radio-button *ngFor="let card of changePaymentDateCardList; let i=index" style="cursor:pointer"
              class="col-10 justify-content-between align-item-center border rounded p-2 mb-2" [value]="card.source_id"
              (click)="selPaymentCard(card);" [checked]="card.source_id==contractData.source_id">
              <div>
                <span>
                  <img style="width:24px;"
                    [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                    *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express';else no_card " />
                  <ng-template #no_card>
                    <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                  </ng-template>
                </span>
                <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
              </div>
              <div>
                <p *ngIf="card.last_error" class="col-12" style="font-size:12px;"
                  [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">{{card.last_error}}</p>
                <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                  style="font-size:12px;display: flex; align-items: center; flex-direction:row-reverse;">
                  <mat-icon class="check">check_circle_outline</mat-icon>Default
                </p>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-lg-12 col-xs-12 mt-2" *ngIf="payment_option.paymentType == 2">
          <div class="row">
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="3">
                  <b class="card-select-radio-text"> Pay from your <span class="notranslate">Denefits</span> account</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="2">
                  <b class="card-select-radio-text"> Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-block" *ngIf="edit_contract_step == 5 && payment_option.paymentType == 2 && selected_option == 3">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          your Business connected bank account.</li>
      </ul>
    </div>
    <div class="d-block" *ngIf="edit_contract_step == 5 && payment_option.paymentType == 1 && selected_option == 5">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          the customer’s connected bank account for this contract.</li>
      </ul>
    </div>
    <div class="d-block" *ngIf="edit_contract_step == 5 && payment_option.paymentType == 1 && selected_option == 1">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
          the customer’s existing card(s) for this contract.</li>
      </ul>
    </div>
    <div class="card-hidden mt-4" [ngClass]="{'show-card':edit_contract_step == 5 &&((payment_option.paymentType == 2 && selected_option == 2) ||
        (payment_option.paymentType == 1 && selected_option == 4))}" *ngIf="edit_contract_step == 5 &&((payment_option.paymentType == 2 && selected_option == 2) ||
        (payment_option.paymentType == 1 && selected_option == 4))">
      <div class="row me-0 ms-0">
        <div class="col-xs-12 col-md-6 form-cont">
          <div class="w-100">
            <label class="form-label d-block ">Card Holder Name</label>
            <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
              (focus)="getCard()" placeholder="Enter cardholder name" trim  maxlength="100" minlength="2"
              class="form-input" style="min-height: 56px !important;">
            <p *ngIf="cardholder_name.invalid" class="mat-error">Please enter a cardholder name</p>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <label class="form-label d-block ">Card Number</label>
          <div class="stripe-card" id="cancel_contract"></div>
        </div>
      </div>
      <div class="col-12">
        <ul style="list-style: disc;" class="px-3">
          <li style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using
            the business new card.
          </li>
          <li style="font-size: 14px !important; font-weight: 400 !important;"
            *ngIf="payment_option.paymentType == 1 && selected_option == 4">
            Newly added card will not be used as default payment method for future payments for this contract.
          </li>
          <li style="font-size: 14px !important; font-weight: 400 !important;">We will not save the card for this
            contract.</li>
        </ul>
      </div>
    </div>

    <!--Step 6-->
    <div *ngIf="edit_contract_step == 6">
      <div style="background:#f1f1f1;border-radius:4px;padding:20px 0px;">
        <div class="col-12">
          <div class="row m-b-10">
            <div class="col-4 ">Contract ID:</div>
            <div class="col-8 text-start">
              <span class="h5 text-bold">
                {{contractData.contract_code}}
              </span>
            </div>
          </div>
        </div>
        <div class="row m-0 mb-2">
          <div class="col-12 d-flex">
            Your new Recurring Amount will be
            <span class="text-bold mx-2 d-flex align-items-center" style="font-size:18px">
              <span class="me-1 notranslate">${{contractData.new_recurring_amount_with_fee | number:'1.2-2'}}</span>
              <span [tooltip]="'This includes the transaction fees.'" [customClass]="'dark-theme-tooltip'"
                [placement]="'right'">
                <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
              </span>
            </span>

            for the next
            <span class="text-bold" style="font-size:18px">
              {{edit_contract_data.newFinanceDetails.remaining_payments}} months
            </span>
          </div>
        </div>
        <div class="mb-2"
          *ngIf="(edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount)">
          <div class="col-12">
            <div class="row">
              <div class="col-4">
                Payable by:
              </div>
              <div class="col-8">
                <div style="display:flex;flex-direction: column;">
                  <span class="h5 text-bold w-100" style="max-width:235px;">
                    <span *ngIf="payment_option.paymentType == 1">
                      {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                    </span>
                    <span *ngIf="payment_option.paymentType == 2">
                      {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                      contractData.doctor_last_name}}
                    </span>
                  </span>

                  <span *ngIf="selected_option == 1">
                    <span class="card-select-confirm">
                      <span class="small">Customer's {{contractData.source_id == changePaymentDateCard.source_id ?
                        'Default' : ''}} Card</span> <br>
                      <img src="assets/img/svg/pay.svg" class="card-icon" /> XXXX XXXX XXXX
                      {{contractData.default_card_last4}}
                    </span>
                  </span>

                  <span *ngIf="selected_option == 4">
                    <span class="card-select-confirm">
                      <span class="small">Customer's New Card</span> <br>
                      <img style="width:24px;"
                        [src]="payment_stripe_data.token.card.brand?'assets/img/svg/card-type/'+payment_stripe_data.token.card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                        *ngIf="payment_stripe_data.token.card.brand.toLowerCase() == 'mastercard' || payment_stripe_data.token.card.brand=='Discover' || payment_stripe_data.token.card.brand=='JCB' || payment_stripe_data.token.card.brand=='Visa' || payment_stripe_data.token.card.brand=='American Express';else no_card " />
                      <ng-template #no_card>
                        <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                      </ng-template>&nbsp;&nbsp; XXXX XXXX XXXX
                      {{payment_stripe_data.token.card.last4}}
                    </span>
                  </span>

                  <span *ngIf="selected_option == 5">
                    <span class="card-select-confirm">
                      <span class="small">Customer's Bank Account</span> <br>
                      <mat-icon>account_balance</mat-icon>XXXX XXXX {{contractData.plaidAccount[0].last4}}
                    </span>
                  </span>

                  <span *ngIf="selected_option == 3">
                    <span class="card-select-confirm">
                      <span class="small"><span class="notranslate">Denefits</span> account</span>
                    </span>
                  </span>
                  <span *ngIf="selected_option == 2">
                    <span class="card-select-confirm">
                      <span class="small">Your New Card</span> <br>
                      <img style="width:24px;"
                        [src]="payment_stripe_data.token.card.brand?'assets/img/svg/card-type/'+payment_stripe_data.token.card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                        *ngIf="payment_stripe_data.token.card.brand.toLowerCase() == 'mastercard' || payment_stripe_data.token.card.brand=='Discover' || payment_stripe_data.token.card.brand=='JCB' || payment_stripe_data.token.card.brand=='Visa' || payment_stripe_data.token.card.brand=='American Express';else no_card " />
                      <ng-template #no_card>
                        <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                      </ng-template>&nbsp;&nbsp;XXXX XXXX XXXX
                      {{payment_stripe_data.token.card.last4}}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12"
          *ngIf="(edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount)">
          <div class="row m-b-10">
            <div class="col-4 ">Remaining Upfront Payment Payable Today:</div>
            <div class="col-8 text-start">
              <span class="h5 text-bold notranslate">
                ${{contractData.net_remaining_upfront_fee | number:'1.2-2'}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row m-b-10">
            <div class="col-4 ">Next Payment Date:</div>
            <div class="col-8 text-start">
              <span class="h5 text-bold notranslate">
                {{contractData.next_payment_date| date:"MM/dd/yyyy"}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <div class="form-group h-100">
            <label>Reason*</label>
            <textarea type="text" class="form-control note-textarea" [(ngModel)]="edit_contract_data.notes"
              style="min-height: 42px;">
            </textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <small
            *ngIf="(edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount) && !((payment_option.paymentType == 1 && selected_option == 5) || (payment_option.paymentType == 2 && selected_option == 3))">
            <b>Note:</b> You will be charged a dollar or 1% (whichever is
            higher) as extra transaction fee
            if you use a non-US debit/credit card.<br />
          </small>
          <div class="checkbox">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" value="" [(ngModel)]="edit_contract_data.terms" id="customCheck2"
                class="custom-control-input" focus-on="true" tabindex="1">
              <label class="custom-control-label" for="customCheck2">
                <small>By clicking on this box, you agree with our <a class="text-primary-custom notranslate" target="_blank"
                    ui-sref="contractTerms">Terms & Conditions</a>.
                  This acceptance will have the same legal effect as a handwritten signature. You
                  agree that all information in this contract is true and has been fully disclosed and
                  agreed upon between you and your customer prior to making this contract adjustment.
                  You are responsible for all of the changes to this contract. In no event will
                  <span class="notranslate">Denefits</span> be liable for any user errors. ANY ATTEMPTED MISUSE OR FRAUD MAY RESULT IN
                  SUSPENSION OF ALL Protected PAYMENTS.
                </small>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Step 7-->
    <div *ngIf="edit_contract_step == 7">
      <div *ngIf="editContractResult.is_error == 0">
        <div class="text-center">
          <h3 *ngIf="!(payment_option.paymentType && selected_option == 5)">
            Contract Edited Successfully
          </h3>
          <h4 *ngIf="payment_option.paymentType && selected_option == 5">
            Thank you. We have initiated your transaction
          </h4>
          <img src="assets/img/svg/check.svg" width="90px" alt="">
          <p *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5)">Send the
            Edited
            Contract details to your customer:</p>
          <div class="form-cont" *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5)">
            <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10">
              <mat-label>Email</mat-label>
              <input [(ngModel)]="send_email" name="email" #email="ngModel" matInput placeholder="Email Address"
                trim  email>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10">
              <mat-label>Phone Number</mat-label>
              <input [(ngModel)]="send_phone" name="phone" #phone="ngModel" matInput placeholder="Text Message"
                [mask]="mask">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="editContractResult.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="">
          <h3 class="m-b-20">Payment Failed</h3>
          <p>{{editContractResult.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button class="btn btn-primary m-r-10" (click)="gotoNextStepEditContract()" focus-on="true">
              Retry
            </button>
            <button class="btn btn-primary"
              *ngIf="edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount"
              (click)="edit_contract_step = 5; editContractResult = {is_error: 0, override_text: null};">
              Change Card
            </button>
          </div>

          <div class="col-xs-12 text-center  m-t-20 m-b-10">
            <p>Need Help?</p>
          </div>

          <div class="col-xs-12 col-sm-12 text-center">
            <span>Need Support?</span>
            <br>
            <button mat-raised-button class="mt-4 me-3" (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button style="width:161px !important" mat-raised-button class="me-3" (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button mat-raised-button class="me-3" (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Step 8-->
    <div *ngIf="edit_contract_step == 8">
      <div class="text-center">
        <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
        <p class="h4">Email/Text Sent Successfully</p>
      </div>
    </div>
    <!--Step 9-->
    <div *ngIf="edit_contract_step == 9">
      <h4>New Service Cost: <strong class="notranslate">${{ edit_contract_data.newFinanceDetails.treatment_amount |
          number:'1.2-2'}}</strong></h4>
      <div class="p-3 service-list">
        <div *ngFor="let d of serviceBreakDown; let i = index;" class="d-flex row mb-3">
          <div class="col-md-4 serv-name p-0 me-3">
            <input placeholder="Service {{i+1}}" id="breakDownText{{i}}" tabindex="{{i+1}}1" [(ngModel)]="d.service"
              [ngModelOptions]="{standalone: true}" (keyup)="services()">
          </div>
          <div class="border-box col-md-4 p-0">
            <span class="dollar">$</span>
            <input type="number" placeholder="Price" id="breakDownVal{{i}}" tabindex="{{i+1}}2" [disabled]="!d.service"
              [(ngModel)]="d.price" [ngModelOptions]="{standalone: true}" (keyup)="services()" class="notranslate">
          </div>
          <div class="action-item d-flex justify-content-start align-items-center p-3">
            <mat-icon *ngIf="i+1 == serviceBreakDown.length && serviceBreakDown.length < 25" (click)="addBreakdown()"
              (keyup.enter)="addBreakdown()" tabindex="{{i+1}}3" style="cursor: pointer">add_circle</mat-icon>
            <mat-icon class="del-icn" *ngIf="serviceBreakDown.length > 1" (click)="deleteBreakdown(i)"
              (keyup.enter)="deleteBreakdown(i)" tabindex="{{i+1}}4" style="cursor: pointer">delete</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <!--Step 10 End-->
  </div>
  <div class="d-flex" mat-dialog-actions *ngIf="edit_contract_step < 7 || edit_contract_step == 9">
    <button mat-stroked-button
      (click)="(edit_contract_step > 1 && edit_contract_step != 6)  ? (edit_contract_step = edit_contract_step - 1) : dialogRef.close()"
      *ngIf="edit_contract_step != 6 && edit_contract_step != 9">
      {{edit_contract_step == 1? 'Close' : 'Back'}}
    </button>
    <button mat-stroked-button
      (click)="(edit_contract_step == 6  && (edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount)) ? (edit_contract_step = edit_contract_step - 1) : (edit_contract_step = edit_contract_step - 2)"
      *ngIf="edit_contract_step == 6">
      Back
    </button>
    <button mat-raised-button [ngClass]="data.actionClass" (click)="edit_contract_step = 7"
      *ngIf="edit_contract_step == 9">Skip</button>
    <button mat-raised-button [ngClass]="data.actionClass" (click)="gotoNextStepEditContract()">
      {{edit_contract_step == 3 ? 'Confirm' :
      edit_contract_step == 9 ? 'Save' :
      edit_contract_step < 6 ? edit_contract_step==2 && !edit_contract_data.tenure &&
        edit_contract_data.new_recurring_amount ? 'Calculate' :'Next' :
        edit_contract_data.newFinanceDetails.advance_interest_amount>
        edit_contract_data.oldFinanceDetails.advance_interest_amount ? 'Pay Now' :
        'Save'}}
    </button>
  </div>
  <div class="d-flex" mat-dialog-actions *ngIf="edit_contract_step == 7">
    <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
    <button mat-raised-button
      *ngIf="contractData.dnd == 0 && editContractResult && editContractResult.is_error == 0 && !(payment_option.paymentType && selected_option == 5)"
      (click)="sendContractPdf('edit_contract_step')">Send</button>
  </div>
  <div class="d-flex" mat-dialog-actions *ngIf="edit_contract_step == 8">
    <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 8">
  <h2 mat-dialog-title> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <h4><strong>{{data.desc}}</strong></h4>
    <br />
    <div>
      <p style="word-break: break-all;" class="small"> Note: $1 will be deducted and reversed to check the Card
        Authorization.
      </p>
    </div>
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button [ngClass]="data.actionClass" (click)="confirmAction()">{{data.action}}</button>
  </div>
</div>
<div class="dialog-header width_650" *ngIf="data.type == 9">
  <h2 mat-dialog-title class='py-4 px-3 d-flex justify-content-between align-items-center'>
    <span class="px-3" *ngIf="edit_recurring_step == 1">Change Payment Date</span>
    <span class="px-3" *ngIf="edit_recurring_step == 2">Choose Payment Method </span>
    <span class="px-3" *ngIf="edit_recurring_step == 3">Confirmation of Change Payment Date </span>
    <span class="px-3" *ngIf="edit_recurring_step == 4 && payment_result.is_error == 0">
      {{selected_option !== 5 ?
      'Payment Date Changed Successfully'
      :
       'Transaction Initiated'}}</span>
    <span class="px-3" *ngIf="edit_recurring_step == 4 && payment_result.is_error == 1">Payment Failed </span>
    <span class="px-3" *ngIf="edit_recurring_step == 5">Email/Text Sent Successfully </span>
    <span class="me-2">
      <mat-icon (click)="(edit_recurring_step == 4 || edit_recurring_step == 5) ? confirmAction() : dialogRef.close()"
        class="close text-dark" style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont">
    <div *ngIf="edit_recurring_step == 1">
      <div class="d-flex align-items-center py-4 px-2">
        <h5 class="ps-0 pe-3">Contract ID: {{contractData.contract_code}}</h5>
        <span class="text-center flex-grow-1">
          <span class="px-4 py-2" style="
            background-color: #EBF6FF;
            color: #1C76BA;
            font-weight: 700;
          ">Next Payment Due:
            <strong class="notranslate">{{contractData.next_payment_date | date:"MM/dd/yyyy": '+0000'}}</strong>
          </span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 px-0">
        <hr *ngIf="edit_recurring_step == 1" />
      </div>
    </div>

    <div *ngIf="edit_recurring_step == 1">
      <div class="text-start px-0">
        <h5 class="py-3 px-2">When would you like the next payment to be made? </h5>
        <div class="text-start ">
          <mat-form-field appearance="outline" class="col-8 px-2 date-picker rounded-0 mat-short-height notranslate whiteBg">
            <input matInput [matDatepicker]="picker" placeholder="Choose a date" (click)="picker.open()" readonly
              [(ngModel)]="edit_recurring_data.payment_date" [max]="edit_recurring_data.maxDate"
              [min]="edit_recurring_data.minDate" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false" startView="month"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <!-- step 2-->
    <div *ngIf="edit_recurring_step == 2">
      <div class="row" style="margin-bottom: 20px;">
        <div class="col-sm-6 col-xs-12">
          <h5>Total Due Today:
            <strong class="notranslate">
              ${{((25 * contractData.missing_payments)+ edit_recurring_data.edit_recurring_amount) |
              number : '1.2-2'}}
            </strong>
          </h5>
        </div>
        <div class="col-sm-6 col-xs-12">
          <ng-template #paymentCharge>
            <div>
              <p>The <span class="notranslate">Denefits</span> system automatically calculates the Payment Change Fee depending on the
                number of days and
                the recurring payment amount. For more information.</p>
              <a href="javascript:void(0);" (click)="t1.close();paymentChargeFee()" class="text-decoration-none">For
                more information <svg width="22" height="16" viewBox="0 0 22 16" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 8L9.5 10V6L13 8Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M1 8.70739V7.29239C1 4.39739 1 2.94939 1.905 2.01839C2.811 1.08639 4.237 1.04639 7.088 0.965391C8.438 0.927391 9.818 0.900391 11 0.900391C12.181 0.900391 13.561 0.927391 14.912 0.965391C17.763 1.04639 19.189 1.08639 20.094 2.01839C21 2.94939 21 4.39839 21 7.29239V8.70739C21 11.6034 21 13.0504 20.095 13.9824C19.189 14.9134 17.764 14.9544 14.912 15.0344C13.562 15.0734 12.182 15.1004 11 15.1004C9.819 15.1004 8.439 15.0734 7.088 15.0344C4.237 14.9544 2.811 14.9144 1.905 13.9824C1 13.0504 1 11.6024 1 8.70839V8.70739Z"
                    stroke="white" stroke-width="1.5" />
                </svg>
              </a>
            </div>
          </ng-template>
          <span class="template-icon">Payment Change Fee: <i [ngbTooltip]="paymentCharge"
              tooltipClass="modal-payment-custom-tooltip" (mouseover)="t1.open()" triggers="manual"
              [autoClose]="'outside'" placement="right" container="body" #t1="ngbTooltip"
              style="line-height: 0; position: relative; top: 3px;">
              <mat-icon aria-hidden="false" aria-label="info outline">info_outline</mat-icon>
            </i> <strong class="notranslate">{{edit_recurring_data.edit_recurring_amount?'$'+(edit_recurring_data.edit_recurring_amount
              |
              number : '1.2-2'):'$0.00'}}</strong>
          </span>
          <br *ngIf="contractData.missing_payments>0">
          <span *ngIf="contractData.missing_payments>0">Late fee:
            <strong>$25 X {{contractData.missing_payments}}months </strong>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 font-size-14 d-flex align-items-center">
          <span class="me-1"> Who will be responsible for the payment?</span>
          <span [tooltip]="'Usually, the party requesting the payment date change will be responsible for the payment.'"
            [customClass]="'dark-theme-tooltip'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 ">
          <div class="row">
            <div class="col-xs-6 col-6 text-center p-0 ps-3">
              <mat-radio-group class="pull-left" name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="1">Customer</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-xs-6 col-6 p-0">
              <mat-radio-group name="a" [(ngModel)]="payment_option.paymentType">
                <mat-radio-button [value]="2">Business</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="col-md-4 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="1">
                  <b class="card-select-radio-text">Customer’s existing card(s)
                    <!-- <img src="/assets/img/svg/pay-white.svg" class="card-icon" *ngIf="selected_option == 1" /> -->
                    <!-- <img src="/assets/img/svg/pay.svg" class="card-icon" /> {{contractData.default_card_last4}} -->
                  </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-4 text-start ps-3" style="display:flex;align-items:center;">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="4">
                  <b class="card-select-radio-text">Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-md-4 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <mat-radio-group name="b" [(ngModel)]="selected_option">
                <mat-radio-button [value]="5">
                  <b class="card-select-radio-text">Customer Bank Account ({{contractData.plaidAccount[0].last4}})</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>

        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-1"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">
          <mat-radio-group>
            <mat-radio-button *ngFor="let card of changePaymentDateCardList; let i=index" style="cursor:pointer"
              class="col-10 justify-content-between align-item-center border rounded p-2 mb-2" [value]="card.source_id"
              (click)="selPaymentCard(card);" [checked]="card.source_id==contractData.source_id">
              <div>
                <span>
                  <img style="width:24px;"
                    [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                    *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express';else no_card " />
                  <ng-template #no_card>
                    <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                  </ng-template>
                </span>
                <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
              </div>
              <div>
                <p *ngIf="card.last_error" class="col-12" style="font-size:12px;"
                  [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">
                  {{card.last_error}}</p>
                <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                  style="font-size:12px;display: flex; align-items: center; flex-direction:row-reverse;">
                  <mat-icon class="check">check_circle_outline</mat-icon>Default
                </p>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>



        <div class="col-lg-12 col-xs-12 mt-4" *ngIf="payment_option.paymentType == 2">
          <div class="row">
            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="3">
                  <b class="card-select-radio-text"> Pay from your <span class="notranslate">Denefits</span> account</b>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-6 text-start" style="display:flex;align-items:center;">
              <mat-radio-group name="business" [(ngModel)]="selected_option">
                <mat-radio-button [value]="2">
                  <b class="card-select-radio-text"> Pay with a new card </b>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-hidden mt-4" [ngClass]="{'show-card':edit_recurring_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
      (payment_option.paymentType == 1 && selected_option == 4))}" *ngIf="edit_recurring_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
      (payment_option.paymentType == 1 && selected_option == 4))">
      <div class="row me-0 ms-0">
        <div class="col-xs-12 col-md-6 form-cont">
          <div class="w-100 ">
            <label class="form-label d-block ">Card Holder Name</label>
            <input [(ngModel)]="payment_option.cardName" (focus)="getCard_1()" name="cardholder_name"
              #cardholder_name="ngModel" matInput placeholder="Enter cardholder name" trim  maxlength="100"
              minlength="2" class="form-input" style="min-height: 56px !important;">
            <p *ngIf="cardholder_name.invalid" class="mat-error">Please enter a cardholder name</p>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <label class="form-label d-block ">Card details</label>
          <div class="stripe-card" id="edit_recurring"></div>
        </div>
      </div>
    </div>
    <div class="d-block  py-2" *ngIf=" edit_recurring_step == 2 && payment_option.paymentType == 2">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 3" style="font-size: 14px !important; font-weight: 400 !important;">Use
          this option, if you want to pay using your Business connected bank account.</li>
        <li *ngIf="selected_option == 2" style="font-size: 14px !important; font-weight: 400 !important;">Use
          this option, if you want to pay using the business new card.</li>
        <li *ngIf="selected_option == 2" style="font-size: 14px !important; font-weight: 400 !important;">We
          will not save the card for this contract.
        </li>
      </ul>
    </div>
    <!-- <div class="d-block  py-2" *ngIf=" selected_option == 1 && payment_option.paymentType == 1">

        <ul style="list-style: disc;" class="px-3">
          <li *ngIf="selected_option == 1" style="font-size: 14px !important; font-weight: 400 !important;">Use
              this option, if you want to pay using the customer’s existing card(s) for this contract.</li>
        </ul>
        </div> -->
    <div class="d-block  py-2"
      *ngIf=" edit_recurring_step == 2 && selected_option == 5 && payment_option.paymentType == 1">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 5  && payment_option.paymentType == 1"
          style="font-size: 14px !important; font-weight: 400 !important;">Use this option, if you want to pay using the
          customer’s connected bank account for this contract.</li>
      </ul>
    </div>
    <div class="d-block  py-2" *ngIf=" edit_recurring_step == 2 && payment_option.paymentType == 1">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 1" style="font-size: 14px !important; font-weight: 400 !important;">Use
          this option, if you want to pay using the customer’s existing card(s) for this contract.</li>
        <li *ngIf="selected_option == 4" style="font-size: 14px !important; font-weight: 400 !important;">Use
          this option, if you want to pay using the customer’s new card.</li>
        <li *ngIf="selected_option == 4" style="font-size: 14px !important; font-weight: 400 !important;"> Newly
          added card will not be used as default payment method for future payments for this contract.</li>
        <li *ngIf="selected_option == 4" style="font-size: 14px !important; font-weight: 400 !important;"> We
          will not save the card for this contract.</li>
      </ul>
    </div>
    <!-- step 3-->
    <div *ngIf="edit_recurring_step == 3">
      <div class="row m-0 bg-muted p-2">
        <div class="col-12">
          <div class="row m-b-10">
            <div class="col-xs-12 col-sm-3 ">Contract ID:</div>
            <div class="col-xs-12 col-sm-9 text-sm-right text-md-right">
              <span class="h5 text-bold text-md-right">
                {{contractData.contract_code}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row m-b-10 ">
            <div class="col-xs-12 col-sm-5">Payment Dates to Change: </div>
            <div class="ccol-xs-12 col-sm-7 px-3 text-md-right tet-sm-right">
              <span class="me-1" style="font-size:11px;">from</span>
              <span class="h5 text-bold notranslate">{{contractData.next_payment_date | date:"MM/dd/yyyy"}}</span>
              <br /><span class="me-1 ms-1" style="font-size:11px;">to</span>
              <span class="h5 text-bold notranslate">{{edit_recurring_data.payment_date | date:"MM/dd/yyyy"}}</span>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="edit_recurring_data.total_rec_amount > 0">
          <div class="row">
            <div class="col-xs-12 col-sm-3 mt-2">
              Payable by:
            </div>
            <div class="col-xs-12 col-sm-9 mt-2 pe-0">
              <div class="row justify-content-end px-4">
                <span class="h5 text-bold col-12 text-end">
                  <span *ngIf="payment_option.paymentType == 1">
                    <span *ngIf="selected_option == 1">
                      {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                    </span>
                    <span *ngIf="selected_option == 4">
                      {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                    </span>
                    <span *ngIf="selected_option == 5">
                      {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                    </span>
                  </span>
                  <span *ngIf="payment_option.paymentType == 2">
                    <span *ngIf="selected_option == 3">
                      {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                      contractData.doctor_last_name}}
                    </span>
                    <span *ngIf="selected_option == 2 || selected_option == 5">
                      {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                      contractData.doctor_last_name}}
                    </span>
                  </span>
                </span>

                <span class="col-12 text-end" *ngIf="selected_option == 1">
                  <span class="card-select-confirm py-2 px-2 w-75 text-start">
                    <!-- <span class="small">Customer's {{contractData.source_id == changePaymentDateCard.source_id ?
                    'Default' : ''}} Card</span> <br> -->
                    <img src="assets/img/svg/pay.svg" style="width:45px !important" class="card-icon px-2" /> XXXX XXXX
                    XXXX {{changePaymentDateCard.last4 ? changePaymentDateCard.last4 :
                    contractData.default_card_last4}}
                  </span>

                </span>
                <span class="ms-3" *ngIf="selected_option == 5">
                  <span class="card-select-confirm">
                    <span class="small">Customer's Bank Account</span> <br>
                    <img src="assets/img/svg/pay.svg" class="card-icon" />
                    {{contractData.plaidAccount[0].last4}}
                  </span>
                </span>
                <span class="ms-3" *ngIf="selected_option == 4">
                  <span class="card-select-confirm">
                    <span class="small">Customer's New Card</span> <br>
                    <img src="assets/img/svg/pay.svg" class="card-icon" />
                    {{payment_stripe_data.token.card.last4}}
                  </span>
                </span>

                <span class="mt-3 ms-3 " *ngIf="selected_option == 3">
                  <span class="card-select-confirm">
                    <span class="small"><span class="notranslate">Denefits</span> account</span>
                  </span>
                </span>
                <span class="ms-3" *ngIf="selected_option == 2">
                  <span class="card-select-confirm">
                    <span class="small">Your New Card</span> <br>
                    <img src="assets/img/svg/pay.svg" class="card-icon" />
                    {{payment_stripe_data.token.card.last4}}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2" *ngIf="edit_recurring_data.total_rec_amount > 0">
          <div class="row">
            <div class="col-6">Total Payable Today:</div>
            <div class="col-6 text-end">
              <span class="h5 text-bold text-righ notranslatet">
                ${{((25 * contractData.missing_payments)+ edit_recurring_data.edit_recurring_amount) |
                number :
                '1.2-2'}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <span>Reason*</span>
          <textarea class="w-100 p-1" [(ngModel)]="changeReason"></textarea>
        </div>
        <div class="col-xs-12 mt-4">
          <mat-checkbox class="apply-cont checkbox-cls" [(ngModel)]="payment_option.terms" name="terms">
            <small>By
              clicking on
              this box, you agree with our <a class="text-primary-custom" [routerLink]="['/terms/contracts-terms']"
                target="_blank">Terms &
                Conditions</a>.
              This acceptance will have the same legal effect as a handwritten signature. You agree that
              all
              information in this contract is true and has been fully disclosed and agreed upon between
              you and your
              customer prior to making this contract adjustment. You are responsible for all of the
              changes to this
              contract. In no event will <span class="notranslate">Denefits</span> be liable for any user errors. ANY ATTEMPTED MISUSE OR
              FRAUD MAY
              RESULT IN SUSPENSION OF ALL Protected PAYMENTS.
            </small>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <!--step 4-->
    <div *ngIf="edit_recurring_step == 4">
      <div *ngIf="payment_result.is_error == 0">
        <div class="text-center">
          <h3>
            {{selected_option !== 5 ?
            'Payment Date Changed Successfully' :
            "Thank you. We have initiated your transaction"}}</h3>
          <img src="assets/img/svg/check.svg" width="90px" alt="">
          <span *ngIf="selected_option !== 5">
            <p *ngIf="contractData.dnd == 0">Send the updated contract to your customer:</p>
          </span>
          <span *ngIf="selected_option !== 5">
            <div class="form-cont" *ngIf="contractData.dnd == 0">
              <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10"
                *ngIf="selected_option !== 5">
                <mat-label>Email</mat-label>
                <input [(ngModel)]="send_email" name="email" #email="ngModel" matInput placeholder="Email Address"
                  trim  email>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10"
                *ngIf="selected_option !== 5">
                <mat-label>Phone Number</mat-label>
                <input [(ngModel)]="send_phone" name="phone" #phone="ngModel" matInput placeholder="Text Message"
                  [mask]="mask" *ngIf="selected_option !== 5">
              </mat-form-field>
            </div>
          </span>
        </div>
      </div>
      <div *ngIf="payment_result.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="">
          <h3 class="m-b-20">Payment Failed!</h3>
          <p>{{payment_result.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button mat-raised-button class="me-3 " (click)="nextRecurringStep()">
              Retry
            </button>
            <button mat-raised-button (click)="edit_recurring_step = 2; payment_result = {};">
              Change Card
            </button>
          </div>
          <br>
          <div class="col-xs-12 col-sm-12 text-center">
            <span>Need Support?</span>
            <br>
            <button mat-raised-button class="mt-4 me-3" (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button style="width:161px !important" mat-raised-button class="me-3 " (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button mat-raised-button class="me-3 " (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
    <!--Step 5-->
    <div *ngIf="edit_recurring_step == 5">
      <div class="text-center">
        <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
        <p class="h4">Email/Text Sent Successfully</p>
      </div>
    </div>
    <!--all buttons -->
    <div class="d-flex justify-content-between" mat-dialog-actions>
      <div *ngIf="edit_recurring_step < 4">
        <button mat-stroked-button
          (click)="edit_recurring_step > 1 ? backRecurringDateStep() : dialogRef.close()">{{edit_recurring_step
          == 1?
          'Cancel' :'Back'}}</button>
        <button mat-stroked-button *ngIf="edit_recurring_step > 1" (click)="dialogRef.close()">Cancel</button>
        <button mat-raised-button (click)="nextRecurringStep()"
          [disabled]="(edit_recurring_step == 2 && (!payment_option.paymentType || (!selected_option && !changePaymentDateCard))) || (edit_recurring_step == 3 && (payment_option && !payment_option.terms))">
          <span>{{(edit_recurring_step < 3 ? 'Next' : (edit_recurring_data.total_rec_amount> 0 ? 'Pay Now' : '
              Next'))}}</span>
        </button>
      </div>
      <div *ngIf="edit_recurring_step == 5">
        <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
      </div>
      <div *ngIf="edit_recurring_step == 4">
        <button mat-stroked-button mat-dialog-close (click)="confirmAction()">Close </button>
        <button mat-raised-button
          *ngIf="contractData.dnd == 0 && payment_result && payment_result.is_error == 0 && selected_option !== 5"
          (click)="sendContractPdf('edit_recurring_step')">Send</button>
      </div>
    </div>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 10">
  <h2 mat-dialog-title>
    Missing Payments
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0">
    <div>
      <h4 class="ps-3">Contract ID: {{contractData.contract_code}}</h4>
      <div class="col-md-12 details">
        <div class="card card-body border">
          <div class="row">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Payment Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let payment of contractData.missingPayments; let i = index">
                  <td>{{i + 1}}</td>
                  <td class="notranslate">{{payment.payment_date | date:'MM/dd/yyyy'}}</td>
                  <td>{{payment.claim_status}}</td>
                  <td>
                    <button mat-raised-button (click)="goToClaim(payment)" [disabled]="payment.can_be_claimed == 0"
                      title="{{payment.reason}}">Claim</button>
                    <!-- [disabled]="payment.can_be_claimed == 0" -->
                    <!-- <i *ngIf="payment.can_be_claimed == 0" uib-popover="{{payment.reason}}" popover-trigger="'mouseenter'"
                      (click)="payment.can_be_claimed == 1 && goToClaim(payment.missing_payment_id)"
                      class="fa fa-question-circle"></i> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 11">
  <h2 mat-dialog-title>
    Claim Confirmation
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <h4 style="font-weight: 500;">
      Are you sure, you want to Claim this payment?
    </h4>
    <br />
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button (click)="confirmAction()">Claim</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 13">
  <h2 style="margin-left: 0px !important;" mat-dialog-title class="d-flex align-items-center justify-content-between py-4 px-4 mb-0">
    Contribution Link
    <mat-icon (click)="dialogRef.close()" class="close pull-right text-dark"
      style="position: relative !important; transform: none;">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <p class="form-label">The following link can be shared with Customer's Friends to contribute to total remaining
      amount for their
      contract
      <span class="text-bold">{{contractData.contract_code}}</span>
    </p>
    <label class="form-label" style="word-break: break-all;padding: 10px 0 0;">{{contractData.card_link}}</label>
  </div>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-12 mb-3">

        <div class="wrap m-h-56 h-100 h-56 d-block">
          <div class="select w-100 h-100 h-56">
            <select required [(ngModel)]="languageSelected" [ngModelOptions]="{standalone: true}"
              class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
              <option class="w-100 py-3 px-2" *ngFor="let d of languages" [value]="d.lan_code">
                {{d.lan_name}}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
            <label class="select-label f-c-p-3">Select Language</label>
          </div>
        </div>
      </div>
      <div class="col-sm-12 example-chip-list" appearance="outline">
          <label for="" class="w-100 mb-2" style="font-Style:16px; font-weight: 600;">Enter Email (Press Enter to
            add)</label>
        <mat-chip-grid #chipList>
          <input class="w-100 m-0 form-input text-dark" style="padding: .8rem !important;" #emailInput email [formControl]="emailCtrl" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
            placeholder="Email Address">
        </mat-chip-grid>
      </div>
      <div class="col-12 py-2">
        <label for="" style="font-weight: 700;color: #0E2535;">Selected Emails</label>
        <p *ngIf="!emails || emails.length == 0" style="color: #C3C8CD; font-size:14px">No email added yet</p>
        <mat-chip-listbox  #chipList aria-label="email selection">
          <mat-chip-option *ngFor="let email of emails" selectable removable (removed)="remove(email)">
            {{ email }}
            <button matChipRemove aria-label="Remove email">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-option>
        </mat-chip-listbox>

      </div>
    </div>
  </div>

  <div class="d-flex justify-content-start px-4" mat-dialog-actions>
    <!-- <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button> -->
    <span class="pe-3">
      <button class="py-2 px-4 w-auto mat-stroked-button" (click)="copyPaymentLink(contractData.card_link)">Copy Link</button>
    </span>
    <span>
      <button class="py-2 px-4 w-auto" mat-raised-button (click)="sendPaymentEmail()">Send Link</button>
    </span>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 14">
  <h2 style="margin-left: 7px !important;" mat-dialog-title class="px-3 py-4 mb-0"> App Download Links
    <mat-icon (click)="dialogRef.close()" class="close pull-right text-dark"
      style="position: relative !important; transform: none;">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <p>
      Are you sure you want to send
      <strong>App Links</strong> to the customer?
    </p>
    <div class="row">
      <mat-form-field appearance="outline" class="w-100 mat-short-height col-sm-10">
        <mat-label>Email</mat-label>
        <input [(ngModel)]="send_email" name="email" matInput placeholder="Email Address" [formControl]="emailCtrl">
      </mat-form-field>
    </div>
  </div>

  <div class="d-flex justify-content-between px-4" mat-dialog-actions>
    <button class="py-2 px-4" mat-raised-button (click)="sendAppLink()">Send Link</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 15">
  <div class="d-flex justify-content-between align-items-center px-4 py-2 border-bottom ">
    <p style="color: #0E2535 !important;font-size:24px;font-weight: 800 !important; margin: 0px;padding: 0px;">Add Card
    </p>
    <div class="closee m-0" (click)="dialogRef.close()">
      <img src="assets\img\svg\close-circle.svg" alt="">
    </div>
  </div>
  <div mat-dialog-content class="card-dialog-box">
    <form [formGroup]="addCardForm">
      <div class="row me-0 ms-0" *ngIf="!showAddressField">
        <div class="col-md-12 form-cont mb-2">
          <div
            [ngClass]="[addCardForm.controls.cardholder_name.touched && addCardForm.controls.cardholder_name.invalid ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-3 pt-3" formControlName="cardholder_name" name="cardholder_name" required
              trim  maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name mb-0">
              <span class="content-name f-c-p-3">
                Card Holder Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="iscardSubmitted && addCardForm.controls.cardholder_name.invalid">
            Please enter card holder name.
          </p>
        </div>
      </div>
      <div class="row me-0 ms-0" style="margin-top: 10px;">
        <!-- card input box -->
        <div class="col-md-12">
          <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
        </div>
      </div>

      <div class="row my-3 me-0 ms-0">
        <div class="col-md-12">
          <!-- <div class="col-md-12 mt-2"> -->
          <input type="checkbox" class="pointer" name="billing_check" id="billing_check" formControlName="checked"
            (change)="getAddressFormV2()">
          <label for="billing_check">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Choose {{data.send_data.type}} address as billing address
            </span>
          </label>
        </div>
      </div>


      <div class="row my-3 me-0 ms-0" [ngClass]="{'d-none': !showAddressField}">
        <div class="col-md-12">
          <div id="address-element"></div>
        </div>
      </div>


      <div *ngIf="!showAddressField" class="same-billing row me-0 ms-0">
        <div class="col-6" style="padding: 15px">
          <div style="border: 1px solid rgba(112,112,112,0.5); padding: 15px">
            <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
            <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
            <p class="m-0">{{data.send_data.state}}
              {{data.send_data.country_code
              ?
              ', '+data.send_data.country_code:''}}
            </p>
          </div>
        </div>
        <div class="col-6" style="padding: 15px">
          <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
            <p class="text-center" style="align-self: center;margin:0">
              <a (click)="getAddressForm()" href="javascript:void(0)" style="color:#3791e5">ADD NEW BILLING ADDRESS</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 pe-4" style="padding-left: 12px;">
        <div class="mt-3">

          <input type="checkbox" class="pointer" name="saveDefault" id="saveDefault" formControlName="saveDefault">
          <label for="saveDefault">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Save as Default
            </span>
          </label>
        </div>
      </div>

      <small class="col-lg-12 pe-4" *ngIf="false">
        <b class="pay-label" style="font-weight: 400 !important;">Note:</b>
        <ul class="ms-3 pay-label" style="font-weight: 400 !important;">
          <li>You will be charged a dollar or 1% (whichever is higher) as extra transaction fee if you use a non-US
            debit/credit card.</li>
          <!-- <li>$1 will be deducted and reversed to check the Card Authorization.</li> -->
        </ul>
        <!-- <p *ngIf="addCardForm.invalid && addCardForm.submitted" class="text-danger-custom text-center"
            style="padding: 10px 15px 0px;">*Please fill the required fields
          </p> -->
        <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
          {{new_address.cardError}}</p> -->
      </small>
      <div class="d-flex justify-content-between" mat-dialog-actions>
        <!-- <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button> -->
        <button button-primary-auth type="submit" (click)="addCardSubmitV2()">Add</button>
      </div>
    </form>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 16">
  <h2 mat-dialog-title>Change Environment
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close
    </mat-icon>
  </h2>
  <div mat-dialog-content>
    <mat-radio-group name="environment" [(ngModel)]="environment">
      <mat-radio-button value="t1">
        <b class="card-select-radio-text"> T1 (DEMO)</b>
      </mat-radio-button>
      <mat-radio-button value="t2" class="ms-4">
        <b class="card-select-radio-text"> T2</b>
      </mat-radio-button>
      <mat-radio-button value="t3" class="ms-4">
        <b class="card-select-radio-text"> T3</b>
      </mat-radio-button>
      <mat-radio-button value="t4" class="ms-4" disabled>
        <b class="card-select-radio-text"> T4</b>
      </mat-radio-button>
      <mat-radio-button value="t5" class="ms-4">
        <b class="card-select-radio-text"> T5</b>
      </mat-radio-button>
      <mat-radio-button value="t6" class="ms-4" disabled>
        <b class="card-select-radio-text"> T6</b>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button (click)="changeEnvironment()">Ok</button>
  </div>
</div>

<!-- Custom Plan Added -->
<div class="dialog-header" *ngIf="data.type == 17">
  <h2 mat-dialog-title style="display: flex;align-items: center;justify-content: space-between;">
    <span style="color: #04182A;font-size: 28px;font-weight: 700;width: 323px;display: inline-block;" class="f-Inter">{{data.title}}</span>
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div class="container text-start form-cont p-0 new-custom-plan">
    <div mat-dialog-content>
      <div class="d-flex justify-content-between align-item-center flex-wrap px-2">
        <div class="col-md-6 col-xs-12 d-flex flex-wrap">

          <!-- new input  -->
          <div class="w-100">
            <div [ngClass]="[ termError ? 'custom-form inputContainer' : 'custom-form']">
              <input class="input_field pt-2 px-3 pt-3" type="text" [(ngModel)]="enterTermVal"
                (click)="enterRecurringAmt = '';recurringAmtError=false;"
                (focus)="enterRecurringAmt = '';recurringAmtError=false;" (keypress)="enterNumberOnly($event)"
                required  id="plan_term"  />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3 bottom-5">
                  Plan Duration (months)
                </span>
              </label>
            </div>

            <!-- new input  -->
            <!-- <div class="d-flex justify-content-between align-items-center p-2"><span>month</span></div> -->
            <p *ngIf="termError" class="mat-error" [innerHTML] = "errorMessage"></p>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-center align-items-center or-text px-0"><span
            style="font-size: 11px !important;">Or</span></div>
        <div class="col-md-5 col-xs-12 d-flex flex-wrap">

          <!-- new input  -->
        <div class="w-100">
          <div [ngClass]="[ recurringAmtError ? 'custom-form inputContainer' : 'custom-form']">
            <input class="input_field pt-3 px-3 notranslate"  id="recurring_amount" [(ngModel)]="enterRecurringAmt" (click)="enterTermVal = '';termError=false;" (focus)="enterTermVal = '';termError=false;"
              appDecimaNumber maxlength="8" required/>
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3 bottom-5">
                Recurring Amount
              </span>
            </label>
          </div>
            <p *ngIf="recurringAmtError" class="mat-error" [innerHTML] = "errorMessage"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between px-4 ms-2 pb-3">
      <!-- <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button> -->
      <button button-primary-auth (click)="validateEnteredAmt();" id="add_plan" [disabled]="isCustomPlanAddDisabled()">Add
        Plan</button>
    </div>
  </div>
</div>

<div class="dialog-header payment-msg" *ngIf="data.type == 18">
  <h2 mat-dialog-title *ngIf="confirmation !== 'cancleConfirm'" class="px-3">
    {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right close-sign">close</mat-icon>
  </h2>
  <h2 mat-dialog-title class="f-w-800 h5" *ngIf="confirmation == 'cancleConfirm'" class="px-3">
    Cancel Confirmation
    <mat-icon (click)="confirmation = ''" class="close pull-right close-sign">close</mat-icon>
  </h2>
  <div class="px-4" *ngIf="confirmation !== 'cancleConfirm'">
    <div mat-dialog-content>
      <div class="text-center" *ngIf="data.paymentInfo && data.send_data.payToday">
        <span class="f-s-16-w-400">Total Payable Today</span>
        <p class="f-s-32-w-800 notranslate" style="margin:2px;">${{data.send_data.payToday | number:'1.2-2'}}</p>
        <p class="f-s-16-w-400">Payment will be deducted from the card ending with ****{{data.send_data.payTodayCardNumber}}</p>
      </div>

      <ng-container *ngIf="data.paymentInfo">
        <div class="bord-bottom d-flex justify-content-between">
          <span class="f-s-14-w-400">Recurring Payment Amount :</span>
          <span class="f-s-14-w-700 notranslate">${{data.send_data.nextRecurringPayment | number:'1.2-2'}}</span>
        </div>

        <div class="bord-bottom d-flex justify-content-between">
          <span class="f-s-14-w-400">Recurring Payment Date :</span>
          <span class="f-s-14-w-700 notranslate">{{data.send_data.nextRecurringPaymentDate}}</span>
        </div>

        <div class="bord-bottom d-flex justify-content-between">
          <span class="f-s-14-w-400">Recurring Payment Card :</span>
          <span class="f-s-14-w-700">****{{data.send_data.nextRecurringPaymentCardNumber}}</span>
        </div>
      </ng-container>
      <h4 class="h5" *ngIf="!data.paymentInfo">
        {{data.desc}}
      </h4>
    </div>
    <div class="d-flex justify-content-center" mat-dialog-actions>
      <button button-login-secondary (click)="dialogRef.close('1')">{{data.paymentInfo ? 'Cancel' : 'No, Add New'}}</button>
      <button button-primary-auth (click)="dialogRef.close('2')" class="ms-3">{{data.paymentInfo ? 'Confirm' : 'Yes'}}</button>
    </div>
  </div>
  <div class="px-4 ms-3" *ngIf="confirmation == 'cancleConfirm'">
    <div class="f-c-p-3 h5 form-group">Are you sure you want to cancel ?</div>
    <span class="mt-4">
      <button button-primary-auth  id="confirmation" (click)="routeMeV2('app/dashboard')">Confirm</button>
    </span>
  </div>

</div>

<div class="dialog-header proposal-div" *ngIf="data.type == 19">
  <div *ngIf="!proposalSent">
    <h2 mat-dialog-title class="f-w-800 border py-3 px-3 d-flex justify-content-between">
      <span>{{fillForm == false ? "Choose payment plans" : "Send Payment Proposal to Customer"}}</span>
      <mat-icon (click)="dialogRef.close()" class="close-sign close pull-right">close</mat-icon>
    </h2>

    <div class="contract_to_Send px-3" style="max-height: 700px;overflow: auto;scroll-behavior: smooth;"  *ngIf="!fillForm">
      <p class="h5 f-c-p-3 px-4 fs-18">Choose the plans that you want to include in this payment proposal</p>

      <div class="" *ngFor="let item of data.allContracts;let i = index;" class="w-100 py-2 px-4 pointer"
        style="z-index: 999999999 !important;">
        <label [for]="'aw'+i"
          class="w-100 d-flex align-item-center justify-content-around p-2 border border_10 pointer mb-0">
          <span class="flex-grow-1 d-flex align-items-center justify-content-start pointer">
            <input type="checkbox" [name]="'aw'+i" [id]="'aw'+i" class="" [checked]="item.checked"
              (change)="checkFunction($event,i)" class="pointer" />
            <label [for]="'aw'+i" class="me-0 mt-0" style="margin-top: -10px !important;"></label>
            <!-- Months -->
            <p class="flex-grow-1 fs-16 fw-bold mb-0 pointer">
              {{item.month}}
              Months
            </p>
          </span>
          <span class="d-felx align-items-center h-100 pointer">
            <p class="flex-grow-1 px-3 py-2 mb-0 pointer">
              <span class="f-c-p-1 pointer notranslate">${{item.recurring_amount | number:'1.2-2'}}</span>
              <span class="f-c-p-3 fw-normal h6 pointer"> per month</span>
            </p>
          </span>
        </label>
      </div>
      <div class="px-4 d-flex align-items-center py-3 justify-content-between">
        <button button-primary-auth (click)="fillForm = true" id="send_proposal"  [disabled]="checkboxed.length == 0">Confirm</button>
        <button *ngIf="!fillForm && checkboxed.length  > 0 && data.send_data.contract_type !== 6" button-login-secondary type="button"
          (click)="downloadPdf()">Download Pdf</button>
      </div>
    </div>
    <form class="container text-start form-cont p-0" *ngIf="fillForm" #sendProposalForm="ngForm"
      (ngSubmit)="sendProposal(sendProposalForm)">
      <div class="row d-flex p-0 pb-3 p-3" mat-dialog-content *ngIf="data && data.send_data">

        <div class="col-6 mb-3">
          <div
            [ngClass]="[!data.send_data.first_name && sendProposalInvalid ? 'custom-form b-10 m-h-56 inputContainer' : ' custom-form b-10 m-h-56']">
            <input type="text" [disabled]="data.send_data.first_name !== '' && data.send_data.page_type == 'Payment' "
              class="input_field px-3 pt-3" name="first_name" required [(ngModel)]="data.send_data.first_name"
              maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                First Name
              </span>
            </label>
          </div>
          <p class="mat-error mb-0" *ngIf="!data.send_data.first_name && sendProposalInvalid">
            Please enter a valid first name
          </p>
        </div>

        <div class="col-6 mb-3">
          <div
            [ngClass]="[!data.send_data.last_name && sendProposalInvalid ? 'custom-form  b-10 m-h-56 inputContainer' : ' custom-form  b-10 m-h-56']">
            <input type="text" [disabled]="data.send_data.last_name !== '' && data.send_data.page_type == 'Payment' "
              class="input_field px-3 pt-3" name="last_name" required [(ngModel)]="data.send_data.last_name"
              maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Last Name
              </span>
            </label>
          </div>
          <p class="mat-error mb-0" *ngIf="!data.send_data.last_name && sendProposalInvalid">
            Please enter a valid last name
          </p>
        </div>

        <div class="col-12 mb-3">
          <div
            [ngClass]="[(!data.send_data.user_email && sendProposalInvalid) || invalidEmailProsposal ? 'custom-form   b-10 m-h-56 inputContainer' : ' custom-form  b-10 m-h-56']">
            <input type="text" [disabled]="data.send_data.user_email !== '' && data.send_data.page_type == 'Payment' "
              class="input_field px-3 pt-3" name="user_email" #user_email="ngModel" email required
              [(ngModel)]="data.send_data.user_email" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Customer Email Address
              </span>
            </label>
          </div>
          <p class="mat-error mb-0"
            *ngIf="(!data.send_data.user_email && sendProposalInvalid) || invalidEmailProsposal">
            Please enter a valid email</p>
        </div>

        <div class="col-12 mb-3">
          <div
            [ngClass]="[((!data.send_data.user_phone && sendProposalInvalid) || (data.send_data.user_phone !== '' && data && data.send_data && data.send_data.user_phone && data.send_data.user_phone.length !== 10 && sendProposalInvalid) && sendProposalInvalid) ? 'custom-form inputContainer' : ' custom-form']">
            <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== ''"
              class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">
              +1
            </span>
            <input type="text" [disabled]="data.send_data.user_phone !== '' && data.send_data.page_type == 'Payment' "
              class="input_field pt-3" name="user_phone" id="phone_number" #user_phone="ngModel" required [mask]="mask"
              [(ngModel)]="data.send_data.user_phone"
              [ngStyle]="{'padding-left': data.send_data.user_phone !== '' ? '40px' : '1rem' }" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Phone Number
              </span>
            </label>
          </div>
          <p class="mat-error mb-0"
            *ngIf="((!data.send_data.user_phone && sendProposalInvalid) || (data.send_data.user_phone !== '' && data && data.send_data && data.send_data.user_phone && data.send_data.user_phone.length !== 10 && sendProposalInvalid) && sendProposalInvalid)">
            Please enter a valid phone number
          </p>
        </div>

        <div class="col-12 mb-3">
          <div class="wrap m-h-56 h-100 h-56 d-block">
            <div class="select w-100 h-100 h-56">

              <select required [(ngModel)]="languageSelected" [ngModelOptions]="{standalone: true}"
                class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                <option class="w-100 py-3 px-2" *ngFor="let d of languages" [value]="d.lan_code">
                  {{d.lan_name}}
                </option>
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <span class="select-bar-1"></span>
              <label class="select-label f-c-p-3">Select a Language for Sending the Proposal</label>
            </div>
          </div>
        </div>

        <h6 class="col-sm-12 fw-bold d-flex align-items-center">
          <span class="me-1">How long will the proposal be valid?</span>
          <span [tooltip]="'This proposal will expire after the number of days selected here.'"
            [customClass]="'dark-theme-tooltip'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </h6>
        <!-- Validity Selector -->
        <div class="col-12">
          <div class="wrap m-h-56 h-100 h-56 d-block">
            <div class="select w-100 h-100 h-56">

              <select required [(ngModel)]="proposalDurationModel" [ngModelOptions]="{standalone: true}"
                (change)="onChange(proposalDurationModel)"
                class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                <option class="w-100 py-3 px-2" *ngFor="let d of proposalDuration" [value]="d.value">
                  {{d.label}}
                </option>
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <span class="select-bar-1"></span>
              <label class="select-label f-c-p-3">Proposal Valid Till</label>
            </div>
          </div>
        </div>
        <!-- Range selector -->
        <div class="custom-field -date pb-2 mt-3" *ngIf="proposalDurationModel == 'Custom Date'">
          <div class="row m-0">
            <div class="col-6">
              <div class="custom-form d-flex align-items-center startDate m-h-56"
                [ngClass]="[!data.send_data.startDate && sendProposalInvalid  ? 'inputContainer' : '']">
                <input class="input_field px-3 pt-3 notranslate" [matDatepicker]="startPicker" (click)="startPicker.open()" readonly
                  [(ngModel)]="data.send_data.startDate" [max]="data.send_data.endDate"
                  [min]="data.send_data.startMinDate" name="startDate" #startDate="ngModel" required />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Start date
                  </span>
                  <span style="position: absolute;top: 15px;right: 0px;">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker disabled="false" startView="month"></mat-datepicker>
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="!data.send_data.startDate && sendProposalInvalid">
                Please enter start date
              </p>
            </div>

            <div class="col-6">
              <div class="custom-form  d-flex align-items-center startDate m-h-56"
                [ngClass]="[!data.send_data.endDate && sendProposalInvalid  ? 'inputContainer' : '']">
                <input class="input_field px-3 pt-3 notranslate" [matDatepicker]="endPicker" (click)="endPicker.open()" readonly
                  [(ngModel)]="data.send_data.endDate" [max]="data.send_data.endMaxDate"
                  [min]="data.send_data.startDate || data.send_data.startMinDate" name="endDate" #endDate="ngModel"
                  required />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    End date
                  </span>
                  <span style="position: absolute;top: 15px;right: 0px;">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker disabled="false" startView="month"></mat-datepicker>
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="!data.send_data.endDate && sendProposalInvalid">
                Please enter end date
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between py-3 px-4 mx-2">
        <!-- <button type="reset" mat-stroked-button (click)="proposalDurationModel=proposalDuration[3].value">Reset</button> -->
        <button *ngIf="fillForm && data.send_data.page_type != 'Payment' " button-login-secondary type="button"
          (click)="sendProposalForm.reset()">Reset</button>
        <button button-primary-auth type="submit">{{data.action}}</button>
      </div>
    </form>
  </div>

  <div class="container text-start p-0 text-center" *ngIf="proposalSent">
    <img src="assets/img/gif/right_mark11.gif" alt="Proposal sent successfully">
    <h1 mat-dialog-title class="pt-2">Payment Proposal Sent</h1>
    <p class="py-4 px-5">The payment proposal has been sent to your Customer via email or text message. When your
      Customer
      chooses a plan and makes a payment, they will automatically be financed.</p>

    <div class="row p-2 pt-2 text-center">
      <div class="col-sm-12 text-center d-flex align-item-center justify-content-around">
        <button *ngIf="currentPath == '/app/finance'" button-primary-auth
          (click)="dialogRef.close(this.data && this.data.downpaymentCost && this.data.downpaymentCost ? 1 : 0)">
          Finance New Customer
        </button>
        <button *ngIf="currentPath == '/app/contract/split-list'" button-primary-auth
          (click)="routeMeV2('/app/finance')">
          Finance New Customer
        </button>
        <button button-login-secondary (click)="dialogRef.close(0)">View Proposal</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Card - Finance Customer -->
<div class="dialog-header" *ngIf="data.type == 20">
  <h2 mat-dialog-title> {{data.title=='Add Card'?'Add new card':data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div *ngIf="data.title == 'Select/Add Card for recurring payments'" style="margin: 5px 16px;">
      <p>Please select/add a new card which will be used for Recurring Payment deductions.</p>
    </div>
    <div *ngIf="data.title == 'Add Card'" style="margin: 5px 16px;">
      <p>Card used for your enrollment fee, down payment, upfront payment.</p>
    </div>
    <div *ngIf="data.title == 'Add Backup Card'" style="margin: 5px 16px;">
      <p>Please add a new card which will be treated as a Backup card.</p>
    </div>
    <div
      *ngIf="data.title == 'Select/Add Card for recurring payments' || data.title == 'Select/Add Card for subscription'">
      <div class="card-list mb-2">
        <div *ngFor="let card of data.send_data.card_list; let i=index" style="cursor:pointer"
          class="col-12 bg-light d-flex justify-content-between align-items-center p-3 mb-2">
          <div class="light-purple p-2 d-flex align-items-center" [class.active]="card.active">
            <span style="line-height:0;">
              <img style="width:24px;"
                [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express';else no_card " />
              <ng-template #no_card>
                <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
              </ng-template>
            </span>
            <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
          </div>
          <div class="">
            <!-- <p class="m-0 text-success-custom" style="font-size:12px;display: flex; align-items: center; flex-direction: row-reverse;" *ngIf="card.source_id==contractDetails.source_id"> <mat-icon>check_circle_outline</mat-icon>Default </p> -->
            <!-- <p class="col-12" style="font-size:12px;" [ngClass]="{'text-danger-custom':card.source_id!=contractDetails.source_id}" *ngIf="card.last_error!='null' && card.last_error!=null"> {{card.last_error.split('=')[0] ||''}}</p> -->
          </div>
          <div>
            <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card)">Select</button>
          </div>

          <div class="">
            <!-- <p class="m-0 text-success-custom" style="font-size:12px;display: flex; align-items: center; flex-direction: row-reverse;" *ngIf="card.source_id==contractDetails.source_id"> <mat-icon>check_circle_outline</mat-icon>Default </p> -->
            <!-- <p class="col-12" style="font-size:12px;" [ngClass]="{'text-danger-custom':card.source_id!=contractDetails.source_id}" *ngIf="card.last_error!='null' && card.last_error!=null"> {{card.last_error.split('=')[0] ||''}}</p> -->
          </div>
          <div>
            <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card);">Select</button>
          </div>
        </div>
  </div>
    </div>
    <div class="p-3 text-center mb-1" *ngIf="data.send_data.card_list.length">
      <span>OR</span>
    </div>

    <form #addCardForm="ngForm" (ngSubmit)="addCard(addCardForm)">
      <div>
        <div class="row me-0 ms-0">

          <div class="col-md-12 form-cont">
            <div class="form-group h-100">
              <label class="form-label">Card Holder Name</label>
              <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel"
                placeholder="Enter cardholder name" trim  required class="form-input w-100 d-block">
            </div>
          </div>

          <div class="col-md-12">
            <div class="stripe-card" id="add_card"></div>
          </div>
        </div>

        <div class="col-md-12">
          <mat-checkbox class="apply-cont" [(ngModel)]="new_address.checked" (click)="changeAddres()"
            name="billing_check">
            <small>
              Choose {{data.send_data.type}} address as billing address
            </small>
          </mat-checkbox>
        </div>

        <div *ngIf="!new_address.checked" class="billing-address-section">

          <div class="col-md-12 form-cont  my-3">
            <div class="custom-form">
              <input type="text" class="input_field pt-3 px-3" name="new_address_1" autocomplete="off" required
                name="new_address_1" trim  #new_address_1="ngModel" [(ngModel)]="new_address.new_address_1"
                [ngModelOptions]="{standalone: true}" />
              <label for="text" class='label-name'>
                <span class="content-name f-c-p-3">
                  Address Line 1
                </span>
              </label>
            </div>
          </div>


          <div class="col-md-12 form-cont  my-3">
            <div class="custom-form">
              <input type="text" class="input_field pt-3 px-3" name="new_address_2" autocomplete="off" required
                name="new_address_2" trim  #new_address_2="ngModel" [(ngModel)]="new_address.new_address_2"
                [ngModelOptions]="{standalone: true}" />
              <label for="text" class='label-name'>
                <span class="content-name f-c-p-3">
                  Address Line 2 (Optional)
                </span>
              </label>
            </div>
          </div>


          <div class="w-100 d-padding px-3">
            <zip-selector (zipSelected)="getZipselected($event)" t="2" [isRequired]="true" [search_canada]="1"
              [model]="new_address.zip_code" ngDefaultControl [not_found]="'No Zip/Postal Code Found'"></zip-selector>
          </div>



          <div class="col-md-12 form-cont  my-3">
            <div class="custom-form">
              <input type="text" class="input_field pt-3 px-3" name="state" disabled autocomplete="off" required
                name="state" trim  maxlength="30" [(ngModel)]="new_address.state" readonly
                [ngModelOptions]="{standalone: true}" />
              <label for="text" [ngClass]="[!new_address?.state  ? '' : 'label-name']">
                <span class="content-name f-c-p-3">
                  State
                </span>
              </label>
            </div>
          </div>

          <div class="col-md-12 form-cont my-3">
            <div class="custom-form">
              <input type="text" class="input_field pt-3 px-3" name="city" disabled autocomplete="off" required
                name="City" trim  maxlength="30" [(ngModel)]="new_address.city" readonly
                [ngModelOptions]="{standalone: true}" disabled />
              <label for="text" [ngClass]="[!new_address?.city ? '' : 'label-name']">
                <span class="content-name f-c-p-3">
                  City
                </span>
              </label>
            </div>
          </div>

        </div>
        <div *ngIf="new_address.checked" class="same-billing row ps-4 pe-4">
          <div class="col-6" style="padding: 15px">
            <div class="theme-bg-color">
              <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
              <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
              <p class="m-0">{{data.send_data.state}}
                {{data.send_data.country_code
                ?
                ', '+data.send_data.country_code:''}}
              </p>
            </div>
          </div>
          <div class="col-6" style="padding: 15px">
            <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
              <p class="text-center" style="align-self: center;margin:0">
                <a (click)="new_address.checked = !new_address.checked" href="javascript:void(0)"
                  style="color:#3791e5">ADD NEW BILLING ADDRESS</a>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-12 ps-4 pe-4" *ngIf="data.title !== 'Add Card'">
          <div class="mt-2">
            <mat-checkbox class="apply-cont checkbox-cls" [(ngModel)]="new_address.saveDefault" name="saveDefault"
              #saveDefault="ngModel">
              <small>
                Save as Default
              </small>
            </mat-checkbox>
          </div>
        </div> -->
        <div class="col-md-12 ps-4 pt-3 pe-4 notes_section">
          <p *ngIf="addCardForm.invalid && addCardForm.submitted" class="text-danger-custom text-center"
            style="padding: 10px 15px 0px;">*Please fill the required fields
          </p>
          <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
            {{new_address.cardError}}
          </p> -->
          <div class="w-100" *ngIf="data.title == 'Select/Add Card for recurring payments'">
            <p>This card will be selected as Default for this contract only.</p>
            <b>Note:</b>
            <ul>
              <li>Recurring Payment will be charged from first card ending with
                {{data.send_data.recurringCardNum}} if
                the payment fails from this card.</li>
              <li>You will be charged a dollar or 1% (whichever is higher) as extra transaction fee if you
                use a non-US
                debit/credit card.</li>
              <li>As part of our card verification process $1 will be deducted which will be refunded once
                your card has
                been validated.</li>
            </ul>
          </div>
          <div class="w-100" *ngIf="data.title == 'Add Backup Card'">
            <b>Note:</b>
            <ul>
              <li>Recurring Payment will be charged from this Backup card if the payment fails from first
                card ending
                with {{data.send_data.recurringCardNum}}.</li>
              <li>You will be charged a dollar or 1% (whichever is higher) as extra transaction fee if you
                use a non-US
                debit/credit card.</li>
              <li>As part of our card verification process $1 will be deducted which will be refunded once
                your card has
                been validated.</li>
            </ul>
          </div>
          <div class="w-100" *ngIf="data.title == 'Add Card'">
            <b>Note:</b>
            <ul>
              <li>You will be charged a dollar or 1% (whichever is higher) as extra transaction fee if you
                use a non-US
                debit/credit card.</li>
              <li>As part of our card verification process $1 will be deducted which will be refunded once
                your card has
                been validated.</li>
            </ul>
          </div>

        </div>
      </div>
      <div class="d-flex justify-content-between" mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="dialogRef.close('2')"
          *ngIf="data.title!='Add Card'">{{data.title == 'Add Card' ? 'Cancel'
          : 'Back'}}</button>
        <a *ngIf="data.title == 'Add Backup Card' && data.send_data.show_skip_btn" href="javascript:void(0);"
          (click)="dialogRef.close('3')" title="Skip"
          class="p-2 text-uppercase text-decoration-none me-2 text-secondary">Skip</a>
        <button type="submit" button-primary-auth [disabled]="responseSubmitted" class="add_btn">Add</button>
      </div>
    </form>
  </div>
</div>
<!-- Add new card and show card list using form data-->
<div class="dialog-header pricingDailog" *ngIf="data.type == 51">
  <h2 mat-dialog-title style="padding:24px">
    <!-- {{data.title=='Add Card'?'Add new card': (data.send_data.card_list.length == 0 ? 'Add Card For Subscription':data.title))}} -->
      {{data.title=='Add Card' ? 'Add new card' : (data.send_data.card_list && data.send_data.card_list.length == 0  ? 'Add Card For Subscription' : data.title)}}
      <mat-icon style="transform: translate(-5%, -10%) !important;" (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content style="height: 80vh !important; max-height: 80vh !important;">
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0" style="margin: 5px 16px;">
      <p class="fs-16 f-w-600">Select or add new card for subscription payment.</p>
    </div>
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0">
      <div class="card-list mb-2">
        <div *ngFor="let card of data.send_data.card_list; let i=index" >
          <label style="cursor:pointer;border-radius: 15px !important;" [ngClass]="{border_added: data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id}"
          class="col-12 bg-light d-flex justify-content-between align-items-center p-3 mb-2"  [for]="'prior' + i">
          <div class="d-flex align-items-center active">
            <span style="line-height:0;">
              <img style="width:24px;"
                [src]="getCardBrandImage(card)"
                *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(card.brand.toLowerCase()); else no_card" />
              <ng-template #no_card>
                <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
              </ng-template>
            </span>
            <span class="card-num font-light" style="color: #6B7376 !important">&nbsp;&nbsp;**** **** **** {{card.last4}}</span>

          </div>
            <input type="radio" [id]="'prior' + i" name="prior" (change)="selectCardForPayment(card);" [checked]="data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id">
            <label [for]="'prior' + i" class="mb-auto"></label>
            <!-- <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card);">Select</button> -->
        </label>
        </div>

      </div>
      <div class="p-3 text-center mb-1 d-flex justify-content-between align-items-center" *ngIf="data.send_data.card_list.length">
        <hr class="rotote">
        <span class="fs-16 f-w-800">Add New</span>
        <hr class="rotote">
      </div>
    </div>
    <form [formGroup]="addCardForm">
      <div class="row me-0 ms-0" *ngIf="!showAddressField">
        <span class="ps-3 fs-16 f-w-800">Card Details</span>
        <div class="col-md-12 form-cont mb-2 mt-2">
          <div
            [ngClass]="[addCardForm.controls.cardholder_name.touched && addCardForm.controls.cardholder_name.invalid ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-2 pt-3" formControlName="cardholder_name" name="cardholder_name" required
              trim  maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Card Holder Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="iscardSubmitted && addCardForm.controls.cardholder_name.invalid">
            Please enter card holder name.
          </p>
        </div>
      </div>

      <div class="row me-0 ms-0" style="margin-top: 10px;">
        <!-- card input box -->
        <div class="col-md-12">
          <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
        </div>
      </div>

      <div class="col-md-12" *ngIf="data && data.send_data && data.send_data.user_info && (data.send_data.user_info.business_verification_state == 'other_info_updated' ||
        data.send_data.user_info.business_verification_state == 'persona_verified')">
        <!-- <div class="col-md-12 mt-2"> -->
        <input type="checkbox" class="pointer" name="billing_check" id="billing_check" formControlName="checked"
        (change)="getAddressFormV2()">
        <label for="billing_check"  style="margin-top: 15px">
          <span style="font-weight: 400; font-size: 14px; color: #313A44;">
            Choose {{data.send_data.type}} address as billing address
          </span>
        </label>
      </div>

      <div class="row my-3 me-0 ms-0" [ngClass]="{'d-none': !showAddressField}">
        <span class="ps-3 fs-16 f-w-800 mb-3">Billing Address</span>
        <div class="col-md-12">
          <div id="address-element"></div>
        </div>
      </div>

      <div *ngIf="!showAddressField" class="same-billing row ps-4 pe-4">
        <div class="col-6" style="padding: 15px">
          <div style="border: 1px solid rgba(112,112,112,0.5); padding: 15px">
            <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
            <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
            <p class="m-0">{{data.send_data.state}}
              {{data.send_data.country_code
              ?
              ', '+data.send_data.country_code:''}}
            </p>
          </div>
        </div>
        <div class="col-6" style="padding: 15px">
          <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
            <p class="text-center" style="align-self: center;margin:0">
              <a (click)="getAddressForm()" href="javascript:void(0)" style="color:#0A6B89">ADD NEW BILLING ADDRESS</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 pe-4" style="padding-left: 12px;" *ngIf="data.send_data.showDefault">
        <div class="mt-3">

          <input type="checkbox" class="pointer" name="saveDefault" id="saveDefault" formControlName="saveDefault">
          <label for="saveDefault">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Save as Default
            </span>
          </label>
        </div>
      </div>

      <!-- <small class="col-lg-12 pe-4">
        <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
          {{new_address.cardError}}</p>
      </small> -->
      <div class="d-flex justify-content-start" mat-dialog-actions>
        <!-- <button mat-stroked-button  mat-dialog-close (click)="dialogRef.close('2')"
            *ngIf="data.title!='Add Card'">{{data.title == 'Add Card' ? 'Cancel'
            : 'Back'}}</button> -->
        <button button-primary-auth [disabled]="responseSubmitted" (click)="addCardSubmitV2()" class="add_btn px-4 ms-2">Add Now</button>
      </div>
      <!-- <div class="ps-3 ms-1 pt-3 w-100">
        <b>Note:</b>
        <ul class="ps-4" style="list-style-type: disc;">
          <li class="f-c-p-8 fs-16" style="font-weight: unset !important; text-align: unset !important;">$1 will be deducted and reversed to check the Card Authorization. </li> -->
          <!-- <li class="f-c-p-8 fs-16">You will be charged a dollor or 1% (whichever is higher) as an extra transaction fee if you use a non-US debit/credit card. </li> -->
        <!-- </ul>
    </div> -->
    </form>
  </div>
</div>
<!-- Add BreakDown -->
<div class="dialog-header" *ngIf="data.type == 21">
  <h2 style="margin-left: 0px !important;" mat-dialog-title class="px-4 py-4 mb-0"> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right text-dark"
      style="position: relative !important; transform: none;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-0">
    <h4 style="background: #DEE8F1;" class="px-4 py-2">
      <span style="color: #313A44;">Service Cost: </span><strong class="notranslate">${{ data.send_data.service_cost |
        number:'1.2-2'}}</strong>
    </h4>
    <form [formGroup]="serviceBreakForm">
      <div class="p-3 px-4 service-list" formArrayName="items">
        <div *ngFor="let service_block of serviceBreakdowns.controls; let i = index;"
          class="d-flex align-item-center justify-content-between mx-0 mb-3">
          <ng-container [formGroup]="service_block">
            <div class="serv-name p-0" style="width: 35%;">
              <div
                [ngClass]="[ service_block.controls.service.touched && service_block.controls.service.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                <input type="text" class="input_field pt-3 px-3" name="service" required formControlName="service"
                  id="breakDownText{{i}}" (keyup)="services()" tabindex="{{i+1}}1"
                  (keypress)="mainService.handleInputSpace($event)" autofocus  maxlength="100" />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3 bottom-5">
                    Service Name
                  </span>
                </label>
              </div>
              <p class="mat-error"
                *ngIf="service_block.controls.service.touched && service_block.controls.service.invalid">
                Please enter service name.
              </p>
            </div>
            <div class="p-0" style="width: 35%;">
              <div
                [ngClass]="[ service_block.controls.price.touched && service_block.controls.price.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3  ']">
                <span *ngIf="service_block.controls.price.value !== null && service_block.controls.price.value !== ''"
                  class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">$
                </span>
                <input class="input_field pt-3 notranslate"
                  [ngClass]="[service_block.controls.price.value !== null && service_block.controls.price.value !== '' ? 'px-4' : 'px-3']"
                  type="number" id="breakDownVal{{i}}" formControlName="price" required
                  onKeyPress="if(this.value.length==8) return false;" (keyup)="services()" tabindex="{{i+1}}2">
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3 bottom-5">
                    Price
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="service_block.controls.price.touched && service_block.controls.price.invalid">
                Please enter price.
              </p>
            </div>
            <div class="action-item d-flex justify-content-start align-items-center p-1"
              style="width: 12%;height: 49px;">
              <img tappable class="me-1" src="assets/img/svg/dashboard/close-circle.svg"
                *ngIf="serviceBreakForm.value.items.length > 1" (click)="deleteGroup(i, false)" />
            </div>
          </ng-container>
        </div>
        <a tappable *ngIf="serviceBreakForm.value.items.length < 25" (click)="addGroup(false)">+Add New Service</a>
      </div>


      <div class="p-3 px-4 service-list" formArrayName="addOns" *ngIf="selected_additional_product_array.controls.length">
        <div *ngFor="let service_block of selected_additional_product_array.controls; let i = index;"
          class="d-flex align-item-center justify-content-between mx-0 mb-3">
          <ng-container [formGroup]="service_block">
            <div class="serv-name p-0" style="width: 35%;">
              <div
                [ngClass]="[ service_block.controls.service.touched && service_block.controls.service.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                <input type="text" class="input_field pt-3 px-3 modified" name="service" required formControlName="service"
                  id="breakDownText{{i}}" (keyup)="services()" tabindex="{{i+1}}1"
                  (keypress)="mainService.handleInputSpace($event)" autofocus maxlength="100" />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Service Name
                  </span>
                </label>
              </div>
              <p class="mat-error"
                *ngIf="service_block.controls.service.touched && service_block.controls.service.invalid">
                Please enter service name.
              </p>
            </div>
            <div class="p-0" style="width: 35%;">
              <div
                [ngClass]="[ service_block.controls.price.touched && service_block.controls.price.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3  ']">
                <span *ngIf="service_block.controls.price.value !== null && service_block.controls.price.value !== ''"
                  class="pt-2 pe-1 font-weight-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">$
                </span>
                <input class="input_field pt-3 notranslate"
                  [ngClass]="[service_block.controls.price.value !== null && service_block.controls.price.value !== '' ? 'px-4' : 'px-3']"
                  type="number" id="breakDownVal{{i}}" formControlName="price" required
                  onKeyPress="if(this.value.length==8) return false;" (keyup)="services()" tabindex="{{i+1}}2">
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Price
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="service_block.controls.price.touched && service_block.controls.price.invalid">
                Please enter price.
              </p>
            </div>
            <div class="action-item d-flex justify-content-start align-items-center p-1"
              style="width: 12%;height: 49px;">
              <img tappable class="me-1" src="assets/img/svg/dashboard/close-circle.svg"
                *ngIf="serviceBreakForm.value.addOns.length > 1" (click)="deleteGroup(i, true)" />
            </div>
          </ng-container>
        </div>
        <a tappable *ngIf="serviceBreakForm.value.addOns.length < 25" (click)="addGroup(true)">+Add New Add-On</a>
      </div>
    </form>
  </div>
  <div class="d-flex justify-content-between px-4" mat-dialog-actions>
    <button class="py-2 px-4 sup-btn" mat-raised-button (click)="addEditBreakDown();"
      [disabled]="!serviceBreakForm.valid">{{data.send_data.action_button}}</button>
  </div>
</div>

<!-- Switch business to Customer -->
<div class="dialog-header" *ngIf="data.type == 22">
  <h2 mat-dialog-title style="padding: 32px 16px 0px 32px; text-transform: none;">
    <mat-icon (click)="dialogRef.close();" class="close pull-right close-sign2">close
    </mat-icon>
      {{data.title || 'Please enter your password to continue'}}
  </h2>
  <div mat-dialog-content>
    <form #switchBusinessToCustomerForm="ngForm" class="px-3 pb-3"
      (ngSubmit)="switchBusinessToCustomer(switchBusinessToCustomerForm)">
      <div class="b-10 m-h-56 custom-form" [ngClass]="[!data.send_data.password ? 'inputContainer' : '']" [class.inputContainer]="passEror">
        <input [type]="hide == true ? 'password' : 'text'" class="input_field px-3 pt-3" name="password"
          [(ngModel)]="data.send_data.password" name="password" #password="ngModel" autocomplete="off" (input)="passEror = false" required />
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Enter Password
          </span>
        </label>

        <button style="position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button
          class="d-inline me-2" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </div>
      <p class="mat-error" *ngIf="passEror">
        Enter valid password.
      </p>
      <div class="mt-3">
        <button button-primary-auth type="submit">Continue</button>
      </div>
      <div class="mt-3">
        <a  (click)="goto_forgot_password()" class="fw-bold mt-2 d-inline pointer ">Forgot Password</a>
      </div>
    </form>
  </div>
</div>

<!-- Send Payment Link -->
<div class="dialog-header" *ngIf="data.type == 23">
  <div *ngIf="!paymentLinkSent">
    <h2 mat-dialog-title class="px-3"> {{data.title}}
      <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
    </h2>
    <form #sendPaymentLinkForm="ngForm" (ngSubmit)="sendPaymentLinkCustomer(sendPaymentLinkForm)"
      class="container text-start form-cont p-0">
      <div class="row p-0" mat-dialog-content *ngIf="data && data.send_data">
        <div class="form-group col-sm-12">
          <div [ngClass]="[!data.send_data.customer_name ? 'custom-form  inputContainer' : 'custom-form']">

            <input type="text" class="input_field pt-3 px-3" [(ngModel)]="data.send_data.customer_name" required
              name="customer_name" #customer_name="ngModel" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Customer Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="customer_name.invalid && customer_name.touched">Please enter a valid customer name
          </p>
        </div>

        <div class="form-group col-sm-12 readonly">
          <div [ngClass]="[!data.send_data.user_email ? 'custom-form  inputContainer' : 'custom-form']">
            <input type="text" class="input_field pt-3 px-3" [(ngModel)]="data.send_data.user_email" required
              name="user_email" #user_email="ngModel" trim  email readonly />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Customer Email
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="user_email.invalid">Please enter a valid email</p>
        </div>

        <div class="form-group col-sm-12">
          <div
            [ngClass]="[!data.send_data.user_alternate_email && user_alternate_email.invalid && user_alternate_email.touched ? 'custom-form  inputContainer' : 'custom-form']">
            <input type="text" class="input_field pt-3 px-3" [(ngModel)]="data.send_data.user_alternate_email"
              name="user_alternate_email" #user_alternate_email="ngModel" trim  email />
            <label for="text"
              [ngClass]="[(user_alternate_email.invalid || user_alternate_email.value != '') ? 'label-name' : '']">
              <span class="content-name f-c-p-3">
                Alternate Email Address
              </span>
            </label>
          </div>

          <p class="mat-error" *ngIf="user_alternate_email.invalid && user_alternate_email.touched">Please enter a valid
            alternate email</p>
        </div>

        <div class="form-group col-sm-12 readonly">
          <div [ngClass]="[!data.send_data.user_phone ? 'custom-form  inputContainer' : 'custom-form']">
            <span *ngIf="user_phone.value !== null && user_phone.value !== ''"
              class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
            </span>
            <input type="text" class="input_field pt-3"
              [ngStyle]="{'padding-left': user_phone.value !== '' ? '40px' : '1rem' }"
              [(ngModel)]="data.send_data.user_phone" name="user_phone" #user_phone="ngModel" [mask]="mask" readonly />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Phone Number
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="user_phone.invalid">Please enter a valid phone number</p>

        </div>

        <div class="form-group col-sm-12">
          <div
            [ngClass]="[!data.send_data.user_alternate_phone && user_alternate_phone.invalid &&  user_alternate_phone.touched ? 'custom-form  inputContainer' : 'custom-form']">

            <span *ngIf="user_alternate_phone.value !== null && user_alternate_phone.value !== ''"
              class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
            </span>

            <input type="text" class="input_field pt-3" [(ngModel)]="data.send_data.user_alternate_phone"
              [ngStyle]="{'padding-left': data.send_data.user_alternate_phone.value !== '' ? '40px' : '1rem' }"
              name="user_alternate_phone" #user_alternate_phone="ngModel" [mask]="mask" pattern="^[0-9]+$" />
            <label for="text"
              [ngClass]="[(user_alternate_phone.invalid || user_alternate_phone.value != '') ? 'label-name' : '']">
              <span class="content-name f-c-p-3">
                Alternate Phone Number
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="user_alternate_phone.invalid && user_alternate_phone.touched">Please enter a valid
            phone number</p>

        </div>

      </div>
      <div class="d-flex justify-content-center" mat-dialog-actions>
        <button mat-raised-button type="submit" class="w-50">Send Payment Link</button>
      </div>
    </form>
  </div>
  <div class="container text-start p-0 text-center" *ngIf="paymentLinkSent">
    <h2 mat-dialog-title>Payment Link
      <mat-icon (click)="dialogRef.close(1)" [routerLink]="['/app/dashboard']" class="close pull-right">close</mat-icon>
    </h2>
    <img src="assets/img/svg/sent.svg" alt="Proposal sent successfully">
    <h4 class="text-bold">Thank You</h4>
    <p class="p-4 mb-2">Payment link sent to {{data.send_data.user_email}}
      {{', '+sendPayLinkCusData.customer_alternate_email}}
      and
      {{data.send_data.user_phone}}
      {{', '+sendPayLinkCusData.customer_alternate_mobile}}
    </p>
    <p class="text-muted mb-3">Awaiting payment authorization from customer.</p>
    <div class="row p-4 pt-2 text-center">
      <div class="col-sm-12">
        <button mat-raised-button (click)="dialogRef.close(1)" [routerLink]="['/app/dashboard']">Done</button>
      </div>
    </div>
  </div>
</div>

<!--Payment Success Modal -->
<div class="dialog-header payment-success-msg" *ngIf="data.type == 24">
  <h2 mat-dialog-title>
    <!-- {{data.title}} -->
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3 text-center w-100">
    <img src="assets/img/png/check_signup.png" alt="Success" width="120px">
    <h4 class="mt-4">Congratulations!</h4>
    <!-- <p>You have successfully financed a customer with Denefits.</p> -->
    <p>You have successfully created a payment plan with <span class="notranslate">Denefits</span>.</p>
    <!-- <div *ngIf="data.send_data.contract_type == 2 && data.send_data.financing_type != 2">
      <span class="ques">Would you like to set No Fee Payment Plan as your default payment method?</span>
      <div class="mt-3 d-flex justify-content-between align-item-center pe-5 ps-5 pb-4 pt-4">
        <button class="rounded" mat-stroked-button mat-dialog-close (click)="dialogRef.close('0')">Close</button>
        <button class="rounded" mat-raised-button (click)="dialogRef.close('1')">Set as Default</button>
      </div>
      <p class="setting-link mb-0">You can change default setting via <a href="javascript:void(0);"
          (click)="dialogRef.close('0')" class="text-decoration-none" [routerLink]="['/app/global-settings']"
          title="Financial Settings">Financial Settings</a></p>
    </div>
    <div *ngIf="data.send_data.contract_type == 2 && data.send_data.financing_type == 2">
      <div class="mt-3 d-flex justify-content-between align-item-center pe-5 ps-5 pb-4 pt-4">
        <button class="rounded" mat-stroked-button mat-dialog-close (click)="dialogRef.close('0')">Done</button>
        <button class="rounded" mat-raised-button (click)="dialogRef.close('0')">Close</button>
      </div>
      <p class="setting-link mb-0">You can change default setting via <a href="javascript:void(0);"
          (click)="dialogRef.close('0')" class="text-decoration-none" [routerLink]="['/app/global-settings']"
          title="Financial Settings">Financial Settings</a></p>
    </div> -->
    <!-- <button class="rounded" *ngIf="data.send_data.contract_type != 2" mat-stroked-button mat-dialog-close
      (click)="dialogRef.close('0')">Close</button> -->
  </div>
</div>

<!-- Request Call-back Modal -->
<div class="dialog-header" *ngIf="data.type == 25">
  <h2 mat-dialog-title class="mb-0 bord d-flex">
    <span style="font-weight: 700;font-size: 16px;line-height: 24px; color: #313A44;">{{data.title}}</span>
    <span class="mt-2 rode">
      <mat-icon (click)="dialogRef.close()" class="close pull-right">close
      </mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="p-3 pb-0 text-center sup-title">
    <form class="container text-start form-cont p-0" #requestCallBackForm="ngForm"
      (ngSubmit)="requestCallBack(requestCallBackForm)">
      <div class="row p-0 mt-3" *ngIf="data && data.send_data">
        <div class="form-group w-100 mat-short-height col-sm-12">

          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field sup px-3" [(ngModel)]="data.send_data.name" required name="name" #name="ngModel"
              placeholder="Customer Name" trim  readonly />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Name
              </span>
            </label>
          </div>

          <!-- <label>Name</label>
          <input class="form-input w-100" [(ngModel)]="data.send_data.name" required name="name" #name="ngModel"
            placeholder="Customer First Name" trim  readonly> -->
        </div>

        <div class="form-group w-100 mat-short-height col-sm-12">

          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field sup px-3" [(ngModel)]="data.send_data.phone" name="phone" #phone="ngModel"
              placeholder="Text Message" [mask]="mask" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Phone
              </span>
            </label>
          </div>

          <!-- <label>Phone</label>
          <input class="form-input w-100" [(ngModel)]="data.send_data.phone" name="phone" #phone="ngModel"
            placeholder="Text Message" [mask]="mask"> -->
        </div>

        <div class="form-group w-100 mat-short-height col-sm-12">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field sup px-3" [(ngModel)]="data.send_data.email" required name="email" #name="ngModel"
              placeholder="Customer Email" trim  readonly />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Email
              </span>
            </label>
          </div>
        </div>

        <div class="form-group example-full-width mb-2 col-sm-12" appearance="outline">

          <div class="wrap m-h-56 h-100 border h-56 border_10 d-block">
            <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
              <div class="w-100 h-100">
                <select id="img_logo_emp" name="timezone" required [(ngModel)]="callReasonModel"
                  (change)="reasonPrioritySet(callReasonModel)"
                  class="select-text pt-3 px-3 mt-1 input_field sup fw-bold m-h-56 h-100 w-100">
                  <option *ngFor="let d of data.send_data.reason" [value]="d.reason">
                    {{d.reason}}
                  </option>
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <span class="select-bar-1"></span>
                <span class="select-bar-1"></span>
                <label class="select-label f-c-p-3">Select Reason</label>
              </div>
            </div>
          </div>


          <!-- <label>Select Reason</label>
          <mat-select class="form-input w-100" required [(ngModel)]="callReasonModel"
            (selectionChange)="reasonPrioritySet(callReasonModel)" name="callReasonModel">
            <mat-option *ngFor="let d of data.send_data.reason" [value]="d.reason">
              {{d.reason}}
            </mat-option>
          </mat-select> -->
        </div>

        <div class="form-group example-full-width mb-2 col-sm-12">
          <textarea class="form-input w-100 mt-3" [(ngModel)]="data.send_data.message" placeholder="Message"
            name="message" #message="ngModel"></textarea>
        </div>

        <div class="form-group col-lg-12">
          <label for="gender" class="calllback-text">Priority*</label>
          <div class="d-flex">
            <div class="radio">
              <label>
                <input type="radio" [(ngModel)]="data.send_data.priority" id="priority" name="priority"
                  #priority="ngModel" [value]=1>
                <label for="priority"></label>
                <span class="ps-1">Low</span>
              </label>
            </div>
            <div class="radio ms-2 me-2">
              <label>
                <input type="radio" [(ngModel)]="data.send_data.priority" name="priority" #priority="ngModel" [value]=2>
                <span class="ps-1">Medium</span>
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" [(ngModel)]="data.send_data.priority" name="priority" #priority="ngModel" [value]=3>
                <span class="ps-1">High</span>
              </label>
            </div>
          </div>

        </div>
      </div>
      <div class="mt-1 d-flex justify-content-start align-item-center pe-5 ps-0 pb-4 pt-2">
        <button mat-raised-button type="submit" class="p-2 sup-btn">Submit</button>
      </div>
    </form>
  </div>
</div>

<!-- Change payment Cards Modal -->
<div class="dialog-header" *ngIf="data.type == 26">
  <h2 style="margin-left: 0px !important;" mat-dialog-title class="px-4 py-4 mb-0">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right text-dark"
      style="position: relative !important; transform: none;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="change-payment-method">

    <div class="card-list mb-2">
      <div class="row pb-3 w-100 g-0">
        <div class=" col-md-8  pay-label">Select Cards/Bank</div>
        <div class=" col-md-4">
          <div class="row g-0">
            <div class=" col-md-6 text-center pay-label">Default</div>
            <div class=" col-md-6 text-center pay-label">Backup</div>
          </div>
        </div>
      </div>
      <div *ngFor="let card of data.send_data.cards; let i=index"
        class="col-12 d-flex justify-content-between align-items-center mb-2 p-0">
        <div class="col-md-8 d-flex align-items-center p-2 card-div" [class.active]="card.active">
          <span style="line-height:0;" *ngIf="card.payment_source_type !== 1">
            <img src="assets/img/svg/card.svg">
          </span>
          <span style="line-height:0;" *ngIf="card.payment_source_type == 1">
            <img src="assets/img/svg/bank.svg">
          </span>
          <span class="card-num ms-1"><span class="text-bold star-pattern">**** **** ****</span> {{card.last4}}</span>
          <span class="m-0 pull-right col text-end text-success-custom p-0"
            *ngIf="card.source_id == data.send_data.source_id || card.source_id == data.send_data.secondary_source_id">{{card.source_id
            == data.send_data.source_id ? 'Default' : card.source_id == data.send_data.secondary_source_id ?
            'Backup' : ''}}</span>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6 text-center">
              <input required type="radio" [(ngModel)]="data.send_data.source_id" name="new_source_id"
                [value]="card.source_id" tappable id="{{'method_'+ card.source_id}}">
              <label class="payment_lab" for="{{'method_'+ card.source_id}}"></label>
            </div>
            <div class="col-md-6 text-center">
              <input required type="radio" [(ngModel)]="data.send_data.secondary_source_id"
                name="new_secondary_source_id" [value]="card.source_id" tappable id="{{'method1_'+ card.source_id}}"
                [disabled]="card.source_id == data.send_data.source_id">
              <label class="payment_lab" for="{{'method1_'+ card.source_id}}"></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-12 mt-3 p-0" style="color:#7A848D; font-size: 14px;">
      <b>Note:</b>
      <ul style="padding-left: 0px;">
        <li> You will be charged ${{ getNonUsCardFee().non_us_amount_below_threshold }} or {{ getNonUsCardFee().non_us_percent_above_threshold }}% (whichever is higher) as extra fee if you use a non-US debit/credit card.
        </li>

        <!-- <li>As part of our card verification process $1 will be deducted which will be refunded once your card has been
          validated.</li> -->
      </ul>
    </div>

    <div class="ngdialog-footer p-b-0 p-t-5 p-r-10 p-l-10">
      <div class="col-xs-12 justify-content-between">
        <!-- <button mat-stroked-button class="large-btn px-4" style="height: 42px" (click)="resetCard()">
          Reset
        </button> -->
        <button type="submit" mat-raised-button class="large-btn sup-btn px-4" style="height: 42px !important"
          (click)="changePaymentPreferences()">
          Update
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Payment Details Modal -->
<div class="dialog-header" *ngIf="data.type == 27">
  <h2 mat-dialog-title class="m-0">
    {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div class="row p-3 w-100 select-card-heading text-bold bg-light">
      <div class="col-md-6 text-center">
        <strong>Months</strong>
      </div>
      <div class="col-md-6 text-center">
        <strong>Recurring Amount</strong>
      </div>
    </div>
    <div class="row m-0 w-100 select-card-heading text-bold">
      <div style="cursor:pointer;max-height:350px;overflow:hidden;overflow-y: scroll;" class="col-12 p-0 mb-2">
        <div class="row p-2 border-bottom" *ngFor="let card of data.send_data.paymentList; let i=index">
          <div class="col-md-6 text-center">
            <span>Month {{i+1}}</span>
          </div>
          <div class="col-md-6 text-center">
            <span class="notranslate">${{card.value}}*</span>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-center">
        <strong>Total Payable Amount:</strong>
      </div>
      <div class="col-md-6 ps-2 text-center">
        <strong class="notranslate">${{data.send_data.totalAmount | number:'1.2-2'}}</strong>
      </div>
    </div>
    <div class="col-md-12 mt-3 p-0 text-start">
      <span class="text-muted font12">*Note: {{data.send_data.paymentList[0].value>100?'3.00%':'$3.00'}} transaction fee
        will be charged on every transaction.</span>
    </div>
  </div>
</div>

<!-- Introduction Modal - Nofee -->
<div class="dialog-header intro-modal" *ngIf="data.type == 28">
  <h2 mat-dialog-title class="text-center">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-8 col-sm-6 col-xs-12">
        <div id="videoPlayer">
          <iframe src="https://player.vimeo.com/video/493630124?autoplay=1&loop=0&autopause=0" style="width: 100%;"
            height="403" frameborder="0" allow="autoplay; fullscreen" allowfullscreen controls="true"></iframe>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 congratulations fadeInUp">
              <div class="col-lg-12 col-md-12 col-sm-12 text-center m-t-20">
                  <img src="assets/img/svg/video_watched.svg" height="240" width="240" />
              </div>
              <h2 class="text-center m-0">Congratulations</h2>
              <p class="owner_name mt-3 text-center">You have just finished the No Fee Financing Video</p>
          </div> -->
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="feature-list">
          <h2 class="feature-heading m-b-0 m-t-0">No Fee Payment Plan</h2>
          <!-- <h4 class="feature-heading m-t-0">Denefits charges dynamic interest</h4> -->
          <h5 class="feature-sub-heading">The No Fee payment plan offers unlimited access to all the
            features of <span class="notranslate">Denefits</span> you know and love but with one simple enhancement.</h5>
          <ul class="list-cont">
            <li>Zero-percent Service Fee (Usually 10%).</li>
            <li>You get the exact amount you finance the customer for.</li>
            <li>You keep 100% of your down payment.</li>
            <li><span class="notranslate">Denefits</span> charges the interest so you don't have to worry about how much to charge.</li>
            <li>Still No Credit Check.</li>
            <li>We will no longer require 10% down payment for protected payments on new contracts.
            </li>
          </ul>
        </div>
        <div class="col-lg-12 text-center">
          <button class="rounded" mat-raised-button mat-dialog-close (click)="dialogRef.close('0')">Start a Payment
            Plan</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cancel Confirmation Modal -->
<div class="dialog-header" *ngIf="data.type == 29">
  <h2 mat-dialog-title class="text-center">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12 text-center p-2">
        <span>Are you sure you want to cancel ?</span>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12 text-center p-2 mt-3">
        <div class="col-md-12 justify-content-between">
          <button class="rounded me-2" mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
          <button class="rounded" mat-raised-button type="submit" (click)="dialogRef.close(1)"
            [routerLink]="['/app/dashboard']">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- How to Change Payment Dates - Video -->
<div class="dialog-header" *ngIf="data.type == 30">
  <h2 mat-dialog-title class="text-center">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div id="videoPlayer">
          <iframe src="https://player.vimeo.com/video/418473120?autoplay=0&loop=0&autopause=0" style="width: 100%;"
            height="403" frameborder="0" allow="autoplay; fullscreen" allowfullscreen controls="true"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Remove Document -->
<div class="dialog-header" *ngIf="data.type == 31">

  <h2 mat-dialog-title style="text-transform: initial !important;">
    {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div class="px-3">
    <div mat-dialog-content class="p-3">
      <h4 class="h5">Are you sure you want to delete the Proof of ID?</h4>
    </div>
    <div class="d-flex justify-content-between" mat-dialog-actions>
      <button class="mat-stroked-button mat-dialog-close close_btn" (click)="dialogRef.close('0')">Close</button>
      <button class="sup-btn" mat-raised-button (click)="dialogRef.close('1')">Delete</button>
    </div>
  </div>

</div>

<!-- Verify Customer -->
<div class="dialog-header verify-user" *ngIf="data.type == 32">
  <div *ngIf="customerVerified" class="animated">
    <h2 mat-dialog-title class="text-center h3">Congratulations</h2>
    <div class="text-center">
      <img class="icons img-responsive" src="assets/img/svg/verified_patient.svg" style="margin:0 auto;" />
      <h4 class="mt-5 w-100 text-bold">Your customer's data has been successfully verified and they are now <span
          class="text-success-custom">APPROVED</span></h4>
    </div>
  </div>
  <div class="animated verify-customer" *ngIf="!customerVerified">
    <h2 mat-dialog-title class="text-center h3">{{data.title}}</h2>
    <div mat-dialog-content class="p-3">
      <div class="loader">
        <ul class="d-flex justify-content-center text-center m-0 p-0">
          <li [ngClass]="verifyingStep.counter>0 ? 'verified-text':''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24.52" height="26.271" viewBox="0 0 24.52 26.271"
                class="active">
                <g id="calendar_5_" data-name="calendar (5)" transform="translate(-2)">
                  <path id="Path_359" data-name="Path 359"
                    d="M26.081,1.751H23.016V.438A.437.437,0,0,0,22.579,0H19.514a.437.437,0,0,0-.438.438V1.751H9.443V.438A.437.437,0,0,0,9.005,0H5.941A.437.437,0,0,0,5.5.438V1.751H2.438A.437.437,0,0,0,2,2.189V25.833a.437.437,0,0,0,.438.438H26.081a.437.437,0,0,0,.438-.438V2.189A.437.437,0,0,0,26.081,1.751ZM19.952.876h2.189V3.5H19.952V.876ZM6.378.876H8.568V3.5H6.378V.876Zm-3.5,1.751H5.5V3.941a.437.437,0,0,0,.438.438H9.005a.437.437,0,0,0,.438-.438V2.627h9.633V3.941a.437.437,0,0,0,.438.438h3.065a.437.437,0,0,0,.438-.438V2.627h2.627V6.568H2.876Zm0,22.768V7.443H25.643V25.395Z"
                    transform="translate(0)" fill="#707070" />
                  <path id="Path_360" data-name="Path 360"
                    d="M22.822,23H11V35.7H27.638V23H22.822Zm-3.065.876h3.065v3.065H19.757Zm3.065,7.005H19.757V27.816h3.065Zm-7.005-3.065h3.065v3.065H15.816Zm0-3.941h3.065v3.065H15.816Zm-3.941,0h3.065v3.065H11.876Zm0,3.941h3.065v3.065H11.876Zm3.065,7.005H11.876V31.757h3.065Zm3.941,0H15.816V31.757h3.065Zm3.941,0H19.757V31.757h3.065Zm3.941,0H23.7V31.757h3.065Zm0-3.941H23.7V27.816h3.065Zm0-7.005v3.065H23.7V23.876Z"
                    transform="translate(-5.059 -12.93)" fill="#707070" />
                </g>
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 1 ? 'Verifying Date of Birth' : 'Date of Birth Verified'
                }}</span>
          </li>
          <li [ngClass]="verifyingStep.counter>1 ? 'verified-text':''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.931" height="27.029" viewBox="0 0 18.931 27.029">
                <g id="placeholder" transform="translate(-8.202)">
                  <path id="Path_363" data-name="Path 363"
                    d="M24.012,12a3.455,3.455,0,1,0,3.455,3.455A3.46,3.46,0,0,0,24.012,12Zm0,5.923a2.468,2.468,0,1,1,2.468-2.468A2.471,2.471,0,0,1,24.012,17.923Z"
                    transform="translate(-6.256 -6.077)" fill="#707070" />
                  <path id="Path_364" data-name="Path 364"
                    d="M24.362,2.773a9.465,9.465,0,0,0-13.387,0,10.782,10.782,0,0,0-.89,13.3l7.584,10.952,7.572-10.937A10.786,10.786,0,0,0,24.362,2.773Zm.078,12.742-6.772,9.779L10.886,15.5a9.741,9.741,0,0,1,.788-12.029,8.478,8.478,0,0,1,11.99,0A9.745,9.745,0,0,1,24.44,15.515Z"
                    transform="translate(0 0)" fill="#707070" />
                </g>
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 2 ? 'Verifying Address' : 'Address Verified' }}</span>
          </li>
          <li [ngClass]="verifyingStep.counter>2 ? 'verified-text':''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="25.111" height="19.252" viewBox="0 0 25.111 19.252">
                <g id="email" transform="translate(0 -59.733)">
                  <g id="Group_237" data-name="Group 237" transform="translate(0 59.733)">
                    <g id="Group_236" data-name="Group 236">
                      <path id="Path_365" data-name="Path 365"
                        d="M23.856,59.733H1.256A1.256,1.256,0,0,0,0,60.989V77.73a1.256,1.256,0,0,0,1.256,1.256h22.6a1.256,1.256,0,0,0,1.256-1.256V60.989A1.256,1.256,0,0,0,23.856,59.733Zm.419,18a.418.418,0,0,1-.419.419H1.256a.418.418,0,0,1-.419-.419V60.989a.418.418,0,0,1,.419-.419h22.6a.418.418,0,0,1,.419.419V77.73Z"
                        transform="translate(0 -59.733)" fill="#707070" />
                      <path id="Path_366" data-name="Path 366"
                        d="M55.514,93.867a.418.418,0,0,0-.306.1l-9.656,8.111a.837.837,0,0,1-1.077,0l-9.655-8.111a.419.419,0,0,0-.538.641l9.655,8.111a1.672,1.672,0,0,0,2.154,0L55.747,94.6a.419.419,0,0,0-.233-.738Z"
                        transform="translate(-32.459 -92.191)" fill="#707070" />
                      <path id="Path_367" data-name="Path 367"
                        d="M40.382,272.935a.419.419,0,0,0-.4.13l-5.859,6.278a.419.419,0,1,0,.612.571l5.859-6.278a.419.419,0,0,0-.208-.7Z"
                        transform="translate(-32.332 -262.469)" fill="#707070" />
                      <path id="Path_368" data-name="Path 368"
                        d="M341.932,273.065a.419.419,0,1,0-.612.571l5.859,6.278a.419.419,0,0,0,.612-.571Z"
                        transform="translate(-324.466 -262.469)" fill="#707070" />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 3 ? 'Verifying Email' : 'Email Verified' }}</span>
          </li>
          <li [ngClass]="verifyingStep.counter>3 ? 'verified-text':''" class="phone">
            <span class="icon">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 66 66">
                  <g id="ic_phn" transform="translate(-531 -294)">
                    <g id="phone-call">
                      <g id="Group_1" data-name="Group 1">
                        <g id="Path_6" data-name="Path 6">
                          <path id="Path_49" data-name="Path 49" d="M574.23,331.147a3.514,3.514,0,0,0-2.55-1.17,3.637,3.637,0,0,0-2.581,1.162l-2.384,2.377c-.2-.106-.392-.2-.581-.3-.272-.136-.528-.264-.747-.4a25.9,25.9,0,0,1-6.21-5.659,15.307,15.307,0,0,1-2.037-3.214c.619-.566,1.192-1.154,1.751-1.72.211-.211.423-.43.634-.641a3.462,3.462,0,0,0,0-5.222l-2.06-2.06c-.234-.234-.475-.475-.7-.717-.453-.468-.928-.951-1.419-1.4a3.571,3.571,0,0,0-2.528-1.109,3.7,3.7,0,0,0-2.566,1.109l-.015.015-2.568,2.582a5.523,5.523,0,0,0-1.637,3.509,13.234,13.234,0,0,0,.966,5.6,32.493,32.493,0,0,0,5.772,9.628,35.511,35.511,0,0,0,11.824,9.259,18.409,18.409,0,0,0,6.64,1.962c.158.008.324.015.475.015a5.684,5.684,0,0,0,4.354-1.871c.008-.015.023-.023.03-.038a17.183,17.183,0,0,1,1.32-1.366c.324-.309.656-.634.981-.973a3.765,3.765,0,0,0,1.139-2.611,3.625,3.625,0,0,0-1.162-2.588Zm2.7,7.946c-.008,0-.008.008,0,0-.294.317-.6.6-.921.921a19.686,19.686,0,0,0-1.453,1.508,3.638,3.638,0,0,1-2.837,1.2c-.113,0-.234,0-.347-.008a16.371,16.371,0,0,1-5.886-1.766,33.52,33.52,0,0,1-11.139-8.722,30.635,30.635,0,0,1-5.433-9.047,10.779,10.779,0,0,1-.845-4.724,3.464,3.464,0,0,1,1.041-2.241l2.573-2.573a1.717,1.717,0,0,1,1.147-.536,1.612,1.612,0,0,1,1.1.528l.023.023c.46.43.9.875,1.358,1.351.234.241.475.483.717.732l2.06,2.06a1.44,1.44,0,0,1,0,2.339c-.219.219-.43.438-.649.649-.634.649-1.237,1.253-1.894,1.841-.015.015-.03.023-.038.038a1.539,1.539,0,0,0-.392,1.713l.023.068a16.534,16.534,0,0,0,2.437,3.977l.008.008a27.7,27.7,0,0,0,6.7,6.1,10.4,10.4,0,0,0,.928.506c.272.136.528.264.747.4.03.015.06.038.091.053a1.635,1.635,0,0,0,.747.189,1.613,1.613,0,0,0,1.147-.521l2.581-2.581a1.711,1.711,0,0,1,1.139-.566,1.535,1.535,0,0,1,1.087.551l.015.015,4.158,4.158a1.492,1.492,0,0,1,.271,2.093,1.564,1.564,0,0,1-.263.264Z" fill="#63c8f6"/>
                        </g>
                        <g id="Path_7" data-name="Path 7">
                          <path id="Path_50" data-name="Path 50" d="M565.295,317.5a9.71,9.71,0,0,1,7.908,7.908,1.013,1.013,0,0,0,1,.845,1.274,1.274,0,0,0,.174-.015,1.021,1.021,0,0,0,.839-1.174v0a11.744,11.744,0,0,0-9.568-9.568,1.024,1.024,0,0,0-1.177.83,1.008,1.008,0,0,0,.808,1.174Z" fill="#707070"/>
                        </g>
                        <g id="Path_8" data-name="Path 8">
                          <path id="Path_51" data-name="Path 51" d="M581.684,324.771a19.336,19.336,0,0,0-15.755-15.755,1.017,1.017,0,0,0-.332,2.007h0a17.27,17.27,0,0,1,14.08,14.08,1.013,1.013,0,0,0,1,.845,1.283,1.283,0,0,0,.174-.015,1,1,0,0,0,.837-1.14Z" fill="#707070"/>
                        </g>
                      </g>
                    </g>
                    <g id="Ellipse_6" data-name="Ellipse 6">
                      <g id="Group_36" data-name="Group 36">
                        <circle id="Ellipse_14" data-name="Ellipse 14" cx="33" cy="33" r="33" transform="translate(531 294)" fill="none"/>
                      </g>
                      <g id="Group_37" data-name="Group 37">
                        <path id="Path_52" data-name="Path 52" d="M564,360a33,33,0,1,1,33-33A33.038,33.038,0,0,1,564,360Zm0-64a31,31,0,1,0,31,31A31.036,31.036,0,0,0,564,296Z" fill="#63c8f5"/>
                      </g>
                    </g>
                  </g>
                </svg>                 -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                  stroke="#868C88" stroke-width="1.5" stroke-miterlimit="10" />
                <path d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5" stroke="#868C88"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22 9C22 5.13 18.87 2 15 2" stroke="#868C88" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

            </span>
            <span class="text">{{verifyingStep.counter < 4 ? 'Verifying Phone Number' : 'Phone Number Verified'
                }}</span>
          </li>
          <li [ngClass]="verifyingStep.counter>4 ? 'verified-text':''">
            <span class="icon">
              <svg id="driving-license" xmlns="http://www.w3.org/2000/svg" width="28.325" height="18.952"
                viewBox="0 0 28.325 18.952">
                <path id="Path_373" data-name="Path 373"
                  d="M26.1,84.718H2.228A2.231,2.231,0,0,0,0,86.946v14.5H0a2.23,2.23,0,0,0,2.228,2.228H26.1a2.23,2.23,0,0,0,2.228-2.228h0v-14.5A2.231,2.231,0,0,0,26.1,84.718Zm-23.87.869H26.1a1.573,1.573,0,0,1,1.359,1.359v13.083H10.92c-.305,0-.553.089-.553.395s.248.395.553.395H27.457v.623A1.573,1.573,0,0,1,26.1,102.8H2.228a1.573,1.573,0,0,1-1.359-1.359v-.623H6.053c.305,0,.553-.089.553-.395s-.248-.395-.553-.395H.789V86.946a1.658,1.658,0,0,1,1.439-1.359Z"
                  transform="translate(0 -84.718)" fill="#707070" />
                <path id="Path_374" data-name="Path 374"
                  d="M270.616,150.333H273.6c.305,0,.553-.089.553-.395s-.248-.395-.553-.395h-2.987c-.305,0-.553.089-.553.395S270.311,150.333,270.616,150.333Z"
                  transform="translate(-255.122 -145.91)" fill="#707070" />
                <path id="Path_375" data-name="Path 375"
                  d="M368.1,150.333h3.071c.306,0,.553-.089.553-.395s-.248-.395-.553-.395H368.1c-.305,0-.553.089-.553.395S367.8,150.333,368.1,150.333Z"
                  transform="translate(-347.216 -145.91)" fill="#707070" />
                <path id="Path_376" data-name="Path 376"
                  d="M270.616,193.1h8.464c.305,0,.553-.089.553-.395s-.248-.395-.553-.395h-8.464c-.305,0-.553.089-.553.395S270.311,193.1,270.616,193.1Z"
                  transform="translate(-255.122 -186.314)" fill="#707070" />
                <path id="Path_377" data-name="Path 377"
                  d="M270.616,236.959h2.544c.305,0,.553-.089.553-.395s-.248-.395-.553-.395h-2.544c-.305,0-.553.089-.553.395S270.311,236.959,270.616,236.959Z"
                  transform="translate(-255.122 -227.743)" fill="#707070" />
                <path id="Path_378" data-name="Path 378"
                  d="M363.046,234.169h-2.157a1.341,1.341,0,0,0-1.339,1.339v2.082a1.341,1.341,0,0,0,1.339,1.339h2.157a1.341,1.341,0,0,0,1.339-1.339v-2.082A1.341,1.341,0,0,0,363.046,234.169Zm.471,3.421a.432.432,0,0,1-.471.471h-2.157a.423.423,0,0,1-.471-.471v-2.082c0-.265.076-.471.471-.471h2.157a.433.433,0,0,1,.471.471Z"
                  transform="translate(-339.659 -225.901)" fill="#707070" />
                <path id="Path_379" data-name="Path 379"
                  d="M270.616,281.086h2.544c.305,0,.553-.089.553-.395s-.248-.395-.553-.395h-2.544c-.305,0-.553.089-.553.395S270.311,281.086,270.616,281.086Z"
                  transform="translate(-255.122 -269.429)" fill="#707070" />
                <path id="Path_380" data-name="Path 380"
                  d="M69.625,154.2h7.8a.553.553,0,0,0,.553-.553V145.1a.553.553,0,0,0-.553-.553h-7.8a.553.553,0,0,0-.553.553v8.55A.553.553,0,0,0,69.625,154.2Zm7.485-.869H69.941V151.5l.005-.019a2.516,2.516,0,0,1,2.169-1.686h2.822a2.516,2.516,0,0,1,2.169,1.686l0,.019Zm-5-5.578a1.322,1.322,0,0,1,1.416-1.416,1.416,1.416,0,1,1-1.416,1.416Zm5,2.084a4.516,4.516,0,0,0-1.655-.863,2.271,2.271,0,0,0,.355-1.221c0-.943-.826-2.36-1.867-2.34H77.11v4.424Zm-4-4.424a2.519,2.519,0,0,0-1.867,2.34,2.271,2.271,0,0,0,.355,1.221,4.515,4.515,0,0,0-1.655.863v-4.424Z"
                  transform="translate(-65.251 -141.234)" fill="#707070" />
                <path id="Path_381" data-name="Path 381"
                  d="M144.776,358.722a.427.427,0,1,0,.161.509A.43.43,0,0,0,144.776,358.722Z"
                  transform="translate(-136.013 -343.371)" fill="#707070" />
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 5 ? 'Verifying License' : 'License Verified' }}</span>
          </li>
          <li
            [ngClass]="verifyingStep.counter>5 ? (( (!data.send_data.annual_income || data.send_data.annual_income <= 0 ) ? 'unverified-text' : 'verified-text')):''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24.472" height="24.468" viewBox="0 0 24.472 24.468">
                <g id="investment" transform="translate(0 -0.036)">
                  <g id="Group_239" data-name="Group 239" transform="translate(0 0.036)">
                    <g id="Group_238" data-name="Group 238">
                      <path id="Path_382" data-name="Path 382"
                        d="M24.467,14.683c0-3.248-1.338-7.5-5.062-9.02V4.035l1.107-.886a.422.422,0,0,0,.158-.329V.458a.422.422,0,0,0-.422-.422H18.983a.422.422,0,0,0-.3.124l-.545.545L17.594.16a.422.422,0,0,0-.3-.124H15.608a.422.422,0,0,0-.3.124l-.545.545L14.219.16a.422.422,0,0,0-.3-.124H12.655a.422.422,0,0,0-.422.422V2.82a.422.422,0,0,0,.158.329l1.107.886V5.663c-3.724,1.525-5.062,5.774-5.062,9.02a6.9,6.9,0,0,0,.35,2.242c-.181-.01-.364-.016-.546-.016H7.171a.422.422,0,0,0-.422-.422H3.375a.422.422,0,0,0-.422.422H0v.844H2.953v4.218H0v.844H2.953a.422.422,0,0,0,.422.422H6.749a.422.422,0,0,0,.422-.422v-.161l3.149,1.308a7.3,7.3,0,0,0,5.368.059l6.517-2.485a1.535,1.535,0,0,0,.862-.821,1.551,1.551,0,0,0-.273-1.684A5.851,5.851,0,0,0,24.467,14.683ZM6.328,22.393H3.8V17.331H6.328ZM13.077,2.618V.88h.669l.72.72a.422.422,0,0,0,.6,0l.72-.72h1.338l.72.72a.422.422,0,0,0,.6,0l.72-.72h.669V2.618l-.992.793H14.068Zm5.484,1.637V5.52H14.342V4.254Zm3.733,16.121a.7.7,0,0,1-.391.374l-6.517,2.485a6.454,6.454,0,0,1-4.747-.051L7.171,21.741V17.753H8.241a9.057,9.057,0,0,1,4.03.951,2.985,2.985,0,0,0,1.331.314h3.272a.633.633,0,0,1,.139,1.249c-.055.005-.109.016-.165.016H11.811v.844h5.062l.025,0a2.6,2.6,0,0,0,.974-.206l3.527-1.5a.67.67,0,0,1,.526,0,.7.7,0,0,1,.38.393A.724.724,0,0,1,22.294,20.375Zm-.251-1.8a1.5,1.5,0,0,0-.973.067l-2.735,1.161a1.459,1.459,0,0,0,.016-.155,1.476,1.476,0,0,0-1.476-1.476H13.6a2.145,2.145,0,0,1-.954-.225,9.891,9.891,0,0,0-2.907-.92,5.78,5.78,0,0,1-.46-2.346c0-3.037,1.241-7.024,4.725-8.319H18.9c3.484,1.3,4.725,5.282,4.725,8.319A5,5,0,0,1,22.042,18.578Z"
                        transform="translate(0 -0.036)" fill="#707070" />
                    </g>
                  </g>
                  <g id="Group_241" data-name="Group 241" transform="translate(5.39 20.84)">
                    <g id="Group_240" data-name="Group 240" transform="translate(0 0)">
                      <rect id="Rectangle_236" data-name="Rectangle 236" height="0.889" fill="#707070" />
                    </g>
                  </g>
                  <g id="Group_243" data-name="Group 243" transform="translate(14.764 9.316)">
                    <g id="Group_242" data-name="Group 242">
                      <path id="Path_383" data-name="Path 383"
                        d="M282.569,178.843l-1.525-.508a.313.313,0,0,1,.1-.611h1.06a.314.314,0,0,1,.313.314v.277h.844v-.277a1.158,1.158,0,0,0-1.157-1.158h-.108v-.844h-.844v.844h-.108a1.157,1.157,0,0,0-.366,2.255l1.525.508a.313.313,0,0,1-.1.611h-1.06a.314.314,0,0,1-.313-.314v-.277h-.844v.277a1.158,1.158,0,0,0,1.157,1.158h.108v.844h.844V181.1h.108a1.157,1.157,0,0,0,.366-2.255Z"
                        transform="translate(-279.985 -176.036)" fill="#707070" />
                    </g>
                  </g>
                  <g id="Group_245" data-name="Group 245" transform="translate(11.811 7.629)">
                    <g id="Group_244" data-name="Group 244">
                      <path id="Path_384" data-name="Path 384"
                        d="M228.64,144.036a4.64,4.64,0,1,0,4.64,4.64A4.64,4.64,0,0,0,228.64,144.036Zm0,8.437a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,228.64,152.473Z"
                        transform="translate(-224 -144.036)" fill="#707070" />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 6 ? 'Verifying Income' : (!data.send_data.annual_income ||
                data.send_data.annual_income <=0 ? 'Income Not Provided' : 'Income Verified' )}}</span>
          </li>
          <li
            [ngClass]="verifyingStep.counter>6 ? ((!(data.send_data.employer_name && data.send_data.employerPhone && data.send_data.employer_address) ? 'unverified-text' : 'verified-text')):''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.979" height="25.182" viewBox="0 0 27.979 25.182">
                <path id="suitcase_1_" data-name="suitcase (1)"
                  d="M26.581,4.2H20.518V2.332A2.334,2.334,0,0,0,18.187,0H9.793A2.334,2.334,0,0,0,7.461,2.332V4.2H1.4A1.4,1.4,0,0,0,0,5.6v10.38a1.405,1.405,0,0,0,.933,1.317v6.49a1.4,1.4,0,0,0,1.4,1.4H25.648a1.4,1.4,0,0,0,1.4-1.4V17.293a1.406,1.406,0,0,0,.933-1.317V5.6a1.4,1.4,0,0,0-1.4-1.4ZM8.394,2.332a1.4,1.4,0,0,1,1.4-1.4h8.394a1.4,1.4,0,0,1,1.4,1.4V4.2h-.933V2.332a.466.466,0,0,0-.466-.466H9.793a.466.466,0,0,0-.466.466V4.2H8.394ZM17.72,4.2H10.259V2.8H17.72Zm8.394,19.586a.466.466,0,0,1-.466.466H2.332a.466.466,0,0,1-.466-.466v-6.33l10.259,1.415v1.184a1.4,1.4,0,0,0,1.4,1.4h.933a1.4,1.4,0,0,0,1.4-1.4V18.868l10.259-1.415ZM14.923,20.052a.466.466,0,0,1-.466.466h-.933a.466.466,0,0,1-.466-.466v-2.8a.466.466,0,0,1,.466-.466h.933a.466.466,0,0,1,.466.466Zm12.125-4.076a.466.466,0,0,1-.4.462l-.129.018-10.662,1.47v-.672a1.4,1.4,0,0,0-1.4-1.4h-.933a1.4,1.4,0,0,0-1.4,1.4v.672L1.334,16.439a.466.466,0,0,1-.4-.462V5.6A.466.466,0,0,1,1.4,5.13H26.581a.466.466,0,0,1,.466.466Zm0,0"
                  fill="#707070" />
              </svg>
            </span>
            <span class="text">{{verifyingStep.counter < 7 ? 'Verifying Employer Details' :
                (!(data.send_data.employer_name && data.send_data.employerPhone && data.send_data.employer_address)
                ? 'Employer Details Missing' : 'Employer Details Verified' )}}</span>
          </li>
          <li [ngClass]="verifyingStep.counter>7 ? 'unverified-text':''">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.232" height="23.865" viewBox="0 0 29.232 23.865">
                <g id="credit-card" transform="translate(1 -46.014)">
                  <g id="Group_247" data-name="Group 247" transform="translate(-1 46.014)">
                    <g id="Group_246" data-name="Group 246" transform="translate(0 0)">
                      <path id="Path_385" data-name="Path 385"
                        d="M264.021,247.638h7.793a.46.46,0,0,0,.487-.487v-4.383a.46.46,0,0,0-.487-.487h-7.793a.46.46,0,0,0-.487.487v4.383A.46.46,0,0,0,264.021,247.638Zm.487-4.383h6.819v3.409h-6.819Z"
                        transform="translate(-248.435 -231.079)" fill="#707070" />
                      <path id="Path_386" data-name="Path 386"
                        d="M33.621,209.121h3.9a.487.487,0,0,0,0-.974h-3.9a.487.487,0,0,0,0,.974Z"
                        transform="translate(-31.186 -198.893)" fill="#707070" />
                      <path id="Path_387" data-name="Path 387"
                        d="M136.021,209.121h3.9a.487.487,0,0,0,0-.974h-3.9a.487.487,0,0,0,0,.974Z"
                        transform="translate(-127.741 -198.893)" fill="#707070" />
                      <path id="Path_388" data-name="Path 388"
                        d="M33.621,243.255h6.332a.487.487,0,1,0,0-.974H33.621a.487.487,0,0,0,0,.974Z"
                        transform="translate(-31.186 -231.079)" fill="#707070" />
                      <path id="Path_389" data-name="Path 389"
                        d="M180.148,242.28h-1.461a.487.487,0,1,0,0,.974h1.461a.487.487,0,1,0,0-.974Z"
                        transform="translate(-167.972 -231.078)" fill="#707070" />
                      <path id="Path_390" data-name="Path 390"
                        d="M27.785,51.177a1.815,1.815,0,0,0-1.315-.731L25.3,50.3V47.962a1.954,1.954,0,0,0-1.948-1.948H.948A1.954,1.954,0,0,0-1,47.962V63.548A1.956,1.956,0,0,0,.4,65.415a1.9,1.9,0,0,0,1.721,1.932l22.5,2.533h.195a1.95,1.95,0,0,0,1.948-1.656l1.461-15.634A1.893,1.893,0,0,0,27.785,51.177ZM-.026,49.423H24.327v2.922H-.026Zm.974-2.435h22.4a.977.977,0,0,1,.974.974v.487H-.026v-.487A.977.977,0,0,1,.948,46.988Zm-.974,16.56V53.32H24.327V63.548a.977.977,0,0,1-.974.974H.948A.977.977,0,0,1-.026,63.548ZM27.249,52.394,25.788,68.029a.982.982,0,0,1-1.071.877L2.263,66.373a.985.985,0,0,1-.877-.877H23.352A1.954,1.954,0,0,0,25.3,63.548V51.225l1.12.1a.833.833,0,0,1,.633.341A.986.986,0,0,1,27.249,52.394Z"
                        transform="translate(1 -46.014)" fill="#707070" />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="text">No Credit Checks</span>
          </li>
        </ul>
        <div class="mb-2">
          <span class="text-center h4 w-100 d-inline-block mt-5">Preliminary Verification <span>{{verifyingStep.counter
              <= 7 ? 'In Progress' : 'Done!' }}</span>
            </span>
            <!-- <progressbar class="progress-striped active" [max]="100" [value]="verifyingStep.loader/1.2" type="success" [animate]="true"><i></i></progressbar> -->
            <mat-progress-bar mode="buffer" style="height:20px" value="{{verifyingStep.loader/1.2}}"></mat-progress-bar>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PP - Payment Process Limits -->
<div class="dialog-header verify-user" *ngIf="data.type == 34">
  <h2 mat-dialog-title class="text-center h3">{{data.title}}</h2>
  <div mat-dialog-content class="p-3">
    <table class="table m-0" *ngIf="data.send_data.arFlow">
      <tbody>
        <tr>
          <td>Daily Transaction Amount Permitted</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.ar_daily_max_transaction_amount?'$'+(data.send_data.paymentSettings.ar_daily_max_transaction_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
        <tr>
          <td>Daily Transactions Permitted</td>
          <td class="text-end">
            {{data.send_data.paymentSettings.ar_daily_max_transaction_number?data.send_data.paymentSettings.ar_daily_max_transaction_number:0}}
          </td>
        </tr>
        <tr>
          <td>Maximum Transaction Permitted in Single Payment</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.ar_single_transaction_max_amount?'$'+(data.send_data.paymentSettings.ar_single_transaction_max_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
        <tr>
          <td>Verification Code Required Above Transaction Amount</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.ar_otp_threshold_amount?'$'+(data.send_data.paymentSettings.ar_otp_threshold_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table m-0" *ngIf="!data.send_data.arFlow">
      <tbody>
        <tr>
          <td>Daily Transaction Amount Permitted</td>
          <td class="text-righ notranslate">
            {{data.send_data.paymentSettings.daily_max_transaction_amount?'$'+(data.send_data.paymentSettings.daily_max_transaction_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
        <tr>
          <td>Daily Transactions Permitted</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.daily_max_transaction_number?data.send_data.paymentSettings.daily_max_transaction_number:0}}
          </td>
        </tr>
        <tr>
          <td>Maximum Transaction Permitted in Single Payment</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.single_transaction_max_amount?'$'+(data.send_data.paymentSettings.single_transaction_max_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
        <tr>
          <td>Verification Code Required Above Transaction Amount</td>
          <td class="text-end notranslate">
            {{data.send_data.paymentSettings.otp_threshold_amount?'$'+(data.send_data.paymentSettings.otp_threshold_amount
            | number: '1.2-2'):'$0.00'}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center pt-0" mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="dialogRef.close('0')">Done</button>
  </div>
</div>

<!-- PP - increase Processing Limit -->
<div class="dialog-header verify-user" *ngIf="data.type == 35">
  <div *ngIf="incProcessLimitPpScreen">
    <h2 mat-dialog-title class="mb-0" style="color: #0E2535; font-size:32px;font-weight:800;">{{data.title}}
      <mat-icon (click)="dialogRef.close()" class="close pull-right">
        close</mat-icon>
    </h2>
    <div style="padding: 35px;">
      <!-- <div>
        <div>
          <p class="mb-0" *ngIf="data.send_data.paymentInfo.payment_process_settings.max_card_limit > 0">Current Credit
            Card Processing Limit: <span> Up to
              ${{data.send_data.paymentInfo.payment_process_settings.max_card_limit | number}} </span></p>
          <p class="mb-0" *ngIf="!data.send_data.paymentInfo.payment_process_settings.max_card_limit">Current Credit
            Card Processing Limit: <span> N.A. </span></p>
        </div>
        <div>
          <p class="font_size_16">Current ACH Processing Limit: <span *ngIf="data.send_data.paymentInfo.payment_process_settings.max_bank_limit  > 0"> Up to
            ${{(data.send_data.paymentInfo.payment_process_settings.max_bank_limit | number )}} </span> <span
            *ngIf="!data.send_data.paymentInfo.payment_process_settings.max_bank_limit"> N.A. </span></p>
        </div>
      </div> -->
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-start">
          <img src="assets\img\svg\cardd.svg" alt="" style="width: 40px;">
          <p class="mb-0 ps-3 pe-0 fw-bold f-c-p-1 fs-14 w-auto"
            *ngIf="data.send_data.paymentInfo.payment_process_settings.max_card_limit > 0" style="word-break: break-all;">
            Current Credit Card Processing Limit: Up to ${{data.send_data.paymentInfo.payment_process_settings.max_card_limit |
            number}}</p>
          <p class="mb-0 ps-3 fw-bold f-c-p-1 fs-14 w-auto pe-0"
            *ngIf="!data.send_data.paymentInfo.payment_process_settings.max_card_limit" style="word-break: break-all;">
            Current Credit   Card Processing Limit: N.A.</p>
        </div>
        <div class="d-flex justify-content-start">
          <img src="assets\img\svg\bank.svg" alt="" style="width: 40px;">
          <p *ngIf="data.send_data.paymentInfo.payment_process_settings.max_bank_limit  > 0"
            class="mb-0 ps-3 fw-bold f-c-p-1 fs-14" style="width: 75%;">Current ACH Processing
            Limit: Up to ${{(data.send_data.paymentInfo.payment_process_settings.max_bank_limit | number )}} </p>
          <p *ngIf="!data.send_data.paymentInfo.payment_process_settings.max_bank_limit"
            class="mb-0 ps-3 fw-bold f-c-p-1 fs-14" style="width: 75%;">Current ACH Processing Limit:
            N.A.</p>
        </div>
      </div>

      <div class="mt-5 mb-2">
        <p class="mb-0 fs-16 f-c-p-1 f-w-400">To increase your processing limits, please verify by linking a bank
          account, card, or if
          applicable, by uploading essential documents.</p>
      </div>

      <div class="mb-3 d-flex justify-content-between align-items-center mt-5">
        <div style="width: 40%;">
          <div>
            <label class="m-0 p-0 fs-16 f-c-p-1 fw-bold">Card Desired Limit:</label>
          </div>
          <div class="custom-form mt-3 position-relative">
            <span *ngIf="ppCardAmount != null && ppCardAmount != ''" class="pt-2 fw-bold "
              style="position: absolute;left: 13px;bottom: 12px;">$ </span>
            <input class="input_field ps-3 pt-2 notranslate" appDecimaNumber autofocus [ngClass]="{dollar_input1: ppCardAmount}"
              [(ngModel)]="ppCardAmount" (keypress)="validateNumValue($event);"
              onKeyPress="if(this.value.length==7) return false;" max="99999" maxlength="8" min="1" type="text"
              pattern="^[0-9]+$" required />
            <label for="text" class="label-name">
              <span class="content-name" style="color: #596775 !important;
                  font-weight: 400 !important;">
                Amount
              </span>
            </label>
          </div>

        </div>

        <div style="width: 40%;">
          <div>
            <label class="m-0 p-0 fs-16 f-c-p-1 fw-bold">ACH Desired Limit:</label>
          </div>
          <div class="custom-form  mt-3 position-relative">
            <span *ngIf="ppBankAmount != null && ppBankAmount !=''" class="pt-2 fw-bold "
              style="position: absolute;left: 13px;bottom: 12px;">$ </span>
            <input class="input_field ps-3 pt-2 notranslate" autofocus appDecimaNumber [ngClass]="{dollar_input1: ppBankAmount}"
              [(ngModel)]="ppBankAmount" (keypress)="validateNumValue($event);"
              onKeyPress="if(this.value.length==7) return false;" max="99999" maxlength="8" min="1" type="text"
              required />
            <label for="text" class="label-name">
              <span class="content-name" style="color: #596775 !important;
                font-weight: 400 !important;">
                Amount
              </span>
            </label>
          </div>
        </div>
      </div>

      <div class="mt-4 pt-0 mb-3">
        <button style="background-color:#E9F1FF; color: #007bff; padding: 20px 0px;" (click)="dialogRef.close()"
          class="d-block w-100 rounded">May be later</button>
        <button style="background-color:#007bff; color: white; padding: 20px 0px;" type="button"
          (click)="incProcessLimitPp()" class="d-block w-100 rounded mt-3">Proceed</button>
      </div>

    </div>
  </div>

  <div [ngClass]="!incProcessLimitPpScreen ? 'd-block':'d-none'">
    <h2 mat-dialog-title class="h3 mb-0 ">
      <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
    </h2>
    <div class="px-3" style="width: 90%;margin: 0px auto;">
      <div>
        <p class="f-w-800 f-c-p-4" style="font-size: 24px;">Business Verification</p>
        <p class="f-c-p-3 fs-12 f-w-400">Note: To quickly have access to payments, please verify your bank by linking it
          to your <span class="notranslate">Denefits</span> account. Linking your bank account is the quickest way to verify your information.</p>
      </div>
      <div>
        <ul class="d-flex justify-content-start align-item-center border-bottom">
          <li class="me-4 fs-16 fw-bold" style="cursor: pointer;color: #596775;"
            [ngClass]="{show_design: businessVerfStep==1}" (click)="businessVerfStep=1"
            [ngClass]="{'li_pp_txt_danger':data.send_data.acc_details.auth_bank_status =='verification_failed' || data.send_data.acc_details.auth_bank_status =='reauthenticate','li_pp_txt_success': data.send_data.acc_details.auth_bank_status =='verified', 'li_pp_txt_warn':data.send_data.acc_details.auth_bank_status =='pending','current_step': businessVerfStep == 1 && data.send_data.acc_details.auth_bank_status =='not_added'}">
            Verify Bank Account</li>
          <li class="fs-16 fw-bold" style="cursor: pointer; color: #596775   ;"
            [ngClass]="{show_design: businessVerfStep==2}" (click)="businessVerfStep=2"
            [ngClass]="{'li_pp_txt_success': data.send_data.acc_details.is_auth_card_added == 1, 'current_step': data.send_data.acc_details.is_auth_card_added != 1 && businessVerfStep == 2, 'last-li': !data.send_data.paymentInfo.payment_process_settings.show_upload_doc}">
            Verify Card</li>
          <li class="" (click)="businessVerfStep=3"
            [ngClass]="{'li_pp_txt_success': data.send_data.acc_details.auth_doc_uploaded >= 1 &&  data.send_data.acc_details.auth_rejected_count==0, 'current_step':businessVerfStep == 3 && data.send_data.acc_details.auth_doc_uploaded == 0 && data.send_data.acc_details.auth_rejected_count == 0 ,'li_pp_txt_warn':data.send_data.acc_details.auth_rejected_count > 0}"
            *ngIf="data.send_data.paymentInfo.payment_process_settings.show_upload_doc">Verify Documents</li>
        </ul>


        <!-- -- Step 1 --  -->
        <div *ngIf="businessVerfStep == 1">
          <div>
            <p class="f-c-p-3 fs-14 f-w-400">To prevent any payment delays, please link a bank account.</p>
          </div>
          <div *ngIf="data.send_data.acc_details.auth_bank_status =='not_added'">
            <div class="mt-3">
              <!-- <button mat-stroked-button (click)="businessVerfStep=2;checkStepBusinessVer();">Next</button> -->
              <button style="background-color:#1581E5; color: white; padding: 16px 24px;box-shadow: 0px 4px 8px rgba(21, 129, 229, 0.22);
              border-radius: 6px;" type="button" (click)="addBank();">Add Bank</button>
            </div>

            <div class="mt-3">
              <p class="f-c-p-3 fs-14 f-w-400" style="display: inline-flex;"><span class="notranslate">Denefits</span><img
                  src="assets\img\svg\plaid_icon.svg" alt="" class="px-1">to connect your account</p>
            </div>
          </div>

          <div class="text-start col-md-12" *ngIf="data.send_data.acc_details.auth_bank_status =='verified'">
            <p>Your bank has been added successfully.</p>
            <div class="">
              <div *ngFor="let card of data.send_data.acc_details.auth_bank; let i=index" style="cursor:pointer"
                class="col-12 bg-light d-flex justify-content-between align-items-center p-2 mb-2 ">
                <p class="m-0 col-lg-7 col-md-7 col-sm-8 col-xs-12 p-l-0">
                  <i class="fa fa-bank lightGreyIcon"></i>&nbsp;&nbsp;XXXX-XXXX-{{card.last4}}
                </p>
                <div class="col-lg-5 col-md-5 col-sm-4 col-xs-12 p-r-0 text-end">
                  <p class="m-0" style="color:#36af47;text-align:right" *ngIf="card.status=='verified'">
                    <i class="p-l-15 fa fa-check-circle greenIcon"></i>&nbsp;&nbsp;Verified
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- -- Step 2 --  -->
        <div class="row auth_step m-0" [ngClass]="businessVerfStep == 2 ? 'd-block':'d-none'">
          <div class="text-start" *ngIf="data.send_data.acc_details.auth_card.length">
            <p class="col-md-12 mb-1 ps-0">Your card has been added successfully.</p>
            <div class="">
              <div *ngFor="let card of data.send_data.acc_details.auth_card; let i=index" style="cursor:pointer"
                class="col-12 bg-light d-flex justify-content-between align-items-center p-2 mb-2 ">
                <div class="light-purple p-2 d-flex align-items-center" [class.active]="card.active">
                  <span style="line-height:0;">
                    <img style="width:24px;"
                      [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                      *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express';else no_card " />
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>
                  </span>
                  <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-between align-items-center">
              <button mat-stroked-button (click)="businessVerfStep=1">Back</button>
              <button class="ms-2" mat-raised-button
                *ngIf="data.send_data.paymentInfo.payment_process_settings.show_upload_doc"
                (click)="businessVerfStep=3">Next</button>
            </div>
          </div>
          <p class="f-c-p-3 fs-14 f-w-400">In order to avoid delays with payments, please add a credit card.</p>
          <div></div>
          <div class="text-start" *ngIf="!data.send_data.acc_details.auth_card.length">
            <!-- <p class="col-md-12 ps-0">In order to avoid delays with payments, please add a credit card.</p> -->
            <form #addCardForm="ngForm" (ngSubmit)="addCardBusinessPP(addCardForm)">
              <div>
                <div class="custom-form ">
                  <input class="input_field pt-3 ps-3" [(ngModel)]="payment_option.cardName" name="cardholder_name"
                    #cardholder_name="ngModel" trim  required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Card Holder Name
                    </span>
                  </label>
                </div>

                <div class="form-group mt-2">
                  <!-- <label class="form-label w-100">Card Number</label> -->
                  <div class="stripe-card mb-0" id="pp_add_card" style="height: 59px;"></div>
                  <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center"
                    style="padding: 10px 15px 0px;">
                    {{new_address.cardError}}</p> -->
                </div>

                <!-- <div class="form-check mt-3 mb-3">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1">
                  <label class="form-check-label f-c-p-1 fs-14 f-w-400" for="exampleCheck1">Save Card</label>
                </div> -->
              </div>

              <div class="d-flex justify-content-center align-items-center">
                <!-- <button mat-stroked-button (click)="businessVerfStep=1">Back</button> -->
                <button style="background: #1581E5;
                box-shadow: 0px 4px 8px rgba(21, 129, 229, 0.22);
                border-radius: 6px;padding: 16px 24px;color: white;" type="submit" class="w-100">Save</button>
                <button mat-raised-button (click)="businessVerfStep=3"
                  *ngIf="data.send_data.paymentInfo.payment_process_settings.show_upload_doc" class="ms-2">Next</button>
              </div>
            </form>


          </div>
        </div>
        <!-- -- Step 3 --  -->
        <div class="row auth_step m-0" *ngIf="businessVerfStep == 3">
          <div class="">
            <p class="col-md-12  m-b-10">We will confirm documents uploaded with the information you provided when you
              first set up your <span class="notranslate">Denefits</span> account.</p>
            <div class="row m-0">
              <div class="col-md-12 p-l-0 p-r-0">
                <div *ngFor="let doc of data.send_data.acc_details.auth_docs; let i=index">
                  <div class="row m-b-10 p-l-15 p-r-15">
                    <div class="col-md-6 col-sm-6 col-xs-7 text-start" style="display:flex">
                      <span>{{(i+1) + '. '}}</span>
                      <label *ngIf="doc.doc_uploaded!=1 && doc.type"> {{doc.name}}</label>
                      <span *ngIf="doc.doc_uploaded!=1 && !doc.type">
                        <input type="text" [(ngModel)]="doc.name" class="form-control m-l-5" maxlength="50"
                          style="height:30px" placeholder="Name" />
                      </span>
                      <label style="color:#3ba3e2;margin-left:5px;" *ngIf="doc.doc_uploaded==1"><a
                          href="{{doc.doc_url}}" target="_blank" style="color: #3791e5;">{{doc.name}} </a></label>

                    </div>
                    <div class="col-md-3 col-sm-3 col-xs-5 hide_400">
                      <label *ngIf="doc.is_approved==0 && doc.is_rejected==0" style="color: #3791e5;"> Uploaded</label>
                      <label *ngIf="doc.is_approved==1" style="color: #27c24c;">Approved </label>
                      <label *ngIf="doc.is_rejected==1" style="color: #ff5858;" class="m-l-10"> Denied
                        <!-- <i  class="fa fa-md fa-info-circle m-l-5" style="display: inline-block !important;" *ngIf="doc.is_rejected==1" uib-popover=" Reason : {{doc.reason}}" popover-trigger="'mouseenter'"></i>  -->
                      </label>
                      <span class="" *ngIf="doc.doc_uploaded!=1">
                        <label class="text-primary-custom upload_docment" for="{{i}}-doc"><strong>Upload Document
                          </strong></label>
                        <input type="file" style="display: none;" id="{{i}}-doc" (change)="uploadProofId($event,i)"
                          accept=".png,.jpg,.jpeg,.pdf" />
                      </span>
                    </div>
                    <div class="col-md-3 col-sm-3 col-xs-5 hide_400">
                      <button class="delete_btn" (click)="deleteBussAuthDoc(doc);"
                        *ngIf="doc.doc_uploaded==1 && doc.is_approved!=1 && doc.is_rejected!=1">Delete</button>
                      <button class="delete_btn" (click)="removeMoreDocs(i);"
                        *ngIf="doc.doc_uploaded!=1 && !doc.type">Delete</button>
                      <span class="" *ngIf="doc.doc_uploaded==1 && doc.is_rejected==1">
                        <label class="text-primary-custom upload_docment" for="{{i}}-doc2"
                          style="cursor:pointer;color:#a1a1a1;font-size:15px"><strong>Change Document </strong></label>
                        <input type="file" style="display: none;" id="{{i}}-doc2" (change)="uploadProofId($event,i)"
                          accept=".png,.jpg,.jpeg,.pdf" />
                      </span>
                    </div>

                    <div class="col-md-3 col-sm-3 col-xs-5 display_400">
                      <i title="Uploaded" *ngIf="doc.is_approved==0 && doc.is_rejected==0"
                        style="color: #3791e5;margin-top:-10px;" class="fa fa-upload m-r-5"></i>
                      <i title="Approved" *ngIf="doc.is_approved==1" style="color: #27c24c;"
                        class="fa fa-check-circle"></i>
                      <i title="Delete" style="color: #ff5858;margin-top:-10px;" class="fa fa-trash"
                        (click)="deleteBussAuthDoc(doc);"
                        *ngIf="doc.doc_uploaded==1 && doc.is_approved!=1 && doc.is_rejected!=1"></i>

                      <span class="" *ngIf="doc.doc_uploaded!=1 || (doc.doc_uploaded==1 && doc.is_rejected==1)">
                        <label class="text-primary-custom upload_docment" title="Upload document" for="{{i}}-doc3"
                          style="cursor:pointer;color:#a1a1a1;font-size:15px"><i
                            class="fa fa-plus-circle upload_docment" style="color:#a1a1a1"></i></label>
                        <input type="file" style="display: none;" id="{{i}}-doc3" (change)="uploadProofId($event,i)"
                          accept=".png,.jpg,.jpeg,.pdf" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="!hide_add_more_btn.length">
              <div class="col-md-12 text-start ">
                <label class="text-primary-custom upload_docment ps-3 d-flex justify-content-start align-items-center"
                  style="cursor:pointer;color:#a1a1a1;font-size:15px" (click)="addMoreDocs();"><strong>Add More
                    Documents </strong>
                  <mat-icon style="color:#a1a1a1">add_circle</mat-icon>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <div class="p-l-15">
                  <label>Note</label>
                  <textarea type="text" [(ngModel)]="notes" class="form-control" maxlength="500"
                    placeholder="Enter note" rows="3"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 mt-3 d-flex justify-content-center align-items-center">
            <button mat-stroked-button (click)="businessVerfStep=2;checkStepBusinessVer();">Back</button>
            <button class="ms-2" mat-raised-button (click)="docRequest()"
            [disabled]="doc_uploaded_disabled">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PP - Thank you Model of Document -->
<div class="dialog-header verify-user" *ngIf="data.type == 36">
  <h2 mat-dialog-title class="text-center h3">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3 text-center">
    <h3>Thank you for adding your Document.</h3>
    <p>Your concern has been submitted to our team. We will reply soon via email.</p>
  </div>
</div>


<!-- PP - Instant Payment Card Add -->
<div class="dialog-header verify-user" *ngIf="data.type == 37">
  <h2 mat-dialog-title class="text-start h3 border py-3">
    <span class="ms-2">{{data.title}}</span>
    <mat-icon (click)="dialogRef.close()" class="close close-sign pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="text-center">
    <h5 class="text-center step-heading text-bold ms-4 d-flex align-items-center">
      <span class="me-1">{{data.action || 'Add'}} your business debit card to receive your
        instant payout </span>
      <span [tooltip]="'To receive your Instant Payout, provide your debit card linked to your bank account.'"
        [customClass]="'dark-theme-tooltip'" [placement]="'right'">
        <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
      </span>
    </h5>
    <div class="clearfix"></div>
    <div class="col-md-12 mt-3 ">
      <form #addInstantCardPp="ngForm" (ngSubmit)="addInstantCard(addInstantCardPp)">
        <div class="row me-0 ms-0 w-100">
          <div class="col-md-11 form-cont">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Card holder Name</mat-label>
              <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
                placeholder="Enter card holder name" trim  required>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <div class="row align-items-center">
              <div class="col-md-11">
                <div class="stripe-card" id="add_instant_card"></div>
                <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
                  {{new_address.cardError}}</p> -->
              </div>
              <div class="col-md-1 ps-0">
                <ng-template #inHouseTooltip>
                  <div>
                    <h6>List of all supported debit cards</h6>
                    <p>For more information <br><a href="javascript:void(0);" class="btn"
                        (click)="showSupportedDebitCard();t3.close()">Click here</a></p>
                  </div>
                </ng-template>
                <i [ngbTooltip]="inHouseTooltip" tooltipClass="payment-custom-tooltip ms-1" (mouseover)="t3.toggle()"
                  triggers="manual" [autoClose]="'outside'" placement="right" container="body" #t3="ngbTooltip"
                  style="line-height: 17px; margin-top: -10px; display: inline-block;">
                  <mat-icon aria-hidden="false" aria-label="info outline">info_outline</mat-icon>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 mt-3 d-flex align-items-center">
          <button class="ms-3 px-4" mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Close</button>
          <button class="ms-2 px-3 sup-btn" mat-raised-button type="submit">{{data.action || 'Add'}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- PP - Instant Bank Name List -->
<div class="dialog-header verify-user" *ngIf="data.type == 38">
  <h2 mat-dialog-title class="text-start h3 mb-0">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3 text-center">
    <div class="clearfix"></div>
    <div class="col-md-12 mt-3 ">
      <div class="col-md-4 col-sm-8 p-15">
        <div class="input-group border" style="width:100%">
          <input type="text" placeholder="Search" class="form-control border-0" [(ngModel)]="searchDebitBank"
            (keyup)="getFilteredInstantPayoutSupoortBanks($event.target.value)">
          <span title="Clear" class="input-group-addon d-flex align-items-center"
            (click)="searchDebitBank = '';getFilteredInstantPayoutSupoortBanks('')" *ngIf="searchDebitBank">
            <mat-icon>close</mat-icon>
          </span>
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-start debit-card-list w-100">
        <ul>
          <li style="text-align: left;" class="ms-3" *ngFor="let d of filtered_banks; let i=index">
            {{d.card_name}}
          </li>
        </ul>
      </div>
      <div *ngIf="filtered_banks_count == 0">
        No records
      </div>
      <div class="col-md-12 mt-3 float-left w-100 text-center" *ngIf="filtered_banks_count > filtered_banks.length">
        <a class="text-primary-custom" [routerLink]="['/app/support-instant']" (click)="dialog.closeAll();">View
          More</a>
      </div>
    </div>
  </div>
</div>

<!-- pay-over-time -->
<div class="dialog-header verify-user" *ngIf="data.type == 39">
  <h2 mat-dialog-title class="text-start h3 mb-0 pt-5 pe-4">{{doctorSettings.show_variable_service == 1 ?
    data.send_data.add_product.title : 'Add Service'}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="px-0 pt-3 w-100">
    <div class="row  m-0" style="padding:0px 37px;">
      <!-- common -->
      <div class="custom-form col-12 p-0 form-group">
        <input [(ngModel)]="add_product.pc_name" name="pc_name" (keypress)="mainService.handleInputSpace($event);" class="input_field  pt-2 px-3" required type="text" maxlength="100">
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3 bottom-5">
            Service Name
          </span>
        </label>
      </div>
      <!-- common -->
      <div class="col-12 p-0 position-relative">
        <div class="d-flex align-items-center mb-3">
          <div class="custom-form form-group mb-0">
            <input [(ngModel)]="add_product.website_navigation_link" name="website_navigation_link" (keypress)="mainService.handleInputSpace($event);"
              class="input_field input_field--modify pt-2 px-3">
            <label for="text" class="" [ngClass]="[!add_product.website_navigation_link  ? '' : 'label-name']">
              <span class="content-name f-c-p-3">
                Redirection URL (Optional)
              </span>
            </label>
          </div>
          <span
            [tooltip]="'Provide Redirection URL if you want to redirect users to your website after the contract creation.'"
            [customClass]="'dark-theme-tooltip'" [placementModal]="'1'" class="tooltip-text tooltip--modify">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 26px;">
          </span>
        </div>
      </div>
      <!-- common -->
      <div class="custom-form col-12 p-0 form-group" [ngClass]="{'currency_input': add_product.service_amount}">
        <input [(ngModel)]="add_product.service_amount" name="service_amount" type="text"
          class="input_field  pt-3 px-3 padding_with_dollar notranslate" required appDecimaNumber>
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3 bottom-5">
            Service Amount
          </span>
        </label>
      </div>

      <!-- inhouse -->
      <div class="col-12 p-0 position-relative" *ngIf="add_product.contract_type == 3">
        <div class="d-flex align-items-center mb-3">
          <div class="custom-form form-group mb-0">
            <input [(ngModel)]="add_product.interest_rate" name="interest_rate" trim
              class="input_field input_field--modify pt-2 px-3 notranslate" min="0" max="100" maxlength="6" required
              appDecimaNumber>
            <label for="text" class="" [ngClass]="[!add_product.interest_rate  ? '' : 'label-name']">
              <span class="content-name f-c-p-3">
                Interest Rate (%)
              </span>
            </label>
          </div>
          <span [tooltip]="'The average interest rate charged by Businesses in your area is 13%.'"
            [customClass]="'dark-theme-tooltip'" [placementModal]="'1'" class="tooltip-text tooltip--modify">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 26px;">
          </span>
        </div>
      </div>
      <!-- inhouse case -->
      <div class="col-12 p-0"
        *ngIf="downpayment_setting.new_ten_downpayment_percent>0 && add_product.contract_type == 3">
        <div class="custom-form col-12 p-0 form-group" [ngClass]="{'currency_input': add_product.dp_amount}">
          <input [(ngModel)]="add_product.dp_amount" name="dp_amount" type="text"
            class="input_field  pt-3 px-3 padding_with_dollar notranslate" required appDecimaNumber>
          <label for="text" class="label-name ">
            <span class="content-name f-c-p-3 bottom-5">
              Downpayment Amount
            </span>
          </label>
        </div>
      </div>
      <!-- nofee case -->
      <div class="col-12 p-0" *ngIf="downpayment_setting.downpayment_percent>0 && add_product.contract_type == 2">
        <div class="custom-form col-12 p-0 form-group" [ngClass]="{'currency_input': add_product.dp_amount}">
          <input [(ngModel)]="add_product.dp_amount" name="dp_amount" type="text"
            class="input_field  pt-3 px-3 padding_with_dollar notranslate" required appDecimaNumber>
          <label for="text" class="label-name ">
            <span class="content-name f-c-p-3 bottom-5">
              Downpayment Amount
            </span>
          </label>
        </div>
      </div>
       <!-- ez deffered case -->
      <div class="col-12 p-0" *ngIf="downpayment_setting.di_downpayment_percent>0 && add_product.contract_type == 6">
        <div class="custom-form col-12 p-0 form-group" [ngClass]="{'currency_input': add_product.dp_amount}">
          <input [(ngModel)]="add_product.dp_amount" name="dp_amount" type="text"
            class="input_field  pt-3 px-3 padding_with_dollar notranslate" required appDecimaNumber>
          <label for="text" class="label-name ">
            <span class="content-name f-c-p-3 bottom-5">
              Downpayment Amount
            </span>
          </label>
        </div>
      </div>
      <!-- commmon -->
      <div class="custom-form col-12 p-0 form-group ">
        <input [value]="'$ '+(add_product.service_amount - add_product.dp_amount).toFixed(2)" name="financed_amount"
          class="input_field  pt-2 px-3 disabled-input notranslate" type="text" disabled>
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Payment Plan Amount
          </span>
        </label>
      </div>
      <!-- commmon -->
      <div class="col-12 px-0 position-relative">
        <div class="d-flex align-item-center justify-content-center mb-3">
          <div class="custom-form flex-grow-1 p-0 form-group mb-0">
            <input [(ngModel)]="add_product.terms" name="terms" trim
              class="input_field input_field--modify pt-2 px-3" required (keydown)="termsvalidator($event,1)">
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3 bottom-5">
                Terms (in months)
              </span>
            </label>
          </div>
          <span class="tooltip-text tooltip--modify"
            [tooltip]="'You can add multiple terms(in months) with comma(,) separator e.g 1,2,3,4,5'"
            [customClass]="'dark-theme-tooltip'" [placementModal]="'1'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 26px;">
          </span>
        </div>
      </div>

      <div class="col-12 p-0 padd-right">
        <div class="reason-area pb-3">
          <div class="custom_text_area">
            <textarea class="text_reason mt-0" [(ngModel)]="add_product.description" name="pc_description" (keypress)="mainService.handleInputSpace($event);"
              required maxlength="500" style="margin-bottom: -8px;height: 125px;"></textarea>
            <label for="" class="area_name mb-05" >
              <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                Service Description
              </span>
            </label>

          </div>
        </div>
      </div>

      <div class="w-100 p-0" style="margin-top: 5rem;">
        <label for="show_desc" class="label-name pointer mb-05" style=" font-weight: normal;color: grey;">
          <input type="checkbox" class="pointer" name="show_desc" id="show_desc" required style="margin-right: 8px;"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="add_product.show_desc">
          <label for="show_desc" class="me-1">Display service description to the customer.</label>
        </label>
      </div>

      <div class="col-12 p-0">
        <button class="send-button" mat-raised-button (click)="addService()"
          style="padding:16px 25px !important;">{{add_product.pc_id ? 'Update' :
          'Add'}}</button>
      </div>

    </div>
  </div>
</div>

<!-- pay-over-time -->
<div class="dialog-header verify-user" *ngIf="data.type == 50">
  <h2 mat-dialog-title class="text-start h3 mb-0 px-4 pb-3 pb-md-0 pt-md-5 px-sm-5 mat-dialog-title">{{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="px-sm-5 py-3 w-100 var-src">
    <div class="row mx-md-0 flex-wrap">
      <div class="col-6 ps-md-0 form-group mb-0">
        <div class="custom-form">
          <input class="input_field px-3 pt-3" type="text" [(ngModel)]="dynamicPackage.service_name" (keypress)="mainService.handleInputSpace($event);"
            required maxlength="100"/>
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3 bottom-5">
              Service Name
            </span>
          </label>
        </div>
      </div>
      <div class="col-6 ps-md-0">
        <div class="d-flex align-items-center position-relative">
          <div class="w-100 ">
            <div class="custom-form form-group me-2">
              <input [(ngModel)]="dynamicPackage.website_navigation_link" name="website_navigation_link" (keypress)="mainService.handleInputSpace($event);"
                class="input_field input_field--modify px-3 pt-3">
              <label for="text" class="" [ngClass]="[!dynamicPackage.website_navigation_link ? '' : 'label-name']">
                <span class="content-name f-c-p-3">
                  Redirection URL (Optional)
                </span>
              </label>
            </div>
          </div>
          <span
            [tooltip]="'Provide Redirection URL if you want to redirect users to your website after the contract creation.'"
            [customClass]="'dark-theme-tooltip'" [placementModal]="'1'" class="tooltip">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 26px;">
          </span>
        </div>
      </div>
      <div class="col-12 ps-md-0 padd-right">
        <div class="reason-area pb-3">
          <div class="custom_text_area custom_text_area_1" style="height: 56px !important;">
            <textarea class="text_reason mt-0" [(ngModel)]="dynamicPackage.description" (keypress)="mainService.handleInputSpace($event);"  required
              maxlength="500" style="margin-bottom: -8px;"></textarea>
            <label for="" class="area_name" style="top: 2px !important">
              <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                Service Description
              </span>
            </label>
            <small class="length pull-right pt-1">{{ dynamicPackage.description ?
              dynamicPackage.description.length : '0' }}/500</small>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="col-6 px-0">
        <label for="show_desc" class="label-name pointer" style=" font-weight: normal;color: grey;">
          <input type="checkbox" class="pointer" name="show_desc" id="show_desc" required style="margin-right: 8px;"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="dynamicPackage.show_desc">
          <label for="show_desc" class="me-1">Display service description to the customer.</label>
        </label>
      </div>
    </div>

    <div class="row mx-0">
      <div class="col-12 p-0 mt-2">
        <p style="font-weight: 700;font-size: 18px;line-height: 24px;">Add Package</p>
      </div>
    </div>
    <ng-container *ngIf="dynamicPackage">
      <ng-container *ngFor="let item of dynamicPackage.add_package_list; let i=index">
        <div class="row mx-0 mb-3" *ngIf="dynamicPackage.edit_dynamic_package_index!=i">
          <div class="col-12 package_added_list p-0 d-flex  flex-wrap">
            <div class="col-12 d-flex justify-content-between flex-wrap py-3 px-3"
              style="background-color: rgb(226 226 226 / 20%);">
              <p class="m-0 pack-text">Package {{i+1}}</p>
              <div class="d-flex align-items-center"> <img src="assets/img/svg/pen-edit.svg" class="me-2"
                  (click)="edit_package(i)"> <img src="assets/img/svg/close-circle-red.svg"
                  (click)="delete_dynamic_package_in_edit(i)"> </div>
            </div>

            <div class="row ps-3 w-100" *ngIf="(add_product.contract_type == 2 || add_product.contract_type == 6)">
              <div class=" py-2 col-md-3 col-sm-6 custom_border_package_list font-light">
                <p>Service amount {{dynamicPackage.amount_terms_type == 1 ? '(fixed)': '(max)'}}</p>
                <h3 class="notranslate">{{item.max_service_amount | currency}}</h3>
              </div>
              <div class="py-2 col-md-3 col-sm-6 custom_border_package_list font-light"
                *ngIf="downpayment_setting.downpayment_percent">
                <p>Min. down payment(%)</p>
                <h3 class="notranslate">{{item.min_dp_amount}}%</h3>
              </div>
              <div class="py-2 col-md-3 col-sm-6 custom_border_package_list font-light">
                <p>Payment Plan</p>
                <h3 class="notranslate">{{item.max_service_amount - ((item.max_service_amount *
                  (item.min_dp_amount?item.min_dp_amount:0))/100) |  currency}}</h3>
              </div>
              <div class="py-2 col-md-3 col-sm-6 custom_border_package_list font-light">
                <p>Terms {{item.terms_type==1?'Fixed':'Max'}} </p>
                <h3>{{item.terms}} months</h3>
              </div>
            </div>
            <div class="row ps-3 w-100" *ngIf="add_product.contract_type == 3">
              <div class=" py-2 col-md-3 col-sm-6 custom_border_package_list font-light">
                <p>Service amount {{dynamicPackage.amount_terms_type == 1 ? '(fixed)': '(max)'}}</p>
                <h3 class="notranslate">{{item.max_service_amount | currency}}</h3>
              </div>
              <div class="py-2 col-md-2 col-sm-6 custom_border_package_list font-light"
                *ngIf="downpayment_setting.new_ten_downpayment_percent">
                <p>Min. down payment(%)</p>
                <h3 class="notranslate">{{item.min_dp_amount}}%</h3>
              </div>
              <div class="py-2 col-md-2 col-sm-6 custom_border_package_list font-light">
                <p>Payment Plan</p>
                <h3 class="notranslate">{{item.max_service_amount - ((item.max_service_amount *
                  (item.min_dp_amount?item.min_dp_amount:0))/100) | currency}}</h3>
              </div>
              <div class="py-2 col-md-3 col-sm-6 custom_border_package_list font-light">
                <p>Terms {{item.terms_type==1?'Fixed':'Max'}} </p>
                <h3>{{item.terms}} months</h3>
              </div>
              <div class="py-2 col-md-2 col-sm-6 custom_border_package_list font-light">
                <p>Interest Rate
                </p>
                <h3 class="notranslate">{{item.interest_rate}} %</h3>
              </div>
            </div>
          </div>
        </div>
        <form #editVariablePackage="ngForm" class="row mb-4 px-0 my-3"
          *ngIf="dynamicPackage.edit_dynamic_package_index==i">

          <div class="col-xs-12 col-sm-6 my-lg-0 my-2 d-flex" style="max-width: 16rem !important;">
            <div class="custom-form custom-select-box-container col-5 form-group m-0" *ngIf="!is_opt_disabled">
              <select class="form-select form-select-sm" required name="amount_terms_type" [(ngModel)]="dynamicPackage.amount_terms_type"
                ngModel [disabled]="is_opt_disabled" #amount_terms_type="ngModel" (change)="changeServiceType($event)">
                <option value="2">Max</option>
                <option value="1">Fixed</option>
              </select>
            </div>
            <div class="custom-form col-7 px-0 form-group m-0" style="min-width: unset !important;margin: 0 !important;" [ngClass]="{'currency_input': variableServiceAmount.valid, 'hide__dropdown' :is_opt_disabled}">
              <input class="input_field input--modify terms_input_field pt-3 px-4 notranslate" type="text" name="service_amount"
              ngModel [(ngModel)]="dynamicPackage.service_amount" required #variableServiceAmount="ngModel"
              appDecimaNumber />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3" style="left: 12px !important;">
                  Service Amount
                </span>
              </label>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-3 my-lg-0 my-2 mi-w-180"
            *ngIf="downpayment_setting.new_ten_downpayment_percent && add_product.contract_type == 3">
            <div class="custom-form " [ngClass]="{'percent_input': minDP.valid}">
              <input class="input_field pt-3 padding_with_dollar px-3 notranslate" type="text" name="min_down_payment"
                ngModel [(ngModel)]="dynamicPackage.min_down_payment" required #minDP="ngModel" appDecimaNumber min="0"
                maxlength="5" [max]="downLimit" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Min. down payment(%)
                </span>
              </label>
              <small class="text-danger" *ngIf="minDP.invalid && minDP.dirty">
                Please enter value from 0 to {{downLimit}}%
              </small>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-3 my-lg-0 my-2 mi-w-180"
            *ngIf="downpayment_setting.downpayment_percent && (add_product.contract_type == 2 || add_product.contract_type == 6)">
            <div class="custom-form " [ngClass]="{'percent_input': minDP.valid}">
              <input class="input_field pt-3 padding_with_dollar px-3 notranslate" type="text" name="min_down_payment"
                ngModel [(ngModel)]="dynamicPackage.min_down_payment" required #minDP="ngModel" appDecimaNumber min="0"
                maxlength="5" [max]="downLimit" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Min. down payment(%)
                </span>
              </label>
              <small class="text-danger" *ngIf="minDP.invalid && minDP.dirty">
                Please enter value from 0 to {{downLimit}}%
              </small>
            </div>
          </div>
          <div class="col-xs-12 my-lg-0 my-2" style="max-width: 19% !important;">
            <div class="custom-form  disabled-input">
              <input class="input_field pt-3 px-3 notranslate" type="text" name="payment_plan_amount"
                [value]="'$'+(dynamicPackage.service_amount-((dynamicPackage.service_amount*(dynamicPackage.min_down_payment?dynamicPackage.min_down_payment:0))/100)).toFixed(2)"
                required disabled />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Payment Plan Amount
                </span>
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 my-lg-0 my-2 d-flex" style="max-width: 19rem !important; position: relative;">
            <div class="custom-form custom-select-box-container  col-4  form-group m-0">
              <select class="form-select form-select-sm" required name="terms_type"
                [(ngModel)]="dynamicPackage.terms_type" ngModel (change)="dynamicPackage.terms=''">
                <option value="2">Max</option>
                <option value="1">Fixed</option>
              </select>
            </div>
            <div class="custom-form col-8 form-group m-0 ms-1 p-0"
              style="min-width: unset !important;margin: 0 !important;">
              <input class="input_field pt-3 px-3 terms_input_field input--modify notranslate" type="text" name="terms"
                ngModel [(ngModel)]="dynamicPackage.terms" trim  required
                (keydown)="termsvalidator($event,dynamicPackage.terms_type)" />
              <label for="text" class="label-name">
                <!-- [ngStyle]="{bottom: !dynamicPackage.terms ? '-6px' : ''}" -->
                <span class="content-name f-c-p-3" >
                  Service amount (max)
                </span>
              </label>
            </div>
            <span class="tooltip-text tooltip--modify2"
              [tooltip]="'You can add multiple terms(in months) with comma(,) separator e.g 1,2,3,4,5'"
              *ngIf="dynamicPackage.terms_type == 1" [customClass]="'dark-theme-tooltip'" [placementModal]="'1'">
              <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 22px;">
            </span>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-3 my-lg-0 my-2 mi-w-180" *ngIf="add_product.contract_type == 3" [class.py-2]="downpayment_setting.new_ten_downpayment_percent > 0">
            <div class="custom-form">
              <input [(ngModel)]="dynamicPackage.interest_rate" ngModel name="interest_rate"
                #variableServiceAmount="ngModel" appDecimaNumber type="text"
                class="input_field pt-3 px-3 padding_with_dollar notranslate" min="0" max="100" maxlength="6" required>
              <label for="text" class="label-name ">
                <span class="content-name f-c-p-3">
                  Interest Rate (%)
                </span>
              </label>
            </div>
            <span class="tooltip-text tooltip--modify3"
              [tooltip]="'The average interest rate charged by Businesses in your area is 13%.'"
              *ngIf="dynamicPackage.terms_type == 1" [customClass]="'dark-theme-tooltip'" [placementModal]="'1'">
              <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 22px;">
            </span>
          </div>

          <div class="col-12 mt-4 d-flex" *ngIf=" (add_product.contract_type == 2 || add_product.contract_type == 6)">
            <button class="btn save-package-button me-3" (click)="savePackage(editVariablePackage)"
              [disabled]="downpayment_setting.downpayment_percent==0?false:dynamicPackage.min_down_payment>downLimit">Save
              Package</button>
            <div class="btn cancel-package-button" (click)="calcelAddpackage()"
              *ngIf="dynamicPackage.add_package_list.length>=1" (click)="cancel_update_package()">
              Cancel</div>
          </div>

          <div class="col-12 mt-4 d-flex" *ngIf="add_product.contract_type == 3">
            <button class="btn save-package-button me-3" (click)="savePackage(editVariablePackage)"
              [disabled]="downpayment_setting.new_ten_downpayment_percent==0?false:dynamicPackage.min_down_payment>downLimit">
              Save Package
            </button>
            <div class="btn cancel-package-button" (click)="calcelAddpackage()"
              *ngIf="dynamicPackage.add_package_list.length>=1" (click)="cancel_update_package()">
              Cancel</div>
          </div>
        </form>
      </ng-container>
    </ng-container>

    <form #addVariablePackage="ngForm" class="row flex-wrap" *ngIf="dynamicPackage.show_input_value_container">

      <div class="col-xs-12 col-sm-6 my-lg-0 my-2 d-flex" style="max-width: 17rem !important;">
        <div class="custom-form custom-select-box-container col-5 form-group m-0" *ngIf="!is_opt_disabled">
          <select class="form-select form-select-sm" required name="amount_terms_type" [(ngModel)]="dynamicPackage.amount_terms_type"
            ngModel [disabled]="is_opt_disabled" #amount_terms_type="ngModel">
            <option value="2">Max</option>
            <option value="1">Fixed</option>
          </select>
        </div>
        <div class="custom-form col-7 px-0 form-group m-0" style="min-width: unset !important;margin: 0 !important;" [ngClass]="{'hide__dropdown' :is_opt_disabled}" [ngStyle]="{'width': is_opt_disabled ? '100%' : 'none'}">
          <input class="input_field input--modify terms_input_field pt-3 px-3 notranslate" type="text" name="service_amount" ngModel
          [(ngModel)]="dynamicPackage.service_amount" required #variableServiceAmount="ngModel" appDecimaNumber style="width:-webkit-fill-available"/>
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3 bottom-5" style="left: 12px !important;">
              Service Amount
            </span>
          </label>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 my-lg-0 my-2 mi-w-180"
        *ngIf="downpayment_setting.new_ten_downpayment_percent && add_product.contract_type == 3">
        <div class="custom-form " [ngClass]="{'percent_input': dynamicPackage.min_down_payment>downLimit}">
          <input class="input_field pt-3 padding_with_dollar px-3 notranslate" #minDP="ngModel" type="text"
            name="min_down_payment" ngModel [(ngModel)]="dynamicPackage.min_down_payment" min="0" maxlength="5"
            [max]="downLimit" required appDecimaNumber />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Min. down payment(%)
            </span>
          </label>
          <small class="text-danger" *ngIf="dynamicPackage.min_down_payment>downLimit">
            Please enter value from 0 to {{downLimit}}%
          </small>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 my-lg-0 my-2 mi-w-180"
        *ngIf="downpayment_setting.downpayment_percent && (add_product.contract_type == 2 || add_product.contract_type == 6)">
        <div class="custom-form " [ngClass]="{'percent_input': dynamicPackage.min_down_payment>downLimit}">
          <input class="input_field pt-3 padding_with_dollar px-3 notranslate" #minDP="ngModel" type="text"
            name="min_down_payment" ngModel [(ngModel)]="dynamicPackage.min_down_payment" min="0" maxlength="5"
            [max]="downLimit" required appDecimaNumber />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Min. down payment(%)
            </span>
          </label>
          <small class="text-danger" *ngIf="dynamicPackage.min_down_payment>downLimit">
            Please enter value from 0 to {{downLimit}}%
          </small>
        </div>
      </div>
      <div class="col-xs-12 my-lg-0 my-2" style="max-width: 19% !important;">
        <div class="custom-form  disabled-input ">
          <input class="input_field pt-3  px-3 disabled-input notranslate" type="text" name="payment_plan_amount"
            [value]="'$'+(dynamicPackage.service_amount-((dynamicPackage.service_amount * (dynamicPackage.min_down_payment?dynamicPackage.min_down_payment:0))/100)).toFixed(2)"
            required disabled />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Payment Plan Amount
            </span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 my-lg-0 my-2 d-flex" style="max-width: 16rem !important;">
        <div class="custom-form custom-select-box-container col-6 form-group m-0">
          <select class="form-select form-select-sm" required name="terms_type" [(ngModel)]="dynamicPackage.terms_type"
            ngModel (change)="dynamicPackage.terms=''">
            <option value="2">Max</option>
            <option value="1">Fixed</option>
          </select>
        </div>
        <div class="custom-form col-6  px-0 form-group m-0" style="min-width: unset !important;margin: 0 !important;">
          <input class="input_field input--modify terms_input_field pt-3 px-3" type="text" name="terms" ngModel
            [(ngModel)]="dynamicPackage.terms" trim  required
            (keydown)="termsvalidator($event,dynamicPackage.terms_type)" />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3 bottom-5" style="left: 12px !important;">
              Terms
            </span>
          </label>
          <span class="tooltip-text tooltip--modify2"
            [tooltip]="'You can add multiple terms(in months) with comma(,) separator e.g 1,2,3,4,5'"
            *ngIf="dynamicPackage.terms_type == 1" [customClass]="'dark-theme-tooltip'" [placementModal]="'1'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 22px;">
          </span>
        </div>
      </div>

      <div class="col-xs-12 col-lg-3 col-sm-6 col-md-3 my-lg-0 my-2 mi-w-180 pe-0" *ngIf="add_product.contract_type == 3" [class.py-2]="downpayment_setting.new_ten_downpayment_percent > 0">
        <div class="custom-form">
          <input [(ngModel)]="dynamicPackage.interest_rate" ngModel name="interest_rate"
            #variableServiceAmount="ngModel" type="text" appDecimaNumber
            class="input_field pt-3 px-3 padding_with_dollar notranslate" min="0" max="100" maxlength="6" required>
          <label for="text" class="label-name ">
            <span class="content-name f-c-p-3">
              Interest Rate (%)
            </span>
          </label>
          <span class="tooltip-text tooltip--modify3"
            [tooltip]="'The average interest rate charged by Businesses in your area is 13%.'"
            *ngIf="dynamicPackage.terms_type == 1" [customClass]="'dark-theme-tooltip'" [placementModal]="'1'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 22px;">
          </span>
        </div>
      </div>

      <div class="col-12 mt-4 d-flex" *ngIf="add_product.contract_type == 3">
        <button class="btn save-package-button me-3" (click)="savePackage(addVariablePackage)"
          [disabled]="downpayment_setting.new_ten_downpayment_percent==0?false:dynamicPackage.min_down_payment>downLimit">Save
          Package</button>
        <div class="btn cancel-package-button" (click)="calcelAddpackage()"
          *ngIf="dynamicPackage.add_package_list.length>=1">Cancel
        </div>
      </div>
      <div class="col-12 mt-4 d-flex" *ngIf="(add_product.contract_type == 2 || add_product.contract_type == 6)">
        <button class="btn save-package-button me-3" (click)="savePackage(addVariablePackage)"
          [disabled]="downpayment_setting.downpayment_percent==0?false:dynamicPackage.min_down_payment>downLimit">Save
          Package</button>
        <div class="btn cancel-package-button" (click)="calcelAddpackage()"
          *ngIf="dynamicPackage.add_package_list.length>=1">Cancel
        </div>
      </div>

    </form>

    <!-- common code -->
    <div class="row"
      *ngIf="!dynamicPackage.show_input_value_container && dynamicPackage.edit_dynamic_package_index==-1">
      <div class="col-12">
        <div style="color: #3492e6;font-size: 16px;margin-top: 10px;"
          (click)="dynamicPackage.show_input_value_container=true; is_opt_disabled = true" *ngIf="dynamicPackage.add_package_list.length<5">
          <span style="margin-top: 2px; margin-left: 4px;cursor: pointer;">
            + Add More Package
          </span>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex mt-4" *ngIf="doctorSettings.show_pot_additional_service == 1">
      <div class="col-6 px-0">
        <label for="show_add_service" class="label-name pointer" style=" font-weight: normal;color: grey;">
          <input type="checkbox" class="pointer" name="show_add_service" id="show_add_service" required style="margin-right: 8px;" [ngModelOptions]="{standalone: true}" [(ngModel)]="show_additional_service" (change)="addAdditionalServices()">
          <label for="show_add_service" class="me-1">Add Additional Services</label>
        </label>
      </div>
    </div> -->
    <div>
      <div *ngIf="doctorSettings.show_pot_additional_service == 1">
        <div class="w-auto d-flex align-items-center pt-4">
        <span class="font-weight-bold">Add Ons</span>
        <mat-slide-toggle class="example-margin ms-3" name="switchUserForm" [ngModelOptions]="{standalone: true}" [(ngModel)]="show_additional_service"(click)="$event.stopPropagation()" (change)="addAdditionalServices()"  [checked]="show_additional_service"></mat-slide-toggle>
    </div>
  <div>
    <p style="color: #596775;" class="d-flex align-items-center">Enhance Your Offerings with Add-Ons  <span class="ms-3"
      [tooltip]="'Give your customers more value and flexibility by offering optional add-ons. These features can enhance their experience, making your services even more attractive.'"
     [customClass]="'dark-theme-tooltip'" [placement]="'right'" >
      <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 22px;">
    </span> </p>
  </div>
</div>
    </div>

    <div *ngIf="show_additional_service" id="services">
      <form [formGroup]="serviceBreakForm" >
        <span class="d-inline fw-700">Add Additional Optional Services</span>
        <div class="pt-2 service-list" formArrayName="items">
          <div *ngFor="let service_block of serviceBreakdowns.controls; let i = index;"
            class="d-flex align-item-center mx-0 mb-3">
            <ng-container [formGroup]="service_block">
              <div class="serv-name p-0 w-25">
                <div
                  [ngClass]="[ service_block.controls.service.touched && service_block.controls.service.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                  <input type="text" class="input_field pt-3 px-3" name="service" required formControlName="service"
                    id="breakDownText{{i}}" (keyup)="services()" tabindex="{{i+1}}1"
                    (keypress)="mainService.handleInputSpace($event)" autofocus maxlength="100" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Add-On Name
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="service_block.controls.service.touched && service_block.controls.service.invalid">
                  Please enter service name.
                </p>
              </div>
              <div class="ps-4 w-25">
                <div
                  [ngClass]="[ service_block.controls.price.touched && service_block.controls.price.invalid ? 'custom-form   flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3  ']">
                  <span *ngIf="service_block.controls.price.value !== null && service_block.controls.price.value !== ''"
                    class="pt-2 pe-1 font-weight-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">$
                  </span>
                  <input class="input_field pt-3 notranslate" id="breakDownVal{{i}}" formControlName="price" required appDecimaNumber
                    [ngClass]="[service_block.controls.price.value !== null && service_block.controls.price.value !== '' ? 'px-4' : 'px-3']"
                    onKeyPress="if(this.value.length==8) return false;" (keyup)="services()" tabindex="{{i+1}}2">
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Price
                    </span>
                  </label>
                </div>
                <p class="mat-error" *ngIf="service_block.controls.price.touched && service_block.controls.price.invalid">
                  Please enter price.
                </p>
              </div>
              <div class="action-item d-flex justify-content-start align-items-center p-1"
                style="width: 12%;height: 49px;">
                <img tappable class="me-1" src="assets/img/svg/dashboard/close-circle.svg"
                  *ngIf="serviceBreakForm.value.items.length > 1" (click)="deleteGroup(i, false)" />
              </div>
            </ng-container>
          </div>
          <a tappable *ngIf="serviceBreakForm.value.items.length < 25" (click)="addGroup(false)">+Add New Add-On</a>
        </div>
      </form>
    </div>

    <div class="mt-3"
      *ngIf="data.type==50 && !dynamicPackage.show_input_value_container && dynamicPackage.edit_dynamic_package_index==-1">
      <button class="btn save-package-button" (click)="publish_or_update_packages()">
        {{dynamicPackage["pc_id"]?'Update Service':'Publish Service'}}
      </button>
    </div>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 40">
  <h2 mat-dialog-title class="text-start h3 mb-0 tile-head">
    <span class="top-heads">{{data.title}}</span>
    <mat-icon (click)="dialogRef.close()" class="close pull-right pointer_1 dialogue">close
    </mat-icon>
  </h2>
  <div mat-dialog-content class="p-3 mt-2">
    <div class="col form-group">
      <!-- <label class="form-label">Please describe your needs</label> -->
      <input class="form-control mb-3" placeholder="Subject(optional)">
      <textarea name="writeToUsMessage" maxlength="2000" style="resize: none;" class="form-control w-100"
        [(ngModel)]="writeToUsMessage" rows="5" placeholder="Message" required (keypress)="mainService.handleInputSpace($event);" ></textarea>
      <small class="mt-2 length pull-right notranslate">{{ writeToUsMessage.length }}/2000</small>
    </div>
    <div class="ms-3 row text-center">
      <!-- <div class="col-6 text-end">
        <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
      </div> -->
      <!-- <div class="col-6 text-start"> -->
      <button class="px-4" button-primary-auth (click)="addWpQuery()">Send Message</button>
      <!-- </div> -->
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 41">
  <h2 style="margin-left:-15px" mat-dialog-title> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content>
    <h4><strong>{{data.desc}}</strong></h4>
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <!-- <button class="ms-2" mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button> -->
    <button button-primary-auth class="px-3 py-2 ms-2 sup-btn" style="height: 40px !important;" (click)="confirmAction()">{{data.action}}</button>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 42">
  <!-- <h2 mat-dialog-title> {{data.title}} </h2> -->
  <div mat-dialog-content class="text-center mt-5 mb-4">
    <img src="assets/img/png/check_signup.png" />
    <h2 class="mt-4" style="font-weight:600"><strong>Training Scheduled!</strong></h2>
    <label style="font-weight: 500;font-size: 16px;line-height: 24px;text-align: center;color: #0E2535;">
      Your training has been scheduled at following date and time:
    </label>
    <p class="m-0 mt-2 mb-1 notranslate">{{data.send_data.training_date}}</p>
    <p class="m-0 mb-3">
      <span style="font-weight: 600;font-size: 16px;line-height: 24px;">{{data.send_data.training_time}}
      </span> {{data.send_data.timezone}}
    </p>
    <button class="mt-2 mat-raised-button train-btn w-auto" (click)="confirmAction()"
      [class.px-4]="userInfo[0].role_id !== 5">Manage Trainings</button>
    <button *ngIf="userInfo[0].role_id !== 5" mat-raised-button class="ms-2 px-4 dash-btn w-auto"
      (click)="goTo('app/dashboard');">Go To Dashboard</button>
  </div>
</div>


<div class="dialog-header vid" *ngIf="data.type == 43">
  <h2 mat-dialog-title class="f-w-800 border py-3">
    <span style="margin-left: -25px;"><span class="notranslate">Denefits</span> Video Tutorials!</span>
    <mat-icon (click)="dialogRef.close()" class="close close-sign pull-right">close</mat-icon>
  </h2>

  <!-- <h2 style="margin-left:-20px; bottom: 10px;" class="border" mat-dialog-title>
    <span style="margin-left: -10px;">Denefits Video Tutorials!</span>
    <mat-icon (click)="dialogRef.close()" class="close pull-right training">close</mat-icon>
  </h2> -->
  <div class="dialog-con ms-2">
    <div class="row">
      <div class="col-12 video-lis">
        <div class="row mb-2" *ngFor="let video_item of tutorial_videos" tappable
          (click)="selected_video = video_item; openDialog()">
          <div class="col-5 ms-2">
            <figure *ngIf="video_item.thumb_url">
              <img class="w-100" [src]="video_item.thumb_url" alt="">
              <img src="assets/img/png/play.png" class="video-icon">
            </figure>
          </div>
          <div class="col-7 outr">
            {{video_item.vid_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- old back connection popup for pp -->
<div class="dialog-header" *ngIf="data.type == 44" style="padding-bottom:0px !important">
  <div class="d-flex justify-content-between align-item-center top_header text-center">
    <span class="px-3">Complete your profile</span>
    <img src="assets\img\svg\cancel_btn.svg" alt="" (click)="dialogRef.close()"
      style="border: 1px solid lightgray;border-radius: 30px;height: 35px; width: 35px;">
  </div>

  <div class="inner-content text-center" *ngIf="userInfo && userInfo[0]">
    <img src="assets/img/png/bank-add-icon.png" style=" height: 6rem;" alt="" class="mb-3" *ngIf="userInfo[0].business_verification_state == 'registered'">
    <img src="assets/img/svg/verify-persona-details.svg" style=" height: 6rem;" alt="" class="mb-3" *ngIf="userInfo[0].business_verification_state == 'bank_added'">
    <img src="assets/img/svg/other-details.svg" style=" height: 6rem;" alt="" class="mb-3" *ngIf="userInfo[0].business_verification_state == 'persona_verified' || userInfo[0].business_verification_state == 'persona_failed'">
    <div class="d-flex justify-content-center mb-2 f-c-p-8 fw-bold fs-18" *ngIf="userInfo[0].business_verification_state == 'registered'">
      Add your Bank Details
    </div>
    <p class="para px-5" *ngIf="userInfo[0].business_verification_state == 'registered' && currentPath != '/app/business-refer'">
      In order for us to send the down payment or future payouts to your account, you must add the banking details.
    </p>
    <p class="para px-5" *ngIf="userInfo[0].business_verification_state == 'registered' && currentPath == '/app/business-refer'">
      In order to transfer funds to your account, you must add the banking details.
    </p>
    <p class="para px-5" *ngIf="userInfo[0].business_verification_state == 'bank_added'">Please
      verify ‘Your Details’ to completely activate your account.</p>
    <p class="para px-5" *ngIf="userInfo[0].business_verification_state == 'persona_verified'">
      Please add your ‘Business Details’ to completely activate your account.</p>
    <p class="para px-5" *ngIf="userInfo[0].business_verification_state == 'persona_failed'">
      You have crossed your verification limit for the day, please contact <a (click)="customerSupport();dialogRef.close();" href="javascript:void(0);">customer support team.</a></p>
    <div class="bottom-data text-center">
      <button class="bank" (click)="_persona.openPersonaAddBankModal();dialogRef.close()"
        *ngIf="userInfo[0].business_verification_state != 'persona_failed'">
        {{userInfo[0].business_verification_state ==
        'persona_verified'
        ?
        'Add Business Details'
        :
        (userInfo[0].business_verification_state == 'bank_added' ?
        'Verify Details': 'Add Bank Details')}}
        </button>
    </div>
    <div *ngIf="data.is_ar == 0" class="align-items-center d-flex fw-bold fs-18 justify-content-center mt-3 pointer skip-hover" (click)="dialogRef.close();">
      <span>Skip for now</span>
    </div>
    <div *ngIf="data.is_ar == 1" class="align-items-center d-flex fw-bold fs-18 justify-content-center mt-3 pointer skip-hover" (click)="skipForAr()">
      <span>Skip for now</span>
    </div>
    <span class="f-s-14-w-400">Note :
      <span *ngIf="currentPath == '/app/business-refer'">By skipping you will not be able to transfer funds.</span>
      <span *ngIf="currentPath != '/app/business-refer'">By skipping you will not get any payment</span>
    </span>
  </div>
</div>


<div class="dialog-header mb-3 py-3 px-4" *ngIf="data.type == 901 && training_timezones.length > 0">
  <div class="align-items-center d-flex justify-content-between mt-3" *ngIf="training_booked == 0">
    <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px)"
      *ngIf="training_booked == 0"> Book a Free Training
    </h2>
    <mat-icon (click)="dialogRef.close(0);this.mainService.getTrainingsList()" class="close pull-right close-sign pointer">close</mat-icon>
  </div>
  <div class="align-items-center d-flex justify-content-between" *ngIf="training_booked == 1">
    <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px)">
    </h2>
    <mat-icon (click)="dialogRef.close(0);this.mainService.getTrainingsList()" class="close pull-right close-sign pointer">close</mat-icon>
  </div>
  <!-- <div class="ms-3 d-flex justify-content-between" mat-dialog-actions> -->
  <div *ngIf="training_booked == 0 && training_timezones.length > 0" class="d-flex justify-content-between w-100 py-0">

    <div class="w-100">
      <!-- select Timezone start -->
      <div class="mt-4">
        <label>Timezone</label>
        <div class="wrap m-h-56 h-100 h-56 d-block" *ngIf="training_timezones.length > 0">
          <div class="select w-100 h-100 h-56">
            <select required class="select-text pt-2 px-3 input_field fw-bold m-h-56 h-100 w-100"
              [(ngModel)]="current_timezone" (change)="getBookableTimeSlots()">
              <ng-container *ngFor="let timezone of training_timezones">
                <option class="w-100 py-3 px-2" value="{{timezone.timezoneName+'****'+timezone.tzOffset}}">
                  {{timezone.timezoneName}} (GMT {{timezone.timezoneString}})
                </option>
              </ng-container>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
          </div>
        </div>
      </div>

      <!-- select Timezone ends -->
      <div class="py-1">
        <label>Date</label>
        <div class="border_10 month-datepicker m-0 p-0 w-100 me-2 m-h-56 pointer">
          <!-- <mat-form-field appearance="outline" class="w-100 px-0 border_10 date-picker rounded-0 mat-short-height notranslate"> -->
          <div class="custom-form">

            <input matInput [matDatepicker]="picker" [matDatepickerFilter]="myFilter"
              style="position: relative;z-index: 1;background-color: transparent !important;cursor: pointer;"
              placeholder="Choose a date" [value]="today" [min]="today" [max]="lastDate" (click)="picker.open()"
              readonly class="fw-700 fs-16 px-3 pt-0 whiteBg" (dateChange)="onDateChange($event)" required>
            <span class="position-absolute right-0 pointer"
              style="right: 0%;top: 50%;transform: translate(-15px, -12px);z-index: 0;">
              <img src="assets/img/svg/calendarv2.svg" alt="">
              <mat-datepicker-toggle matSuffix [for]="picker" class="d-none">
                <mat-datepicker #picker disabled="false"></mat-datepicker>
              </mat-datepicker-toggle>
            </span>
            <!-- </mat-form-field> -->
          </div>
        </div>
      </div>

      <!-- select timeslot start -->
      <div class="py-1 mb-3">
        <label class="">Select Timeslot</label>
        <div class="wrap m-h-56 h-100 h-56 d-block">
          <div class="select w-100 h-100 h-56">
            <select required class="select-text pt-2 px-3 input_field fw-bold m-h-56 h-100 w-100"
              *ngIf="training_data[0] && training_data[0].all_slots"
              (change)="openTooltip($event);selected_timeslot=null;">
              <option value="" class="d-none"></option>
              <ng-container *ngFor="let data of training_data">
                <ng-container *ngFor="let time of data.all_slots; let index = index">
                  <ng-container *ngIf="time.disable == 0">
                    <option class="notranslate" [value]="getValue(data,time,index)">
                      {{time.timeAmPm}}
                    </option>
                  </ng-container>
                </ng-container>
              </ng-container>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="selected_training_data.selected_time_lots.length > 0 && openboxes">
        <ng-container *ngFor="let timeslotss of availableTimeslots;let i = index">
          <div class="row mx-0 align-items-center justify-content-start flex-wrap mb-3 booking_slots" style="gap:10px;">
            <button class="slot-btn border_10 m-h-56 px-4 fw-500 fs-16" *ngFor="let timeslots of timeslotss;let i2 = index"
              style="flex: 0.5 !important; flex-grow: 1 !important;" [disabled]="timeslots.disable == 1"
              (click)="selected_timeslot = (i+i2 + (i==0 ? 0:1))"
              (click)="selected_training_data.selected_full_date_time_string = timeslots.fullDateTimeString; selected_training_data.schedule_time_slot = timeslots.time_slot;"
              [ngClass]="{
                'selected_time': (i + i2 + (i == 0 ? 0 : 1)) == selected_timeslot,
                'border': (i + i2 + (i == 0 ? 0 : 1)) != selected_timeslot,
                'disable_time': timeslots.disable == 1,
                'actv': selected_training_data.schedule_time_slot == timeslots.time_slot &&
                        selected_training_data.selected_full_date_time_string == timeslots.fullDateTimeString
              }">
              <span class="notranslate">{{timeslots.timeAmPm}}</span>
            </button>
          </div>
        </ng-container>
      </ng-container>

    </div>
  </div>

  <ng-container *ngIf="training_booked == 1">
    <div style="position: relative;">
      <img src="assets\img\png\pp_image1.png" alt=""
        style="position: fixed;margin-top:-82px;margin-left: 125px;">
    </div>

    <div class="dialog-header mt-3">
      <div style="width: 100%;max-width: 400px;margin: 0px auto;text-align: center;">
        <div>
          <p style="color: #000000;font-size: 24px;font-weight: 800;">Training Session Confirmed!
          </p>
          <p style="color: #000000;font-size: 16px;font-weight: 400;">Thank you for booking a training session.
            Your session is scheduled for <Strong>{{training_booked_data.training_date}}</Strong> at
            <Strong>{{training_booked_data.training_time}}.</Strong></p>
        </div>
        <hr style="border: 1px solid #DFE5ED;margin: 30px 0px;">

        <p style="color: #000000;font-size: 16px;font-weight: 400;">You can complete your profile in the meantime to
          ensure seamless access to the Payment Processing feature.</p>
        <div style="margin-top: 20px;">
          <button
            style="color: #ffffff;font-size: 16px;font-weight: 400;background: #1581E5;border: 1px solid #1581E5;padding: 15px 50px;border-radius: 7px;width: 100%;" (click)="_persona.openPersonaAddBankModal();dialogRef.close();this.mainService.getTrainingsList()">Complete
            Profile</button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="mt-3" *ngIf="training_booked == 0">
    <button button-primary-auth class="w-100" [disabled]="selected_timeslot == null"
      (click)="confirmBooking();">Continue</button>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 902">
  <div style="position: relative;">
    <img src="assets\img\png\pp_image2.png" alt=""
      style="position: fixed;z-index: 99999;margin-top: -42px;margin-left: 163px;">
  </div>
  <div class="align-items-center d-flex justify-content-between" style="padding: 15px;margin-top: 10px;">
    <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px);">
    </h2>
    <mat-icon (click)="dialogRef.close(0);this.mainService.getTrainingsList()" class="close pull-right close-sign pointer">close</mat-icon>
  </div>
  <div style="width: 100%;max-width: 431px;margin: 0px auto;padding: 16px;text-align: center;padding-top: 15px;">
    <p style="color: #1167B6;font-size: 24px;font-weight: 800;">Complete Your Profile to Access {{ show_pp_subscription ? 'Subscription' : 'Payment Processing' }}
    </p>
    <p style="color: #000000;font-size: 16px;font-weight: 500;">To start using the {{ show_pp_subscription ? 'Subscription' : 'Payment Processing' }} feature,
      you'll need to complete profile setup. We recommend booking a training session to guide you through the
      process.</p>
    <div
      style="display: flex;justify-content: center;flex-direction: column;width: 100%;max-width: 300px;margin: auto;margin-top: 36px;">
      <button
        style="border: 1px solid #1581E5;color: #000000;font-size: 16px;font-weight: 700;background: #ffffff;padding: 10px 50px;border-radius: 7px;"
        (click)="mainService.openTrainingModalForpp();dialogRef.close()">Book
        Training Now <img src="\assets\img\svg\Button Text.svg" alt="" style="display: inline;"></button>
      <p style="color: #131921;font-size: 14px;font-weight: 500;margin: 0px;padding-top: 20px;padding-bottom: 10px;">Or,
        you can start completing your profile
      </p>
      <button
        style="color: #ffffff;font-size: 16px;font-weight: 600;background: #1581E5;border: 1px solid #1581E5;padding: 10px 50px;border-radius: 7px;"
        (click)="_persona.openPersonaAddBankModal();dialogRef.close();this.mainService.getTrainingsList()">Complete
        Profile</button>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 903">
  <ng-container>
    <div style="position: relative;">
      <img src="assets\img\png\pp_image1.png" alt=""
        style="position: fixed;margin-top:-46px;margin-left: 163px;">
    </div>
    <div class="align-items-center d-flex justify-content-between" style="padding: 13px 10px;">
      <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px)">
      </h2>
      <mat-icon (click)="dialogRef.close(0)" class="close pull-right close-sign pointer">close</mat-icon>
    </div>
    <div class="dialog-header mt-3">
      <div style="width: 100%;max-width: 400px;margin: 0px auto;text-align: center;">
        <div>
          <p style="color: #000000;font-size: 24px;font-weight: 800;">Training Session Confirmed!
          </p>
          <p style="color: #000000;font-size: 16px;font-weight: 400;">Thank you for booking a training session.
            Your session is scheduled for <Strong>{{data && data.getTraningData && data.getTraningData.start_show_date}}</Strong> at
            <Strong>{{data && data.getTraningData && data.getTraningData.start_show_time}}.</Strong></p>
        </div>
        <hr style="border: 1px solid #DFE5ED;margin: 30px 0px;">

        <p style="color: #000000;font-size: 16px;font-weight: 400;">You can complete your profile in the meantime to
          ensure seamless access to the Payment Processing feature.</p>
        <div style="margin-top: 20px;">
          <button
            style="color: #ffffff;font-size: 16px;font-weight: 400;background: #1581E5;border: 1px solid #1581E5;padding: 15px 50px;border-radius: 7px;width: 100%;" (click)="_persona.openPersonaAddBankModal();dialogRef.close()">Complete
            Profile</button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="dialog-header" *ngIf="data.type == 800">
  <div class="d-flex justify-content-between align-item-center top_header text-center">
    <img src="assets\img\svg\cancel_btn.svg" alt="" (click)="dialogRef.close()"
      style="border: 1px solid lightgray;border-radius: 30px;height: 35px; width: 35px;">
  </div>
</div>



<div class="dialog-header verify-user" *ngIf="data.type == 45">
  <h2 mat-dialog-title class="text-start h3 mb-0">{{data.title}} <mat-icon (click)="dialogRef.close()"
      class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3">
    <div class="form-group example-full-width mb-2 col-sm-12" appearance="outline">
      <label>Select Location</label>
      <select required [(ngModel)]="selected_location" name="selected_location" class="form-select mb-3">
        <option *ngFor="let location of data.send_data.all_locations" [value]="location.doctor_id">
          {{location.practice_name ? location.practice_name : (location.doctor_first_name + ' ' +
          location.doctor_last_name)}}
        </option>
      </select>
    </div>
    <div class="row text-center mt-4">
      <div class="col-6 text-end">
        <button mat-stroked-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
      </div>
      <div class="col-6 text-start">
        <button class="px-4" mat-raised-button (click)="locationSelected()">Next</button>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 46 || data.type == 47">
  <h2 mat-dialog-title>Terms & Conditions</h2>
  <div mat-dialog-content>
    <div class="row px-4">
      <div [innerHTML]="dynamic_html | safeHtml">
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <div class="col text-end">
      <button mat-stroked-button mat-dialog-close (click)="logout()" style="height: 48px !important;">Deny & Logout</button>
    </div>
    <div class="col text-start">
      <button mat-raised-button [ngClass]="data.actionClass" (click)="acceptTermsCondition()">Accept &
        Continue</button>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 90 || data.type == 100">
  <!-- <h2 mat-dialog-title class="px-4 py-4 mb-0"> {{data.title}} </h2>
    <mat-icon (click)="dialogRef.close()" class="close pull-right text-dark"
      style="position: relative !important; transform: none;">close</mat-icon> -->
  <h2 mat-dialog-title class="f-w-800 border py-3 px-3 d-flex justify-content-between">
    <span style="margin-left: 20px !important;">{{data.title}}</span>
    <mat-icon (click)="dialogRef.close()" class="close-sign close pull-right">close</mat-icon>
  </h2>

  <div mat-dialog-content>
    <div class="row mx-0">
      <input style="padding: .8rem !important;"  type="text" [(ngModel)]="data.email" class="form-input w-100 f-c-p-4" placeholder="Customer Reference Number">
    </div>
  </div>
  <div class="d-flex justify-content-between px-4" mat-dialog-actions>
    <button mat-raised-button [ngClass]="data.actionClass" class="py-2 px-4"
      (click)="updateReference()">{{data.action}}</button>
  </div>
</div>

<!-- customer reference number -->

<div class="dialog-header" *ngIf="data.type == 99" style="min-height: max-content !important; width: 100% !important;">
  <h2 mat-dialog-title class="mb-2"> {{data.title}}
    <mat-icon (click)="routeMe('', 'revive_add_cross_count')" class="close pull-right">close</mat-icon>
  </h2>
  <div>
    <!-- <h3><strong>{{data.desc}}</strong></h3> -->
    <h5 class="py-4 w-100 text-center"><b><span
          *ngIf="userInfo[0].business_verification_state != 'other_info_updated'"><a style="color:#007bff !important"
            (click)="_persona.openPersonaAddBankModal()" tappable><u class="pe-2">Add a Bank
              account</u></a></span>{{data.desc}}</b></h5>
    <div class="row mx-0 justify-content-around">
      <div class="col-12">
        <div class="row mx-0">
          <div class="col-6 py-2 d-flex " *ngFor="let keys of data.popup_data.tips_text">
            <img class="px-2 img_icon" src="assets/img/svg/revive_check_circle_icon.svg" alt=""><span>{{keys}}</span>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4">
        <div class="row mx-0 align-item-center justify-content-around">
          <div class="width_set svg_box px-4 py-5 hoverable col-4 text-center " tappable
            (click)="routeMe('app/finance','revive_finance')">
            <div class="">
              <img width="50px" class="" src="assets/img/svg/revive_finance.svg" alt="">
              <div class="py-2">
                <p class="mt-4 mb-0 fw-700 fs-18 white">Start Payment Plan</p>
              </div>
            </div>
            <div></div>
          </div>
          <div class="width_set svg_box_1 px-4 py-5 hoverable col-4 text-center " tappable
            (click)="routeMe('app/help/trainings/schedule','revive_training')">
            <div class="">
              <img width="50px" src="assets/img/svg/revive_training.svg" alt="">
              <div class="py-2">
                <p class="mt-4 mb-0 fw-700 fs-18">Book Your Training</p>
              </div>
            </div>
            <div></div>
          </div>
          <div class="width_set svg_box px-4 py-5 hoverable col-4 text-center" tappable
            (click)="routeMe('','revive_callback')">
            <div class="">
              <img width="50px" class="" src="assets/img/svg/revive_callback.svg" alt="">
              <div class="py-2">
                <p class="mt-4 mb-0 fw-700 fs-18 white">Have us Call You</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- bussinessMOdal -->
<div *ngIf="data.type == 200" style="padding: 15px 5px;">
  <div class="mt-0">
    <h2 mat-dialog-title class="mb-0 dialog-bb-none">
      <mat-icon (click)="dialogRef.close(9)" class="close pull-right">close</mat-icon>
    </h2>
  </div>

  <div class="px-3">
    <div class="pb-3">
      <h2 class="h4" style="color: #0E2535 !important;font-weight: 800 !important;"> {{data.title}} </h2>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <button button-primary-auth (click)="dialogRef.close(0)" autofocus>Business Owner</button>
      <div class="d-flex flex-column align-item-center justify-content-between">
        <hr style="width:23px; transform: rotate(90deg);color: #C3C8CD;">
        <p style="text-align: center;margin-bottom:0px !important;color: #C3C8CD;">or</p>
        <hr style="width:23px; transform: rotate(90deg);color: #C3C8CD;">
      </div>
      <button button-primary-auth style="padding: 15px 47px  !important" (click)="dialogRef.close(1)">Customer</button>
    </div>
  </div>

</div>

<!-- password -->

<div class="dialog-header" *ngIf="data.type == 201">
  <div class="mt-4">
    <h2 mat-dialog-title class="mb-2 dialog-bb-none">
      <mat-icon (click)="routeMe('', 'revive_add_cross_count')" class="close pull-right">close</mat-icon>
    </h2>
  </div>

  <div class="w-75 px-3 py-2">
    <h2 style="color: #0E2535 !important;font-size:32px;font-weight: 800 !important;"> {{data.title}} </h2>
  </div>

  <div mat-dialog-content>
    <form #switchBusinessToCustomerForm="ngForm" (ngSubmit)="switchBusinessToCustomer(switchBusinessToCustomerForm)">
      <div>
        <div class="custom-form px-3 py-2 border mt-3">
          <input type="text" class="input_field pt-2" name="empName" formControlName="empName" trim  />
        </div>
        <div class="d-flex justify-content-between" mat-dialog-actions>
          <button button-primary-auth type="submit">continue</button>
        </div>
      </div>
    </form>
  </div>
</div>


<!-- Send invoice -->

<div *ngIf="data.type == 202">
  <div class="closee" (click)="dialogRef.close()">
    <img src="assets\img\svg\close-circle.svg" alt="">
  </div>

  <div class="px-5 py-3">
    <div class="w-75 mt-3">
      <h2 class="heading" style="color: #0E2535 !important;font-size:24px;font-weight: 800 !important;"> {{data.title}}
      </h2>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-5">
      <button button-primary-auth class="button" (click)="dialogRef.close(1)" id="send_invoice">Send Invoice</button>
      <div class="d-flex flex-column align-item-center justify-content-between">
        <hr style="width:23px; transform: rotate(90deg);color: #C3C8CD;">
        <p style="text-align: center;margin-bottom:0px !important;color: #C3C8CD;">or</p>
        <hr style="width:23px; transform: rotate(90deg);color: #C3C8CD;">
      </div>
      <button button-primary-auth class="button" (click)="dialogRef.close(0)" id="pay_via_card">Pay via Card</button>
    </div>

  </div>

</div>

<!-- send receipt -->
<div *ngIf="data.type == 203">
  <div class="mt-0">
    <h2 mat-dialog-title class="mb-2 dialog-bb-none">
      <mat-icon (click)="dialogRef.close(1)" class="close pull-right">close</mat-icon>
    </h2>
  </div>
  <div class="download_rct">
    <img src="assets\img\gif\right_mark11.gif" alt="" style="width:45% !important;margin:0px auto;padding-left: 46px;">
    <p class="mt-2 f-c-p-4 h2 f-w-800">Payment Successful!</p>
    <p class="mt-2 f-c-p-4 fs-14 f-w-400">How would you like your receipt?</p>
    <div class="d-flex justify-content-center align-item-center mt-2 cursor-pointer">
      <img src="assets\img\svg\download_sign.svg" alt="" width="12px">
      <a href="{{data.send_data.paymentSettings}}" download
        target="_blank" class=" f-c-p-1 fs-16 f-w-700 ps-2">Download Receipt</a>
    </div>
    <button class="mt-3 mb-3" button-primary-auth (click)="dialogRef.close(0)">Send Receipt</button>
  </div>
</div>

<!-- customer reference number -->


<!-- Add user starts -->

<div *ngIf="data.type == 210" style="overflow-x: hidden;">

  <h2 mat-dialog-title class="f-w-800 border py-3 pe-4" style="left: 10px;">
    <span>{{data.title}}</span>
    <mat-icon (click)="dialogRef.close(9)" class="close-sign close pull-right">close</mat-icon>
  </h2>

  <!-- <div class="w-75">
      <h2 class="h4 px-4 ms-2" style="color: #0E2535 !important;font-weight: 800 !important;"> {{data.title}} </h2>
    </div> -->

  <form [formGroup]="userDetails" class="px-5 justify-content-between align-items-center mt-3 flex-wrap">
      <div class="row">
        <div class="col-12 mb-3 p-0">
          <div
            [ngClass]="[ (userDetails.controls.name.touched && userDetails.controls.name.invalid) || userDetails.controls.name?.errors?.error ? 'custom-form  me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input type="text" class="input_field px-3 pt-3" name="name" required formControlName="name" maxlength="100"
              (keypress)="omit_special_char($event);mainService.handleInputSpace($event);" autofocus />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Name
              </span>
            </label>
          </div>
          <p class="mat-error mb-0"
            *ngIf="(userDetails.controls.name.touched && userDetails.controls.name.invalid && userDetails.controls.name.dirty) || userDetails.controls.name.errors?.error">
            {{
            userDetails.controls.name.errors && userDetails.controls.name.errors?.error
            ?
            userDetails.controls.name.errors?.error
            :
            'Please enter a valid user name.'}}
          </p>
        </div>

      <div class="col-12 mb-3 p-0">
          <div
        [ngClass]="[ (userDetails.controls.email.touched && userDetails.controls.email.invalid) ? 'custom-form  flex-grow-1 me-md-3 inputContainer' : 'custom-form flex-grow-1 me-md-3']">
        <input type="text" class="input_field px-3 pt-3" name="email" required formControlName="email" maxlength="100"
          autofocus (keydown.space)="$event.preventDefault();" />
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Email
          </span>
        </label>
      </div>
      <p class="mat-error mb-0"
        *ngIf="(userDetails.controls.email.touched && userDetails.controls.email.invalid && userDetails.controls.email.dirty) || userDetails.controls.email?.errors?.error">
        {{ userDetails.controls.email.errors && userDetails.controls.email.errors.error ?
        userDetails.controls.email.errors.error
        :
         'Please enter a valid email address.'}}</p>
    </div>
    </div>

    <div class="row">
      <div class="col-12 text-start py-3 ps-0">
        <button button-primary-auth (click)="addUser()" [disabled]="userDetails.invalid">Add Now</button>
    </div>
    </div>
  </form>
</div>

<!-- Add New user  -->

<!-- payment failed -->

<div *ngIf="data.type == 212" class="p-3">
  <div (click)="dialogRef.close(0)" class="w-100 d-flex justify-content-end align-item-center pointer">
    <img src="assets\img\svg\close-circle.svg" alt=""
      style="border: 1px solid lightgray;padding: 6px;border-radius: 26px;">
  </div>

  <div class="d-flex flex-column align-items-center justify-content-center">

    <div class="w-100 text-center">
      <img src="assets\img\svg\not_icon.svg" alt="">
    </div>

    <div class="mt-3 w-100 text-center">
      <h2 style="color: #05141F !important;font-size:24px;font-weight: 800 !important;">Payment Failed!</h2>
      <p class="fs-16 text-danger f-w-400 ">{{data.send_data.payment_data}}</p>
    </div>

    <div class="d-flex flex-column justify-content-between align-items-center mt-3 w-100">
      <button button-simple-hover class="button" (click)="dialogRef.close(1)"
        [disabled]="data.send_data.switchUserForm && data.send_data.retryDisabled"
        style="border-radius: 6px;">Retry</button>
      <button button-primary-auth class="button mt-2 mb-2" [disabled]="data.send_data.switchUserForm"
        style="padding: 17px 54px !important;" (click)="dialogRef.close(0)">Change Card</button>
    </div>

  </div>
</div>


<div class="dialog-header proposal-div" *ngIf="data.type == 213 && data.send_data.patient_signature">
  <h2 mat-dialog-title class="f-w-800 border py-3">
    <span style="margin-left: -10px;">Customer Signature</span>
    <mat-icon (click)="dialogRef.close()" class="close close-sign pull-right">close</mat-icon>
  </h2>
  <div class="customer_signature_container">
    <img src="{{data.send_data.patient_signature}}" />
  </div>

  <div class="px-4">
    <span>Contract made {{data.send_data.split_made == 0 ? 'in office': 'Remotely'}} on
      <span class="notranslate">{{data.send_data.date_added | date: 'MM/dd/yyyy'}} </span> at
      <span class="notranslate">{{data.send_data.date_added | date: 'h:mm a'}}</span>
      <span *ngIf="data.send_data.show_ip"> through IP:
        {{data.send_data.ip_address.includes('::fff') ? data.send_data.ip_address.substr(7) :
        data.send_data.ip_address}}
      </span>
    </span>
  </div>
</div>

<!-- <====================================================================================> -->


<div class="dialog-header verify-user" *ngIf="data.type == 214">
  <h2 mat-dialog-title class="text-start h3 mb-0 px-4 pb-3 pb-md-0 pt-md-5 px-sm-5 mat-dialog-title" style="white-space: pre-line;">
    {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="px-sm-5 py-3 w-100">
    <div id="videoPlayer1">
      <iframe [src]="data.url  | vimeoUrl" style=" width: 100%; border: 1px solid #eee; border-radius: 4px;"
        frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay">

      </iframe>
    </div>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 215" style="max-width:800px;">
  <h2 mat-dialog-title class="text-start h3 mb-0 px-4 pb-3 pb-md-0 pt-md-5 mat-dialog-title">
    Select Location
    <mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content class="py-3 w-100">
    <div class="row support-card justify-content-center">
      <div class="col-12">
        <div class="loaction_wrapper" [class.towgrid]="_shared.locations?.length == 2">
          <div *ngFor="let loc of _shared.locations" class="item_scale">
            <div class="item bg-white item-shadow box-contents h-100 pt-4 p-3 d-flex" tappable
              (click)="dialogRef.close(loc)">
              <div class="icon ms-2">
                <div class="icon-wrap d-flex me-3">
                  <img [src]="loc.doctor_image ? loc.doctor_image : 'assets/img/svg/business_placehold.svg'">
                </div>
              </div>
              <div class="ms-2 mt-3">
                <h4 style="word-break: break-all;">{{loc.location_name ? loc.location_name : loc.practice_name |
                  titlecase}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="dialog-header verify-user" *ngIf="data.type == 216" style="max-width:800px;">
  <h2 mat-dialog-title class="text-start mb-0 px-4 pb-3 pb-md-0  mat-dialog-title" style="font-size: 30px !important;">
    <span class="px-3 d-inline-block pot-trans" *ngIf="pot_contract_step == 1" style="width: 90%;">
      What type of payment plan do you want to create?
    </span>
    <span class="px-3 d-inline-block pot-trans" *ngIf="pot_contract_step == 2" style="width: 90%;">
      Select the type of service you want to create
    </span>
    <span class="px-1 pt-4 d-inline-block float-right"><mat-icon (click)="dialogRef.close()" class="close pull-right">close</mat-icon></span>
  </h2>
  <div mat-dialog-content class="py-3 w-100">
    <div class="row support-card justify-content-center g-0 ">
      <ng-container>
        <div class="choosePaymentType transition w-100 px-3">
          <!-- choose contract type -->
            <div class="w-100 payment_type_options h-100" *ngIf="pot_contract_step==1">
                <div class="mt-3 mi-w-280 m-w-550 w-100 ">
                    <div class="card m-w-550 py-2 mb-3 card_payment_type pointer hover_nofee"
                        [tooltip]="'You’ll receive the full payment plan amount, and all your payments are protected.'"
                        [customClass]="'dark-theme-tooltip'" [placement]="'right'" [placementModal]="'1'"
                        tabindex="1"
                        *ngIf="[2,3,5,7,10,11,14,17,19,20,21,22].includes(financing_type)"
                        (click)="changeMyScreen(2,2)">
                        <div class="px-2 py-3 d-flex">
                            <img class="image_write ps-2" src="assets\img\svg\No Fee Payment Plan.svg"
                                alt="">
                            <span class="px-3">
                                <p class="f-c-p-1 h5 fw-bold">No Fee Payment Plan</p>
                                <p class="f-c-p-7 fs-16">Protected payments</p>
                            </span>
                        </div>
                    </div>

                    <div class="card m-w-550 py-2 mb-3 card_payment_type pointer in_house"
                        [tooltip]="'With In-House Payment Plan, you set the interest and keep it. Denefits will only charge you a small transaction fee.'"
                        [customClass]="'dark-theme-tooltip'" [placement]="'right'" [placementModal]="'1'"
                        (click)="changeMyScreen(3,2)"
                        *ngIf="[4,5,8,10,15,20,22,23].includes(financing_type)"
                        tabindex="3">
                        <div class="px-2 py-3 d-flex">
                            <img class="image_write ps-2" src="assets\img\svg\In House Payment Plan.svg"
                                alt="">
                            <span class="px-3">
                                <p class="f-c-p-1 h5 fw-bold">In House Payment Plan</p>
                                <p class="f-c-p-7 fs-16">You keep the interest</p>
                            </span>
                        </div>
                    </div>

                    <!-- EZ Deferred -->

                    <div class="card m-w-550 py-2 mb-3 card_payment_type pointer in_house"
                    [tooltip]="'Deferred interest period allows customers to pay off their purchase without accruing interest, making immediate purchases more attractive.'"
                    [customClass]="'dark-theme-tooltip'" [placement]="'right'" [placementModal]="'1'"
                    (click)="changeMyScreen(6,2)"
                    *ngIf="[12,13,14,15,16,17,18,19,20,21,22,23].includes(financing_type)"
                    tabindex="3">
                    <div class="px-2 py-3 d-flex mb-2 mt-1">
                        <img class="image_write pl-2" src="assets\img\svg\ez_payment_plan.svg"
                            alt="">
                        <span class="px-3">
                            <p class="f-c-p-1 h5 font-weight-bold">EZ Payment Plan (Deferred)</p>
                            <p class="f-c-p-7 fs-16 mb-0">Deferred Interest for 12 Months</p>
                        </span>
                    </div>
                  </div>

                </div>
            </div>
            <!-- choose payment type -->
            <div class="w-100 payment_type_options h-100" *ngIf="pot_contract_step==2">
              <div class="mt-3 mi-w-280 m-w-550 w-100 ">
                  <div class="card m-w-550 py-2 mb-3 card_payment_type pointer in_house"
                      [tooltip]="'Use this option if the service amount is fixed'"
                      [customClass]="'dark-theme-tooltip'" [placement]="'right'" [placementModal]="'1'"
                      tabindex="1"
                      (click)="addServicepopup(1);">
                      <div class="px-2 py-3 d-flex">
                          <img class="image_write ps-2" src="assets\img\svg\inhouse_plan.svg"
                              alt="">
                          <span class="px-3">
                              <p class="f-c-p-1 h5 fw-bold">{{doctorSettings.show_variable_service == 1 ? this.data.send_data.add_product.title : 'Add Service'}}</p>
                              <p class="f-c-p-7 fs-16">Use this option if the service amount is fixed</p>
                          </span>
                      </div>
                  </div>

                  <div class="card m-w-550 py-2 mb-3 card_payment_type pointer hover_nofee"
                      [tooltip]="'Use this option if the service amount is changable'"
                      [videoLink]="'https://vimeo.com/725917129'"
                      [videoTitle]="'Pay Over Time with Denefits'"
                      [customClass]="'dark-theme-tooltip'" [placement]="'right'" [placementModal]="'1'"
                      tabindex="3" *ngIf="doctorSettings.show_variable_service == 1">
                      <div class="px-2 py-3 d-flex" (click)="addServicepopup(2);">
                          <img class="image_write ps-2" src="assets\img\svg\nff_plan.svg"
                              alt="">
                          <span class="px-3">
                              <p class="f-c-p-1 h5 fw-bold">Add Variable Service</p>
                              <p class="f-c-p-7 fs-16">Use this option if the service amount is changable
                              </p>
                          </span>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<div class="dialog-header mb-3" *ngIf="data.type == 761">
  <h2 mat-dialog-title class="px-4" style="text-transform: none !important;"> {{data.title}}
    <mat-icon (click)="dialogRef.close()" class="close pull-right close-sign">close</mat-icon>
  </h2>
  <span class="plan-sm-txt pb-2 d-inline-flex px-3">Please tell us your reason for not making a payment plan:</span>

  <div mat-dialog-content [ngStyle]="{'min-height': reason.includes(100) ? '17vw': '10vw' }" class="mt-0">
    <div class="col-sm-12 px-0 py-1" *ngFor="let item of reasonsData; let i=index">
        <input type="checkbox" class="pointer" name="complete_later" [id]="'complete_later' + i"
        (change)="selectReason(item.reason_id)">

      <label [for]="'complete_later' + i" class="d-inline-block">
        <span class="f-s-18-w-400 px-2 d-inline-block">
          {{item.reason_name}}
        </span>
      </label>
    </div>

    <div class="col-sm-12" *ngIf="reason.includes(100)" style="padding-left: 2.3rem;">
      <div class="custom_text_area">
        <textarea class="append text_reason mt-2" placeholder="Write us your issue, we would like to help you!" [(ngModel)]="other_reason"
          required (keydown)="checkReason($event)"></textarea>
      </div>
    </div>

  </div>
  <div class="ms-3" mat-dialog-actions>
    <button mat-stroked-button class="me-3" [disabled]="!showCloseBtn" style="padding:10px 16px; height:auto !important" (click)="sendCloseData()">Send & Close</button>
    <button button-primary-auth class="px-4 py-3" (click)="this.dialogRef.close();">Back To Payment Plans</button>
  </div>
</div>

<div class="dialog-header verify-user addded" *ngIf="data.type == 101">
  <h2 mat-dialog-title class="text-center h3">{{data.title}}
    <mat-icon (click)="dialogRef.close(0)" class="close pull-right">close</mat-icon>
  </h2>
  <div class="ms-5">
    <img style="display: block; margin-left: auto; margin-right: auto; width: 50%;" src="assets/img/svg/lock.svg">
  </div>
  <div mat-dialog-content class="p-3 text-center">
    <h3>This feature is not available in your plan</h3>
    <p *ngIf="userInfo[0].role_id == 4">But you can unlock it on upgrading!</p>
    <p *ngIf="userInfo[0].role_id == 5">Please connect with your Business Owner to upgrade the subscription plan.

    </p>
  </div>
  <div class="mt-3" style="text-align: center;" *ngIf="userInfo[0].role_id == 4">
    <button (click)="upgradeSubscription()" button-primary-auth class="button">Upgrade My
      Subscription</button>
  </div>
</div>

<!-- cancel subscription  -->
<div *ngIf="data.type == 300 && data.send_data.cancel==false" >
  <div>
    <div class="d-flex justify-content-between align-items-center border-bottom p-3">
      <p class="m-0 p-0" style="color:#596775;font-size: 14px"> <span style="color:#0A0A0A;font-size: 14px;font-weight: 600;"> {{subscibtion_plan_data.sub_name}} </span> ${{subscibtion_plan_data.sub_cost}} monthly  <span style="color:#00BC8B;font-size: 12px;background-color:#D8FFEF ;border-radius: 136px;padding: 6px 8px;margin-left: 10px;">Active</span></p>
      <mat-icon (click)="dialogRef.close()" class="close m-0 p-0" style="cursor: pointer;">close</mat-icon>
    </div>
    <div class="p-3">
      <p class="m-0 p-0 mb-4" style="color:#0A0A0A;font-size: 14px;font-weight: 800;">Are you sure you want to cancel subscription?</p>

      <div class="d-flex justify-content-between align-items-center">
        <div style="width: 100%;max-width: 320px;">
          <p class="p-0 m-0" style="color:#0A0A0A;font-size: 14px;font-weight: 600;">Do you have a question or a problem?</p>
          <p class="m-0" style="color:#596775;font-size: 14px;font-weight: 400;">Feel free to contact us if you need assistance.</p>
        </div>
        <button style="color: #fff; padding: 6px 7px;border: 1px solid #C3C8CD; border-radius: 8px;background-color: #1581E5;font-size: 14px;font-weight: 600;" (click)="openWriteToUs()">Contact Now</button>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <div style="width: 100%;max-width: 341px;">
          <p class="p-0 m-0 " style="color:#0A0A0A;font-size: 14px;font-weight:600;">Change your plan</p>
          <p class="m-0" style="color:#596775;font-size: 14px;font-weight: 400;">If you are not happy with your current plan, you can downgrade or upgrade it.</p>
        </div>
        <button style="color: #1581E5; padding: 6px 7px;border: 1px solid #C3C8CD; border-radius: 8px;background-color: #FFFFFF;font-size: 14px;font-weight: 600;" [routerLink]="['/app/pricing']" (click)="dialogRef.close()">Change Plan</button>
      </div>
    </div>
      <div class="d-flex justify-content-between align-items-center mt-4 border-top p-3">
        <p class="m-0" style="color:#FF0909;font-size: 16px;font-weight: 400;cursor: pointer;" (click)="dialogRef.close(changeSubApis.cancel_subscription)">Continue to cancel subscription</p>
        <p  class="m-0" style="color:#1581E5;font-size: 16px;font-weight: 600;cursor: pointer;" (click)="dialogRef.close()">Don’t Cancel</p>
      </div>
  </div>
</div>


<!-- restrore sybscription -->
<div *ngIf="data.type == 301 && data.send_data.cancel" >
  <div>
    <div class="d-flex justify-content-between align-items-center border-bottom p-3">
      <p class="m-0 p-0"  style="color:#596775;font-size: 14px;"><span style="color:#0A0A0A;font-size: 14px;font-weight: 600;">{{subscibtion_plan_data.sub_name}}</span>
        <span class="notranslate">${{subscibtion_plan_data.cost_changed_amount}}</span> monthly <span style="color:#00BC8B;font-size: 12px;background-color:#D8FFEF ;border-radius: 136px;padding: 6px 8px;margin-left: 10px;">Active</span></p>
      <mat-icon (click)="dialogRef.close()" class="close m-0 p-0" style="cursor: pointer;">close</mat-icon>
    </div>

    <div class="p-3">
      <p style="color:#05141F;font-size: 16px;font-weight: 400;"> You are about to restore your subscription to the {{subscibtion_plan_data.sub_name}} Plan.</p>
      <button (click)="dialogRef.close(changeSubApis.restore_subscription)" style="color: #1581E5; padding: 6px 7px;border: 1px solid #C3C8CD; border-radius: 8px;background-color: #FFFFFF;">Confirm</button>
    </div>
  </div>
</div>


<div class="dialog-header" *ngIf="data.type == 444">
  <div class="d-flex justify-content-between align-item-center text-center"></div>
  <div class="inner-content text-center">
    <img src="assets/img/png/pay-success.png" alt="" class="mb-4 filter">
    <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;" *ngIf="data.send_data.firstData || data.send_data.upgradeData">Payment Successful </h4>
    <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;" *ngIf="data.send_data.downgradeData && data.send_data.downgradeData.is_grace_period < 1">Your <span style="color:#1581E5">{{data.send_data.downgradeData.plan_name}} Plan</span>
      will be activated from the next billing cycle
    </h4>
    <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;" *ngIf="data.send_data.downgradeData && data.send_data.downgradeData.is_grace_period > 0">Your <span style="color:#1581E5">{{data.send_data.downgradeData.plan_name}} Plan</span>
      has been activated
    </h4>

    <p class="para pay-text fs-16" *ngIf="data.send_data.firstData">
      Thank you!
      For subscribing to {{data.send_data.firstData.plan_name}} Plan! <br>
      You now have access to our exclusive features. <br>
      Visit your profile settings to manage your subscription.
    </p>

    <p class="para pay-text fs-16" *ngIf="data.send_data.upgradeData">
      Your subscription plan has been successfully upgraded to <span class="pay-label-text">{{data.send_data.upgradeData.plan_name}} Plan</span>.
      You now have access to a wider range of features and benefits that come with this plan. <br>
      Your upgraded plan will become effective immediately and your next billing cycle will be charged accordingly.
    </p>

    <p class="para pay-text fs-16" *ngIf="data.send_data.downgradeData && data.send_data.downgradeData.is_grace_period < 1">
      You have opted to downgrade your <span class="pay-label-text">{{data.send_data.userPlan.sub_name}} Plan</span> and switch to the <span class="pay-label-text">{{data.send_data.downgradeData.plan_name}} Plan</span>.
      Please be aware that you will still have access to all of your <span class="pay-label-text">{{data.send_data.userPlan.sub_name}} Plan</span> features until
      <span class="pay-label-text notranslate">{{data.send_data.downgradeData.downgrade_date | date}}</span>.
      After that date, your card will be charged for <span class="pay-label-text">{{data.send_data.downgradeData.plan_name}} Plan</span> subscription fees.
    </p>
    <p class="para pay-text fs-16" *ngIf="data.send_data.downgradeData && data.send_data.downgradeData.is_grace_period > 0">
      You have opted to downgrade your <span class="pay-label-text">{{data.send_data.userPlan.sub_name}} Plan</span> and switch to the <span class="pay-label-text">{{data.send_data.downgradeData.plan_name}} Plan</span>.
      Starting from now, you'll no longer have access to the features provided in the <span class="pay-label-text">{{data.send_data.userPlan.sub_name}} plan.</span>
    </p>
    <p class="para pay-text fs-16" *ngIf="data.send_data.payInAdvance">
      You have paid in advance for your <span class="pay-label-text">{{data.send_data.payInAdvance.plan_name}} Plan !</span><br> <span class="pay-label-text">30 days</span> have been added in your subscription duration.
    </p>

    <div class="bottom-data text-center">
      <button class="bank" [routerLink]="['/app/dashboard']" (click)="dialogRef.close()">Go To Dashboard</button>
    </div>
  </div>
</div>


<!-- Send Proposal -->
<div class="dialog-header proposal-div" *ngIf="data.type == 999" [ngStyle]="{ 'width' : fillForm ? '1050px' : '500px'}" style="max-height: 650px;overflow: auto;">
  <div *ngIf="!proposalSent">
    <h2 mat-dialog-title class="f-w-800 px-4">
      {{fillForm == false ? "Choose payment plans" : "Customer details"}}
      <mat-icon (click)="dialogRef.close()" class="close pull-right close-sign">close</mat-icon>
    </h2>

    <div class="contract_to_Send px-3" style="max-width: 500px;max-height: 500px;overflow: auto;scroll-behavior: smooth;"  *ngIf="!fillForm">
      <p class="h5 px-4 fs-18">Choose the plans that you want to include in this payment proposal</p>

      <div class="" *ngFor="let item of data.allContracts;let i = index;" class="w-100 py-2 px-4 pointer" style="z-index: 999999999 !important;" >
        <label [for]="'aw'+i" class="w-100 d-flex align-item-center justify-content-around p-2 border border_10 pointer mb-0">
          <span class="flex-grow-1 d-flex align-items-center justify-content-start pointer">
            <input type="checkbox" [name]="'aw'+i" [id]="'aw'+i" class="" [checked]="item.checked"
              (change)="checkFunction($event,i)"  class="pointer"/>
              <label [for]="'aw'+i"class="me-0 mt-0" style="margin-top: -10px !important;"></label>
            <!-- Months -->
            <p class="flex-grow-1 fs-16 fw-bold mb-0 pointer">
              {{item.month}} Months
            </p>
          </span>
          <span class="d-felx align-items-center h-100 pointer">
            <p class="flex-grow-1 px-3 py-2 mb-0 pointer">
              <span class="f-c-p-1 pointer notranslate">${{item.recurring_amount | number:'1.2-2'}}</span>
              <span class="f-c-p-3 fw-normal h6 pointer"> per month</span>
            </p>
          </span>
        </label>
      </div>
      <div class="px-4 d-flex align-items-center py-3 justify-content-between">
        <button button-primary-auth (click)="fillForm = true" id="send_proposal" [disabled]="checkboxed.length == 0">Confirm</button>
        <button *ngIf="!fillForm && checkboxed.length  > 0" button-login-secondary type="button"
          (click)="downloadPdf()">Download Pdf</button>
      </div>
    </div>
    <ng-container *ngIf="add_proposal_users.length>0">
      <div class="px-4 mb-3" *ngFor="let item of add_proposal_users; let i=index">
        <div class="col-12 proposal_added_list p-0 d-flex  flex-wrap">

          <div class=" py-2 col-xs-12 col-md-3 col-sm-6 custom_border_package_list " >
            <span>Name</span>
            <p style="word-break: break-all;">{{item.patient_first_name + ' '+ item.patient_last_name}}</p>
          </div>
          <div class="py-2 px-0 col-xs-12 col-md-3 col-sm-6 custom_border_package_list " >
            <span>Contact number</span>
            <p>+1-{{item.patient_mobile}}</p>
          </div>
          <div class="py-2 col-xs-12 col-md-5 col-sm-6 custom_border_package_list ">
            <span>Email address</span>
            <p style="word-break: break-all;">{{item.patient_email}}</p>
          </div>
          <div class="py-2 col-xs-12 col-md-1 col-sm-6 custom_border_package_list border-left">
            <div class="d-flex justify-content-center mt-3">
              <img *ngIf="!editpatientVal" src="assets/img/png/edit.png" class="me-2" (click)="editSpecificPatient(i)">
              <img src="assets/img/png/trash.png" (click)="removeSpecificPatient(i)"> </div>
          </div>
        </div>
      </div>
    </ng-container>


    <form class="container text-start form-cont p-0 py-2" *ngIf="fillForm" #sendProposalForm="ngForm" (ngSubmit)="sendCustomerProposal(sendProposalForm,2)">
      <div class="row d-flex p-0 pb-3 px-3" mat-dialog-content *ngIf="data && data.send_data">
        <ng-container *ngIf="editpatientVal && showNewInputs">
          <div class="col-3 mb-3">
            <div class="custom-form b-10 m-h-56">
              <input type="text" class="input_field px-3 pt-3" name="first_name" required  [(ngModel)]="user_obj.patient_first_name" maxlength="25" (keypress)="mainService.handleInputSpace($event)"/>
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  First Name
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form  b-10 m-h-56">
              <input type="text" class="input_field px-3 pt-3" name="last_name" required [(ngModel)]="user_obj.patient_last_name" maxlength="25" (keypress)="mainService.handleInputSpace($event)"/>
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Last Name
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form  b-10 m-h-56">
              <input type="text" class="input_field px-3 pt-3" name="user_email" #user_email="ngModel" email required
                [(ngModel)]="user_obj.patient_email" (keypress)="mainService.handleInputSpace($event)" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Customer Email Address
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form">
              <span *ngIf="user_obj.patient_mobile && user_obj.patient_mobile !== ''"
                class="pt-2 pe-1 fw-bold dollar_input"  style="position: absolute;left: 14px;bottom: 8px;">
                +1
              </span>
              <input type="text" class="input_field pt-3" name="user_phone" #user_phone="ngModel"
              required [mask]="mask" [(ngModel)]="user_obj.patient_mobile"  [ngStyle]="{'padding-left': user_obj.patient_mobile!== '' ? '40px' : '1rem' }"  />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Phone Number
                </span>
              </label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!editpatientVal && showNewInputs">
          <div class="col-3 mb-3">
            <div class="custom-form b-10 m-h-56">
              <input type="text" [disabled]="data.send_data.first_name !== '' && data.send_data.page_type == 'Payment' " class="input_field px-3 pt-3" name="first_name" required
                [(ngModel)]="data.send_data.first_name" maxlength="25" (keypress)="mainService.handleInputSpace($event)"/>
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  First Name
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form  b-10 m-h-56">
              <input type="text" [disabled]="data.send_data.last_name !== '' && data.send_data.page_type == 'Payment' " class="input_field px-3 pt-3" name="last_name" required
                [(ngModel)]="data.send_data.last_name" maxlength="25" (keypress)="mainService.handleInputSpace($event)"/>
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Last Name
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form  b-10 m-h-56">
              <input type="text" [disabled]="data.send_data.user_email !== '' && data.send_data.page_type == 'Payment' " class="input_field px-3 pt-3" name="user_email" #user_email="ngModel" email required
                [(ngModel)]="data.send_data.user_email" (keypress)="mainService.handleInputSpace($event)" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Customer Email Address
                </span>
              </label>
            </div>
          </div>

          <div class="col-3 mb-3">
            <div class="custom-form">
              <span *ngIf="data.send_data.user_phone && data.send_data.user_phone !== ''"
                class="pt-2 pe-1 fw-bold dollar_input"  style="position: absolute;left: 14px;bottom: 8px;">
                +1
              </span>
              <input type="text" [disabled]="data.send_data.user_phone !== '' && data.send_data.page_type == 'Payment' " class="input_field pt-3" name="user_phone" #user_phone="ngModel"
              required [mask]="mask" [(ngModel)]="data.send_data.user_phone"  [ngStyle]="{'padding-left': data.send_data.user_phone !== '' ? '40px' : '1rem' }"  />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Phone Number
                </span>
              </label>
            </div>
          </div>
        </ng-container>
        <div class="col-12 d-flex justify-content-start mt-1 mb-3">
          <button *ngIf="!editpatientVal && showNewInputs && showcancell" button-login-secondary type="button"  class="me-3 px-4"
            (click)="showNewInputs = false">Cancel</button>
          <button *ngIf="editpatientVal && showNewInputs" button-login-auth type="button"  class="add_btn px-4 py-2"
            (click)="addNext(sendProposalForm,1)">Save</button>
          <span *ngIf="!editpatientVal && showNewInputs" class="mt-3" style="font-weight: 700; font-size: 16px;line-height: 24px;color: #1581E5; cursor: pointer;"
            (click)="addNext(sendProposalForm,1)">+ Add Another</span>
          <!-- <div for="profile-img">
            <span style="font-weight: 400; font-size: 14px;line-height: 24px;color: #596775;">
              Do you have multiple customers?
            </span>
            <label for="importCsv">
              <span for="profile-img" style="font-weight: 700; font-size: 14px;line-height: 24px;color: #1581E5;cursor: pointer;padding-left: 0.25rem;">
                Upload CSV or XLSX
              </span>
            </label>
            </div>
            <input id="importCsv" type="file" (change)="importFile($event.target.files)" accept=".xlsx, .xls, .csv" class="d-none" /> -->
        </div>

        <h6 class="col-sm-12 fw-bold d-flex align-items-center mt-2">
          <span class="me-1">How long will the proposal be valid?</span>
          <span [tooltip]="'This proposal will expire after the number of days selected here.'"
            [customClass]="'dark-theme-tooltip'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </h6>

        <!-- Validity Selector -->
        <div class="col-12 col-xl-6">
          <div class="wrap m-h-56 h-100 h-56 d-block">
            <div class="select w-100 h-100 h-56">
              <select required [(ngModel)]="proposalDurationModel" [ngModelOptions]="{standalone: true}"
                (change)="onChange(proposalDurationModel)"
                class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                <option class="w-100 py-3 px-2" *ngFor="let d of proposalDuration" [value]="d.value">
                  {{d.label}}
                </option>
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <span class="select-bar-1"></span>
              <label class="select-label f-c-p-3">Proposal Valid Till</label>
            </div>
          </div>
        </div>
        <!-- Range selector -->
        <div class="custom-field -date pb-2 mt-3" *ngIf="proposalDurationModel == 'Custom Date'">
          <div class="row m-0">
            <div class="col-6">
                <div class="custom-form d-flex align-items-center startDate m-h-56" [ngClass]="[!data.send_data.startDate && sendProposalInvalid  ? 'inputContainer' : '']">
                  <input class="input_field px-3 pt-3 notranslate" [matDatepicker]="startPicker" (click)="startPicker.open()" readonly
                    [(ngModel)]="data.send_data.startDate" [max]="data.send_data.endDate"
                    [min]="data.send_data.startMinDate" name="startDate" #startDate="ngModel" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Start date
                    </span>
                    <span style="position: absolute;top: 15px;right: 0px;">
                      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                      <mat-datepicker #startPicker disabled="false" startView="month"></mat-datepicker>
                    </span>
                  </label>
              </div>
              <p class= "mat-error" *ngIf="!data.send_data.startDate && sendProposalInvalid">
                Please enter start date
              </p>
            </div>

            <div class="col-6">
                <div class="custom-form  d-flex align-items-center startDate m-h-56" [ngClass]="[!data.send_data.endDate && sendProposalInvalid  ? 'inputContainer' : '']">
                  <input class="input_field px-3 pt-3 notranslate" [matDatepicker]="endPicker" (click)="endPicker.open()" readonly
                    [(ngModel)]="data.send_data.endDate" [max]="data.send_data.endMaxDate"
                    [min]="data.send_data.startDate || data.send_data.startMinDate" name="endDate" #endDate="ngModel" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      End date
                    </span>
                    <span style="position: absolute;top: 15px;right: 0px;">
                      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                      <mat-datepicker #endPicker disabled="false" startView="month"></mat-datepicker>
                    </span>
                  </label>
                </div>
              <p class= "mat-error" *ngIf="!data.send_data.endDate && sendProposalInvalid">
                Please enter end date
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex py-3 px-4 mx-2">
        <button *ngIf="fillForm && data.send_data.page_type != 'Payment' && showNewInputs " button-login-secondary type="button"
          (click)="sendProposalForm.reset()" class="me-3">Reset</button>
        <button button-primary-auth type="submit">{{data.action}}</button>
      </div>
    </form>
  </div>

  <div class="container text-start p-0 text-center" *ngIf="proposalSent">
    <img src="assets/img/gif/right_mark11.gif" alt="Proposal sent successfully" >
    <h1 mat-dialog-title class="pt-2">Payment Proposal Sent</h1>
    <p class="py-4 px-5">The payment proposal has been sent to your Customer via email or text message. When your Customer
      chooses a plan and makes a payment, they will automatically be financed.</p>

    <div class="row p-2 pt-2 text-center">
      <div class="col-sm-12 text-center d-flex align-item-center justify-content-around">
        <button *ngIf="currentPath == '/app/finance'" button-primary-auth (click)="dialogRef.close(this.data && this.data.downpaymentCost && this.data.downpaymentCost ? 1 : 0)">
          Finance New Customer
        </button>
        <button *ngIf="currentPath == '/app/contract/split-list'" button-primary-auth (click)="routeMeV2('/app/finance')">
          Finance New Customer
        </button>
        <button button-login-secondary
          (click)="dialogRef.close(0)">View Proposal</button>
      </div>
    </div>
  </div>
</div>
<!-- remind me later -->
<div class="dialog-header" *ngIf="data.type == 600">
<div>
  <div class="p-3">
    <mat-icon (click)="dialogRef.close(0)" class="close pull-right pointer">close</mat-icon>
  </div>
  <div class="p-3 text-center">
    <img src="assets/img/gif/right_mark11.gif" alt="" width="156px">
    <p class="m-0 p-0"  style="color:#0A0A0A;font-size: 20px;font-weight: 700;">Reminder successfully set</p>
    <p class="fs-14 fw-400" style="color:#3F4446">A reminder has been set for <span class="notranslate"> {{data.send_data.renewal_before_two | date}}</span>, for your subscription renewal.</p>
    <!-- <button button-primary-auth (click)="dialogRef.close(1)">Confirm Now</button> -->
  </div>
</div>
</div>

<div class="dialog-header" *ngIf="data.type == 601">
  <div>
    <div class="p-3" (click)="dialogRef.close(0)">
      <img src="\assets\img\png\close-circle.png" alt="" class="close-image">
    </div>
    <div class="p-3">
      <div class="text-center">
        <img src="\assets\img\svg\sad.png" alt="" >
        <p style="font-weight: 700;font-size: 20px;color: #0A0A0A;" class="mt-3">We’re sad to see you go</p>
        <p class="fs-16 fw-400 p-3" style="color:#5F666D">You have opted to cancel your <span class="fw-600" style="color: #0A0A0A;">{{data.send_data.plan}}</span> Plan and switch to the Free plan. Please be aware that you will still have access to all of your <span class="fw-600"  style="color: #0A0A0A;">{{data.send_data.plan}}</span> Plan features until <span class="fw-600 notranslate" style="color: #0A0A0A;">{{data.send_data.renewal_date | date}}</span>. After that date, your card will not be charged for any subscription fees.</p>
        <i>If you want to come back, It’s just a click away</i>
        <div class="d-flex justify-content-center flex-column align-items-center mt-3">
          <button button-primary-auth (click)="dialogRef.close(1)">Restore Subscription</button>
          <button button-login-secondary (click)="dialogRef.close(2)" class="mt-3" style="width: fit-content;">Go To Dashboard</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 602">
  <div class="p-3">
    <div (click)="dialogRef.close(1)">
      <img src="\assets\img\png\close-circle.png" alt="" class="close-image">
    </div>
    <div class="px-3">
      <div class="text-center">
        <img src="assets/img/gif/right_mark11.gif" alt="" width="200px" style="display: inline;">
        <p style="font-weight: 700;font-size: 20px;color: #0A0A0A;" class="mt-2">Thank you for submitting your query</p>
        <p class="fs-16 fw-400 p-3" style="color:#5F666D">Our team has received your query and will review it shortly. We will contact you as soon as possible with a response. Thank you for your patience.</p>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header pricingDailog" *ngIf="data.type == 603">
  <h2 mat-dialog-title style="padding:24px">
    <!-- {{data.title=='Add Card'?'Add new card': (data.send_data.card_list.length == 0 ? 'Add Card For Subscription':data.title))}} -->
      {{data.title=='Add Card' ? 'Add new card' : (data.send_data.card_list && data.send_data.card_list.length == 0  ? 'Add Card For Subscription' : data.title)}}
      <mat-icon style="transform: translate(-5%, -10%) !important;" (click)="dialogRef.close()" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content style="height: 80vh !important; max-height: 80vh !important;">
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0" style="margin: 5px 16px;">
      <p class="fs-16 f-w-600">Select or add new card for subscription payment.</p>
    </div>
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0">
      <div class="card-list mb-2">
        <div *ngFor="let card of data.send_data.card_list; let i=index" >
          <label style="cursor:pointer;border-radius: 15px !important;" [ngClass]="{border_added: data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id}"
          class="col-12 bg-light d-flex justify-content-between align-items-center p-3 mb-2"  [for]="'prior' + i">
          <div class="d-flex align-items-center active">
            <span style="line-height:0;">
              <img style="width:24px;"
                [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express' || card.brand=='UnionPay'|| card.brand=='Diners Club';else no_card " />
              <ng-template #no_card>
                <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
              </ng-template>
            </span>
            <span class="card-num font-light" style="color: #6B7376 !important">&nbsp;&nbsp;**** **** **** {{card.last4}}</span>

          </div>
            <input type="radio" [id]="'prior' + i" name="prior" (change)="selectCardForPayment(card);" [checked]="data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id">
            <label [for]="'prior' + i" class="mb-auto"></label>
            <!-- <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card);">Select</button> -->
        </label>
        </div>

      </div>
      <div class="p-3 text-center mb-1 d-flex justify-content-between align-items-center" *ngIf="data.send_data.card_list.length">
        <hr class="rotote">
        <span class="fs-16 f-w-800">Add New</span>
        <hr class="rotote">
      </div>
    </div>
    <form [formGroup]="addCardForm" (ngSubmit)="addCardSubmit()">
      <div class="row me-0 ms-0">
        <span class="ps-3 fs-16 f-w-800">Card Details</span>
        <div class="col-md-12 form-cont mb-2 mt-2">
          <div
            [ngClass]="[addCardForm.controls.cardholder_name.touched && addCardForm.controls.cardholder_name.invalid ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-2 pt-3" formControlName="cardholder_name" name="cardholder_name" required
              trim  maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Card Holder Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="iscardSubmitted && addCardForm.controls.cardholder_name.invalid">
            Please enter card holder name.
          </p>
        </div>
        <div class="col-md-12">
          <div class="stripe-card" id="add_card"></div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="data && data.send_data && data.send_data.user_info && (data.send_data.user_info.business_verification_state == 'other_info_updated' ||
        data.send_data.user_info.business_verification_state == 'persona_verified')">
        <!-- <div class="col-md-12 mt-2"> -->
        <input type="checkbox" class="pointer" name="billing_check" id="billing_check" formControlName="checked"
          (change)="showAddressField = !showAddressField">
        <label for="billing_check">
          <span style="font-weight: 400; font-size: 14px; color: #313A44;">
            Choose {{data.send_data.type}} address as billing address
          </span>
        </label>
      </div>
      <div *ngIf="showAddressField" class="billing-address-section mt-2">
        <span class="ps-3 fs-16 f-w-800">Billing Address</span>
        <div class="col-md-12 form-cont mb-3 mt-2">
          <div
            [ngClass]="[(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||  (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required) ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-3 pt-3" formControlName="new_address_1" name="new_address_1" required trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Address Line 1
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||
                (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required)">
            Please enter address.
          </p>
        </div>

        <div class="col-md-12 form-cont mb-3">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" formControlName="new_address_2" name="new_address_2" trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text"
              [ngClass]="[addCardForm.controls.new_address_2 && addCardForm.controls.new_address_2.value !== '' ? 'label-name' : '']">
              <span class="content-name f-c-p-3">
                Address Line 2 (Optional)
              </span>
            </label>
          </div>
        </div>

        <div class="col-md-12 form-cont">
          <!-- <zip-selector (zipSelected)="getZipselected($event)" [placeholder]="" t="2"
            [customClass]="[(addCardForm.controls.zip_code.invalid && addCardForm.controls.zip_code.touched) || (iscardSubmitted && addCardForm.controls.zip_code.errors?.required)  ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']"
            [isRequired]="true" id="zip" name="zip" [model]="zipCode" ngDefaultControl>
          </zip-selector> -->
          <app-google-api (setAddress)="getZipselected($event)" [t]="1" [customClass]="[(addCardForm.controls.zip_code.invalid && addCardForm.controls.zip_code.touched) || (iscardSubmitted && addCardForm.controls.zip_code.errors?.required)  ? 'custom-form inputContainer' : 'custom-form']"
          id="zip" name="zip" [model]="zipCode"
          ngDefaultControl>
          </app-google-api>
          <p class="mat-error" *ngIf="addCardForm.controls.zip_code.errors?.required && iscardSubmitted">
            Please enter zip code.
          </p>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3" [ngClass]="[(addCardForm.controls.city.touched && addCardForm.controls.city.invalid) ||  (iscardSubmitted && addCardForm.controls.city.errors?.required) ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
                <input class="input_field px-3 pt-3" formControlName="city" name="city" trim  required  autocomplete="disbaled"  (blur)="updateCity(addCardForm.controls.city.value, 'user_data')"  />
                <label for="text"
                  class="label-name">
                  <span class="content-name f-c-p-3">
                    City
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="addCardForm.controls.city.errors?.required && iscardSubmitted">
                Please enter city.
              </p>
            </div>

            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3">
                <input class="input_field px-3 pt-3 disabled_field" formControlName="state" name="state" disabled trim  />
                <label for="text"
                  [ngClass]="[addCardForm.controls.state && addCardForm.controls.state.value !== '' ? 'label-name' : '']">
                  <span class="content-name f-c-p-3">
                    State
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!showAddressField" class="same-billing row ps-4 pe-4">
        <div class="col-6" style="padding: 15px">
          <div style="border: 1px solid rgba(112,112,112,0.5); padding: 15px">
            <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
            <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
            <p class="m-0">{{data.send_data.state}}
              {{data.send_data.country_code
              ?
              ', '+data.send_data.country_code:''}}
            </p>
          </div>
        </div>
        <div class="col-6" style="padding: 15px">
          <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
            <p class="text-center" style="align-self: center;margin:0">
              <a (click)="getAddressForm()" href="javascript:void(0)" style="color:#0A6B89">ADD NEW BILLING ADDRESS</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 pe-4" style="padding-left: 12px;" *ngIf="data.send_data.showDefault">
        <div class="mt-3">

          <input type="checkbox" class="pointer" name="saveDefault" id="saveDefault" formControlName="saveDefault">
          <label for="saveDefault">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Save as Default
            </span>
          </label>
        </div>
      </div>

      <small class="col-lg-12 pe-4">
        <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
          {{new_address.cardError}}</p> -->
      </small>
      <div class="d-flex justify-content-start" mat-dialog-actions>
        <!-- <button mat-stroked-button  mat-dialog-close (click)="dialogRef.close('2')"
            *ngIf="data.title!='Add Card'">{{data.title == 'Add Card' ? 'Cancel'
            : 'Back'}}</button> -->
        <button button-primary-auth [disabled]="responseSubmitted" class="add_btn px-4 ms-2">Add Now</button>
      </div>
      <div class="ps-3 ms-1 pt-3 w-100">
        <b>Note:</b>
        <ul class="ps-4" style="list-style-type: disc;">
          <li class="f-c-p-8 fs-16" style="font-weight: unset !important; text-align: unset !important;">$1 will be deducted and reversed to check the Card Authorization. </li>
          <!-- <li class="f-c-p-8 fs-16">You will be charged a dollor or 1% (whichever is higher) as an extra transaction fee if you use a non-US debit/credit card. </li> -->
        </ul>
    </div>
    </form>
  </div>
</div>

<div class="dialog-header pricingDailog" *ngIf="data.type == 604">
  <h2 mat-dialog-title style="padding:24px">
    <!-- {{data.title=='Add Card'?'Add new card': (data.send_data.card_list.length == 0 ? 'Add Card For Subscription':data.title))}} -->
      {{data.title=='Add Card' ? 'Add new card' : (data.send_data.card_list && data.send_data.card_list.length == 0  ? 'Add Card For Subscription' : data.title)}}
      <mat-icon style="transform: translate(-5%, -10%) !important;" (click)="dialogRef.close()" [routerLink]="['/app/dashboard']" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content style="height: 80vh !important; max-height: 80vh !important;">
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0" style="margin: 5px 16px;">
      <p class="fs-16 f-w-600">Select or add new card for subscription payment.</p>
    </div>
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0">
      <div class="card-list mb-2">
        <div *ngFor="let card of data.send_data.card_list; let i=index" >
          <label style="cursor:pointer;border-radius: 15px !important;" [ngClass]="{border_added: data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id}"
          class="col-12 bg-light d-flex justify-content-between align-items-center p-3 mb-2"  [for]="'prior' + i">
          <div class="d-flex align-items-center active">
            <span style="line-height:0;">
              <img style="width:24px;"
                [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express' || card.brand=='UnionPay'|| card.brand=='Diners Club';else no_card " />
              <ng-template #no_card>
                <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
              </ng-template>
            </span>
            <span class="card-num font-light" style="color: #6B7376 !important">&nbsp;&nbsp;**** **** **** {{card.last4}}</span>

          </div>
            <input type="radio" [id]="'prior' + i" name="prior" (change)="selectCardForPayment(card);" [checked]="data.send_data && data.send_data.current_card && data.send_data.current_card.source_id == card.source_id">
            <label [for]="'prior' + i" class="mb-auto"></label>
            <!-- <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card);">Select</button> -->
        </label>
        </div>

      </div>
      <div class="p-3 text-center mb-1 d-flex justify-content-between align-items-center" *ngIf="data.send_data.card_list.length">
        <hr class="rotote">
        <span class="fs-16 f-w-800">Add New</span>
        <hr class="rotote">
      </div>
    </div>
    <form [formGroup]="addCardForm" (ngSubmit)="addCardSubmit()">
      <div class="row me-0 ms-0">
        <span class="ps-3 fs-16 f-w-800">Card Details</span>
        <div class="col-md-12 form-cont mb-2 mt-2">
          <div
            [ngClass]="[addCardForm.controls.cardholder_name.touched && addCardForm.controls.cardholder_name.invalid ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-3 pt-3" formControlName="cardholder_name" name="cardholder_name" required
              trim  maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Card Holder Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="iscardSubmitted && addCardForm.controls.cardholder_name.invalid">
            Please enter card holder name.
          </p>
        </div>
        <div class="col-md-12">
          <div class="stripe-card" id="add_card"></div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="data && data.send_data && data.send_data.user_info && (data.send_data.user_info.business_verification_state == 'other_info_updated' ||
        data.send_data.user_info.business_verification_state == 'persona_verified')">
        <!-- <div class="col-md-12 mt-2"> -->
        <input type="checkbox" class="pointer" name="billing_check" id="billing_check" formControlName="checked"
          (change)="showAddressField = !showAddressField">
        <label for="billing_check">
          <span style="font-weight: 400; font-size: 14px; color: #313A44;">
            Choose {{data.send_data.type}} address as billing address
          </span>
        </label>
      </div>
      <div *ngIf="showAddressField" class="billing-address-section mt-2">
        <span class="ps-3 fs-16 f-w-800">Billing Address</span>
        <div class="col-md-12 form-cont mb-3 mt-2">
          <div
            [ngClass]="[(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||  (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required) ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-3 pt-3" formControlName="new_address_1" name="new_address_1" required trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Address Line 1
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||
                (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required)">
            Please enter address.
          </p>
        </div>

        <div class="col-md-12 form-cont mb-3">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" formControlName="new_address_2" name="new_address_2" trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text"
              [ngClass]="[addCardForm.controls.new_address_2 && addCardForm.controls.new_address_2.value !== '' ? 'label-name' : '']">
              <span class="content-name f-c-p-3">
                Address Line 2 (Optional)
              </span>
            </label>
          </div>
        </div>

        <div class="col-md-12 form-cont">
          <zip-selector (zipSelected)="getZipselected($event)" [placeholder]="" t="2"
            [customClass]="[(addCardForm.controls.zip_code.invalid && addCardForm.controls.zip_code.touched) || (iscardSubmitted && addCardForm.controls.zip_code.errors?.required)  ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']"
            [isRequired]="true" id="zip" name="zip" [model]="zipCode" ngDefaultControl>
          </zip-selector>
          <p class="mat-error" *ngIf="addCardForm.controls.zip_code.errors?.required && iscardSubmitted">
            Please enter zip code.
          </p>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3">
                <input class="input_field px-3 pt-3 disabled_field" formControlName="city" name="city" disabled trim  />
                <label for="text"
                  [ngClass]="[addCardForm.controls.city && addCardForm.controls.city.value !== '' ? 'label-name' : '']">
                  <span class="content-name f-c-p-3">
                    City
                  </span>
                </label>
              </div>
            </div>

            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3">
                <input class="input_field px-3 pt-3 disabled_field" formControlName="state" name="state" disabled trim  />
                <label for="text"
                  [ngClass]="[addCardForm.controls.state && addCardForm.controls.state.value !== '' ? 'label-name' : '']">
                  <span class="content-name f-c-p-3">
                    State
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!showAddressField" class="same-billing row ps-4 pe-4">
        <div class="col-6" style="padding: 15px">
          <div style="border: 1px solid rgba(112,112,112,0.5); padding: 15px">
            <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
            <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
            <p class="m-0">{{data.send_data.state}}
              {{data.send_data.country_code
              ?
              ', '+data.send_data.country_code:''}}
            </p>
          </div>
        </div>
        <div class="col-6" style="padding: 15px">
          <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
            <p class="text-center" style="align-self: center;margin:0">
              <a (click)="getAddressForm()" href="javascript:void(0)" style="color:#0A6B89">ADD NEW BILLING ADDRESS</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 pe-4" style="padding-left: 12px;" *ngIf="data.send_data.showDefault">
        <div class="mt-3">

          <input type="checkbox" class="pointer" name="saveDefault" id="saveDefault" formControlName="saveDefault">
          <label for="saveDefault">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Save as Default
            </span>
          </label>
        </div>
      </div>

      <small class="col-lg-12 pe-4">
        <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
          {{new_address.cardError}}</p> -->
      </small>
      <div class="d-flex justify-content-start" mat-dialog-actions>
        <!-- <button mat-stroked-button  mat-dialog-close (click)="dialogRef.close('2')"
            *ngIf="data.title!='Add Card'">{{data.title == 'Add Card' ? 'Cancel'
            : 'Back'}}</button> -->
        <button button-primary-auth [disabled]="responseSubmitted" class="add_btn px-4 ms-2">Add Now</button>
      </div>
      <div class="ps-3 ms-1 pt-3 w-100">
        <b>Note:</b>
        <ul class="ps-4" style="list-style-type: disc;">
          <li class="f-c-p-8 fs-16" style="font-weight: unset !important; text-align: unset !important;">$1 will be deducted and reversed to check the Card Authorization. </li>
          <!-- <li class="f-c-p-8 fs-16">You will be charged a dollor or 1% (whichever is higher) as an extra transaction fee if you use a non-US debit/credit card. </li> -->
        </ul>
    </div>
    </form>
  </div>
</div>


<div *ngIf="data.type == 217" class="px-5 py-4">
  <mat-icon (click)="dialogRef.close()" class="close pull-right"
    style="cursor: pointer;border: 1px solid grey;border-radius: 50%;width: 40px;height: 40px;padding: 7px;position: relative;top: -10px;right: -30px;">close</mat-icon>
  <div>
    <p class="fw-800 fs-24 f-c-p-8 mt-3" style="width: 100%;max-width: 457px;font-size: 18px;"> You are about to
      initiate debt recovery for <span style="color:#596775"> {{data.send_data.valid_records }} </span>
      {{data.send_data.valid_records > 1 ?'customers':'customer'}}. </p>
  </div>
  <form [formGroup]="arTerm">
    <!-- <div class="checkbox mb-4">
      <input type="checkbox" formControlName="terms" id="terms">
      <label for="terms" class="mb-0">
        I acknowledge that I have read, understand, and agree to be bound by Denefits' Terms and Conditions
        before proceeding to initiate Debt Recovery.
      </label>
      <p class="mat-error" *ngIf="arTerm.get('terms')?.invalid && arTerm.get('terms')?.touched">
        Please check to agree to the terms and conditions
      </p>
    </div> -->
    <div class="d-flex  align-items-center">
      <!-- <button button-primary-auth class="button" (click)="dialogRef.close(1)"
        [disabled]="arTerm.invalid">Confirm</button> -->
        <button button-primary-auth class="button" (click)="dialogRef.close(1)">Confirm</button>
    </div>
  </form>
</div>


<div class="dialog-header verify-user addded pb-5" *ngIf="data.type == 251">
  <h2 mat-dialog-title class="text-center h3">{{data.title}}
    <mat-icon (click)="dialogRef.close(0)" class="close pull-right">close</mat-icon>
  </h2>
  <div class="ms-5">
    <img style="display: block; margin-left: auto; margin-right: auto; width: 50%;height: 8rem;" src="assets/img/svg/no_left.svg">
  </div>
  <div mat-dialog-content class="text-center" style="padding: 10px 6rem;">
    <p class="fs-32 fw-900 mb-2">Limit Exhausted</p>
    <p class="fs-16">You are already <span style="color: #FF0909">sent {{doctorSettings.ar_ez_proposal_subscription}} proposals</span> under this plan.</p>
    <p *ngIf="userInfo[0].role_id == 4" class="fs-18 fw-800" style="color: rgba(0,0,0,.54);">
      Please upgrade to PLATINUM PLAN to send unlimited proposals.
    </p>
    <p *ngIf="userInfo[0].role_id == 5" class="fs-18 fw-800" style="color: rgba(0,0,0,.54);">
      Please connect with your Business Owner to upgrade the subscription plan.
    </p>
  </div>
  <div class="pb-4" style="text-align: center;" *ngIf="userInfo[0].role_id == 4">
    <button (click)="upgradeSubscription()" button-primary-auth class="button">Upgrade My
      Subscription</button>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 606">
  <div class="d-flex justify-content-between align-item-center text-center"></div>
  <div class="inner-content text-center">
    <img src="assets/img/png/pay-success.png" alt="" class="mb-4 filter">
    <h4 class="f-w-800 ps-4 pe-4" style="line-height: 32px;font-size: 24px;" *ngIf="data.send_data.firstData || data.send_data.upgradeData">Payment Successful </h4>
    <p class="para pay-text fs-16" *ngIf="data.send_data.upgradeData">
      You have renewed your <span class="pay-label-text">{{data.send_data.upgradeData.plan_name}} Plan</span>!<br>
      You now have access to our exclusive features. <br>
      Visit your profile settings to manage your subscription
    </p>
    <div class="bottom-data text-center">
      <button class="bank" [routerLink]="['/app/dashboard']" (click)="dialogRef.close()">Go To Dashboard</button>
    </div>
  </div>
</div>

<div class="dialog-header pricingDailog" *ngIf="data.type == 704">
  <h2 mat-dialog-title style="padding:24px">
    <!-- {{data.title=='Add Card'?'Add new card': (data.send_data.card_list.length == 0 ? 'Add Card For Subscription':data.title))}} -->
      {{data.title=='Add Card' ? 'Add new card' : (data.send_data.card_list && data.send_data.card_list.length == 0  ? 'Add Card For Subscription' : data.title)}}
      <mat-icon style="transform: translate(-5%, -10%) !important;" (click)="dialogRef.close()" [routerLink]="['/app/profile']" class="close pull-right">close</mat-icon>
  </h2>
  <div mat-dialog-content style="height: 80vh !important; max-height: 80vh !important;">
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0" style="margin: 5px 16px;">
      <p class="fs-16 f-w-600">Select or add new card for subscription payment.</p>
    </div>
    <div *ngIf="data.title == 'Select/Add Card for subscription' && data.send_data.card_list && data.send_data.card_list.length > 0">
      <div class="card-list mb-2">
        <div *ngFor="let card of data.send_data.card_list; let i=index" >
          <label style="cursor:pointer;border-radius: 15px !important;" [ngClass]="{border_added: selectDeafultCard && i==card_index}"
          class="col-12 bg-light d-flex justify-content-between align-items-center p-3 mb-2"  [for]="'prior' + i">
          <div class="d-flex align-items-center active">
            <span style="line-height:0;">
              <img style="width:24px;"
                [src]="card.brand?'assets/img/svg/card-type/'+card.brand+'.svg':'assets/img/svg/card-type/no_card.svg'"
                *ngIf="card.brand.toLowerCase() == 'mastercard' || card.brand=='Discover' || card.brand=='JCB' || card.brand=='Visa' || card.brand=='American Express' || card.brand=='UnionPay'|| card.brand=='Diners Club';else no_card " />
              <ng-template #no_card>
                <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
              </ng-template>
            </span>
            <span class="card-num font-light" style="color: #6B7376 !important">&nbsp;&nbsp;**** **** **** {{card.last4}}</span>

          </div>
            <input type="radio" [id]="'prior' + i" name="prior" (click)="selectSubscriptionPayment(i, card);" [checked]="selectDeafultCard && i==card_index">
            <label [for]="'prior' + i" class="mb-auto"></label>
            <!-- <button class="rounded" mat-raised-button type="submit" (click)="selectCardForPayment(card);">Select</button> -->
        </label>
        </div>

      </div>
      <div class="p-3 text-center mb-1 d-flex justify-content-between align-items-center" *ngIf="data.send_data.card_list.length && !selectDeafultCard">
        <hr class="rotote">
        <span class="fs-16 f-w-800">Add New</span>
        <hr class="rotote">
      </div>
      <div class="d-flex justify-content-start" *ngIf="selectDeafultCard" mat-dialog-actions>
        <button button-primary-auth [disabled]="responseSubmitted" (click)="payWithDefaultCard()" class="add_btn px-4 ms-2">Continue</button>
        <button button-primary-auth (click)="addNewCard()" class="add_btn px-4 ms-2">Add card</button>
      </div>
    </div>
    <form [formGroup]="addCardForm" (ngSubmit)="addCardSubmit()" *ngIf="!selectDeafultCard">
      <div class="row me-0 ms-0">
        <span class="ps-3 fs-16 f-w-800">Card Details</span>
        <div class="col-md-12 form-cont mb-2 mt-2">
          <div
            [ngClass]="[addCardForm.controls.cardholder_name.touched && addCardForm.controls.cardholder_name.invalid ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-2 pt-3" formControlName="cardholder_name" name="cardholder_name" required
              trim  maxlength="25" (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Card Holder Name
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="iscardSubmitted && addCardForm.controls.cardholder_name.invalid">
            Please enter card holder name.
          </p>
        </div>
        <div class="col-md-12">
          <div class="stripe-card" id="add_card"></div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="data && data.send_data && data.send_data.user_info && (data.send_data.user_info.business_verification_state == 'other_info_updated' ||
        data.send_data.user_info.business_verification_state == 'persona_verified')">
        <!-- <div class="col-md-12 mt-2"> -->
        <input type="checkbox" class="pointer" name="billing_check" id="billing_check" formControlName="checked"
          (change)="showAddressField = !showAddressField">
        <label for="billing_check">
          <span style="font-weight: 400; font-size: 14px; color: #313A44;">
            Choose {{data.send_data.type}} address as billing address
          </span>
        </label>
      </div>
      <div *ngIf="showAddressField" class="billing-address-section mt-2">
        <span class="ps-3 fs-16 f-w-800">Billing Address</span>
        <div class="col-md-12 form-cont mb-3 mt-2">
          <div
            [ngClass]="[(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||  (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required) ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
            <input class="input_field px-3 pt-3" formControlName="new_address_1" name="new_address_1" required trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Address Line 1
              </span>
            </label>
          </div>
          <p class="mat-error" *ngIf="(addCardForm.controls.new_address_1.touched && addCardForm.controls.new_address_1.invalid) ||
                (iscardSubmitted && addCardForm.controls.new_address_1.errors?.required)">
            Please enter address.
          </p>
        </div>

        <div class="col-md-12 form-cont mb-3">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" formControlName="new_address_2" name="new_address_2" trim
              (keypress)="mainService.handleInputSpace($event)" />
            <label for="text"
              [ngClass]="[addCardForm.controls.new_address_2 && addCardForm.controls.new_address_2.value !== '' ? 'label-name' : '']">
              <span class="content-name f-c-p-3">
                Address Line 2 (Optional)
              </span>
            </label>
          </div>
        </div>

        <div class="col-md-12 form-cont">
          <!-- <zip-selector (zipSelected)="getZipselected($event)" [placeholder]="" t="2"
            [customClass]="[(addCardForm.controls.zip_code.invalid && addCardForm.controls.zip_code.touched) || (iscardSubmitted && addCardForm.controls.zip_code.errors?.required)  ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']"
            [isRequired]="true" id="zip" name="zip" [model]="zipCode" ngDefaultControl>
          </zip-selector> -->
          <app-google-api (setAddress)="getZipselected($event)" [t]="1" [customClass]="[(addCardForm.controls.zip_code.invalid && addCardForm.controls.zip_code.touched) || (iscardSubmitted && addCardForm.controls.zip_code.errors?.required)  ? 'custom-form inputContainer' : 'custom-form']"
          id="zip" name="zip" [model]="zipCode"
          ngDefaultControl>
          </app-google-api>
          <p class="mat-error" *ngIf="addCardForm.controls.zip_code.errors?.required && iscardSubmitted">
            Please enter zip code.
          </p>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3" [ngClass]="[(addCardForm.controls.city.touched && addCardForm.controls.city.invalid) ||  (iscardSubmitted && addCardForm.controls.city.errors?.required) ? 'custom-form me-md-3 inputContainer' : 'custom-form me-md-3']">
                <input class="input_field px-3 pt-3" formControlName="city" name="city" trim  required autocomplete="disabled" (blur)="updateCity(addCardForm.controls.city.value, 'user_data')"/>
                <label for="text"
                  class="label-name">
                  <span class="content-name f-c-p-3">
                    City
                  </span>
                </label>
              </div>
              <p class="mat-error" *ngIf="addCardForm.controls.city.errors?.required && iscardSubmitted">
                Please enter city.
              </p>
            </div>

            <div class="col-md-6 form-cont mt-3">
              <div class="custom-form flex-grow-1 me-md-3">
                <input class="input_field px-3 pt-3 disabled_field" formControlName="state" name="state" disabled trim  />
                <label for="text"
                  [ngClass]="[addCardForm.controls.state && addCardForm.controls.state.value !== '' ? 'label-name' : '']">
                  <span class="content-name f-c-p-3">
                    State
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!showAddressField" class="same-billing row ps-4 pe-4">
        <div class="col-6" style="padding: 15px">
          <div style="border: 1px solid rgba(112,112,112,0.5); padding: 15px">
            <p class="m-0">{{data.send_data.address_1 + ', '}}</p>
            <p class="m-0">{{data.send_data.city + ', ' + data.send_data.zip_code}}</p>
            <p class="m-0">{{data.send_data.state}}
              {{data.send_data.country_code
              ?
              ', '+data.send_data.country_code:''}}
            </p>
          </div>
        </div>
        <div class="col-6" style="padding: 15px">
          <div class="" style="padding: 15px; border: 1px dashed rgba(112,112,112,0.5); height: 100%; display: flex;">
            <p class="text-center" style="align-self: center;margin:0">
              <a (click)="getAddressForm()" href="javascript:void(0)" style="color:#0A6B89">ADD NEW BILLING ADDRESS</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 pe-4" style="padding-left: 12px;" *ngIf="data.send_data.showDefault">
        <div class="mt-3">

          <input type="checkbox" class="pointer" name="saveDefault" id="saveDefault" formControlName="saveDefault">
          <label for="saveDefault">
            <span style="font-weight: 400; font-size: 14px; color: #313A44;">
              Save as Default
            </span>
          </label>
        </div>
      </div>

      <small class="col-lg-12 pe-4">
        <!-- <p *ngIf="new_address.cardError" class="text-danger-custom text-center" style="padding: 10px 15px 0px;">
          {{new_address.cardError}}</p> -->
      </small>
      <div class="d-flex justify-content-start" mat-dialog-actions>
        <!-- <button mat-stroked-button  mat-dialog-close (click)="dialogRef.close('2')"
            *ngIf="data.title!='Add Card'">{{data.title == 'Add Card' ? 'Cancel'
            : 'Back'}}</button> -->
        <button button-primary-auth [disabled]="responseSubmitted" class="add_btn px-4 ms-2">Add Now</button>
      </div>
      <div class="ps-3 ms-1 pt-3 w-100">
        <b>Note:</b>
        <ul class="ps-4" style="list-style-type: disc;">
          <li class="f-c-p-8 fs-16" style="font-weight: unset !important; text-align: unset !important;">$1 will be deducted and reversed to check the Card Authorization. </li>
          <!-- <li class="f-c-p-8 fs-16">You will be charged a dollor or 1% (whichever is higher) as an extra transaction fee if you use a non-US debit/credit card. </li> -->
        </ul>
    </div>
    </form>
  </div>
</div>

<div class="dialog-header mb-3" *ngIf="data.type == 801">
  <h2 mat-dialog-title class="px-4" style="text-transform: none !important;"> {{data.title}}
    <mat-icon (click)="dialogRef.close(0)" class="close pull-right close-sign">close</mat-icon>
  </h2>
  <span class="plan-sm-txt pb-2 d-inline-flex px-3">customer details</span>

  <div class="ms-3 d-flex justify-content-between" mat-dialog-actions>
    <button button-primary-auth class="px-4 py-3" (click)="this.dialogRef.close(2);">no</button>
    <button button-primary-auth class="px-4 py-3" (click)="this.dialogRef.close(1);">yes</button>
  </div>
</div>


<!-- Delete recent Service -->
<div class="dialog-header mb-3" *ngIf="data.type == 1001">
  <h2 mat-dialog-title class="px-4" style="text-transform: none !important;"> {{data.title}}
    <svg (click)="dialogRef.close(0)" class="close pull-right close-sign cursor" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 16L16 8" stroke="#596775" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 16L8 8" stroke="#596775" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  </h2>
  <p class="plan-sm-txt px-4" style="font-size: 18px; color:#313A44; line-height: 1.5; ">Are you sure you want to delete<span style="color:#1581E5;" class="ms-2">{{data.send_data.serviceInfo}} {{data.send_data.serviceAmmount | currency}}</span> from the recent services?</p>
  <div class="ms-3 d-flex" mat-dialog-actions>
    <button class="px-4 py-3 btn-delete" (click)="this.dialogRef.close(1);">Delete</button>
    <button class="px-4 py-3 btn-canecl"  (click)="dialogRef.close(0)">Cancel</button>
  </div>
</div>

<!-- Delete recent Service End -->

<div class="dialog-header mb-3" *ngIf="data.type == 802 && training_timezones.length > 0">
  <div class="align-items-end d-flex justify-content-between pt-5 px-5 pb-4" *ngIf="training_booked == 0">
    <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px); margin-left: 0px !important;" *ngIf="training_booked == 0"> Book a Free Training
    </h2>
    <mat-icon (click)="dialogRef.close(0)" class="close pull-right close-sign pointer">close</mat-icon>
  </div>
  <!-- <div class="ms-3 d-flex justify-content-between" mat-dialog-actions> -->
  <div *ngIf="training_booked == 0 && training_timezones.length > 0" class="d-flex justify-content-between w-100 py-0 px-5" mat-dialog-content>

    <div class="w-100">
      <!-- select Timezone start -->
      <div class="py-3 pt-0">
            <label>Select Timezone</label>
        <div class="wrap m-h-56 h-100 h-56 d-block" *ngIf="training_timezones.length > 0">
          <div class="select w-100 h-100 h-56">
            <select required class="select-text pt-2 px-3 input_field fw-bold m-h-56 h-100 w-100" [(ngModel)]="current_timezone" (change)="getBookableTimeSlots()">
              <ng-container *ngFor="let timezone of training_timezones">
                <option class="w-100 py-3 px-2" value="{{timezone.timezoneName+'****'+timezone.tzOffset}}">
                  {{timezone.timezoneName}} (GMT {{timezone.timezoneString}})
                  </option>
              </ng-container>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
          </div>
        </div>
      </div>
      <!-- select Timezone ends -->

      <div class="py-1">
        <label>Select Date</label>
        <div class="border_10 month-datepicker m-0 p-0 w-100 me-2 m-h-56 pointer">
          <!-- <mat-form-field appearance="outline" class="w-100 px-0 border_10 date-picker rounded-0 mat-short-height notranslate"> -->
            <div  class="custom-form">

            <input matInput [matDatepicker]="picker" [matDatepickerFilter]="myFilter" style="position: relative;z-index: 1;background-color: transparent !important;cursor: pointer;"  placeholder="Choose a date" [value]="today" [min]="today" [max]="lastDate" (click)="picker.open()" readonly class="fw-700 fs-16 px-3 pt-0 whiteBg"  (dateChange)="onDateChange($event)"
            required>
            <span class="position-absolute right-0 pointer" style="right: 0%;top: 50%;transform: translate(-15px, -12px);z-index: 0;">
              <img src="assets/img/svg/calendarv2.svg" alt="">
              <mat-datepicker-toggle matSuffix [for]="picker" class="d-none">
                <mat-datepicker #picker disabled="false"></mat-datepicker>
              </mat-datepicker-toggle>
            </span>
          <!-- </mat-form-field> -->
          </div>
        </div>
      </div>

      <!-- select timeslot start -->
      <div class="py-3 mb-3">
            <label class="">Select Timeslot</label>
        <div class="wrap m-h-56 h-100 h-56 d-block">
          <div class="select w-100 h-100 h-56">
            <select required class="select-text pt-2 px-3 input_field fw-bold m-h-56 h-100 w-100" *ngIf="training_data[0] && training_data[0].all_slots" (change)="openTooltip($event);selected_timeslot=null;">
              <option value="" class="d-none"></option>
              <ng-container *ngFor="let data of training_data">
                <ng-container *ngFor="let time of data.all_slots; let index = index">
                  <ng-container *ngIf="time.disable == 0">
                    <option class="notranslate" [value]="getValue(data,time,index)" >
                      {{time.timeAmPm}}
                    </option>
                  </ng-container>
                </ng-container>
                </ng-container>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <span class="select-bar-1"></span>
            <!-- <label class="select-label f-c-p-3">Select Timeslot</label> -->
          </div>
        </div>
      </div>
      <!-- select timeslot ends -->

      <!-- <div class="timeslot-buttons">
        <button mat-raised-button color="primary">02:00 PM</button>
        <button mat-raised-button color="accent">02:15 PM</button>
      </div> -->

      <ng-container *ngIf="selected_training_data.selected_time_lots.length > 0 && availableTimeslots.length > 0 && openboxes">
          <ng-container *ngFor="let timeslotss of availableTimeslots;let i = index">
            <div class="row mx-0 align-items-center justify-content-start flex-wrap mb-3 booking_slots" style="gap:10px;">
              <button class="slot-btn border_10 m-h-56 px-4 fw-500 fs-16" *ngFor="let timeslots of timeslotss;let i2 = index"
                style="flex: 0.5 !important; flex-grow: 1 !important;" [disabled]="timeslots.disable == 1"
                (click)="selected_timeslot = (i+i2 + (i==0 ? 0:1))"
                (click)="selected_training_data.selected_full_date_time_string = timeslots.fullDateTimeString; selected_training_data.schedule_time_slot = timeslots.time_slot;"
                [ngClass]="{
                  'selected_time': (i + i2 + (i == 0 ? 0 : 1)) == selected_timeslot,
                  'border': (i + i2 + (i == 0 ? 0 : 1)) != selected_timeslot,
                  'disable_time': timeslots.disable == 1,
                  'actv': selected_training_data.schedule_time_slot == timeslots.time_slot &&
                          selected_training_data.selected_full_date_time_string == timeslots.fullDateTimeString
                }">
                <span class="notranslate">{{timeslots.timeAmPm}}</span>
              </button>

            </div>
          </ng-container>
      </ng-container>

    </div>
  </div>


  <ng-container *ngIf="training_booked == 1">
    <div class="w-100 text-center pb-3 pt-4 px-5">
      <img src="assets/img/gif/right_mark11.gif" class="mx-auto" style="width: 170px;" alt="green_check" srcset="">
    </div>

    <div class="w-100 px-5">
      <p class="fs-20 text-center fw-600 mb-0 pb-2">Training has been booked</p>
      <p class="fw-700 fs-24 py-2 mb-0 text-center">
        {{training_booked_data.training_date}} at {{training_booked_data.training_time}}
      </p>
      <p class="text-center fs-14 training_sub">{{training_booked_data.timezone}}</p>
    </div>

  </ng-container>


  <div class="d-flex justify-content-between px-5" mat-dialog-actions>
    <button button-primary-auth class="px-4 py-3 w-100" *ngIf="training_booked == 0" [disabled]="selected_timeslot == null" (click)="confirmBooking();">Continue</button>
    <button button-primary-auth class="px-4 py-3 w-100" *ngIf="training_booked == 1" (click)="this.dialogRef.close(2);">Okay</button>
  </div>
</div>
<div *ngIf="data.type == 806"
  style="position: relative; padding: 40px 32px 32px !important; background-image: url('/assets/img/svg/banner/dec-modal2.svg') !important; background-repeat: no-repeat; background-size: cover;">

  <!-- Close Button -->
  <button (click)="dialogRef.close()"
    style="position: absolute; top: 10px; right: 10px; width: 32px; height: 32px; border-radius: 50%; background-color: transparent; border: 1px solid #FFFFFF; color:#FFFFFF; display: flex; align-items: center; justify-content: center; font-size: 24px; cursor: pointer;">
    &times;
  </button>
  <div class="challenge-container row mx-0" style="background: transparent;">
    <div class="challenge-content text-center" style="display: flex; flex-direction: column; align-items: center;">
      <img src="assets/img/svg/banner/challenge-pop-bg.svg" style="height: 76px;width: 120px;position: relative;overflow: hidden;margin-top: 4px;">
      <span class="challenge-title pb-2" style="color: #FFFFFF; font-size: 14px !important; font-weight: 500; margin-top: 12px !important;">{{capitalizeFirstLetter(dynamicMonth)}} Challenge</span>
      <span class="challenge-text" style="color: #FFFFFF; font-size: 22px !important; font-weight: 800; max-width: 420px; margin-top: 14px; text-align: center;">
        Earn <span
          class="highlight" style="color: #ffc202; font-weight: 800 !important;">{{'$'+(business_challenge.need_to_create_contract * business_challenge.prize)}}+ Minimum</span>
         Cashback This Month Just Create
        <span class="highlight" style="color: #FFFFFF; font-weight: 800 !important;">{{business_challenge.need_to_create_contract}}
          Contracts</span>!
      </span>
      <span class="challenge-description p-1 mt-2" style="color: #FFFFFF !important; font-size: 14px !important; max-width: 420px; font-weight: 400; text-align: center; opacity: .9;">
        Create {{business_challenge.need_to_create_contract}} contracts to get <b style="font-weight:800; color: #FFFFFF;">
            {{ '$'+(business_challenge.need_to_create_contract * business_challenge.prize )}} minimum </b>cashback this month & earn more if you surpass the goal! Cash out or choose an Amazon gift card.
      </span>
      <button class="challenge-button btn" style="margin-top: 24px; display: flex; align-items: center; justify-content: center; padding: 0 14px; width: 210px; max-width: unset; height: 48px; border-radius: 10px; background-color: #fff !important;" (click)="startChallenge()">
        <p style="display: flex; align-items: center; justify-content: center; gap: 10px; color: #000 !important; font-size: 16px; font-weight: 600; line-height: 1; margin: 0; white-space: nowrap;">
          Start Challenge
        </p>
      </button>
      <span class="challenge-timer d-flex align-items-center" style="margin-top: 14px;">
        <img src="assets/img/svg/clock.svg" class="me-1" style="width: 16px; filter: brightness(0) invert(1);">
        <span style="font-size: 13px; color: #FFFFFF !important;font-weight: 500;">{{timeRemaining}}</span>
      </span>
    </div>
  </div>
</div>

<div *ngIf="data.type == 803"
  style="position: relative; padding: 40px 32px 32px !important; background-image: url('/assets/img/svg/banner/dec-modal2.svg') !important; background-repeat: no-repeat; background-size: cover;">

  <!-- Close Button -->
  <button (click)="dialogRef.close()"
    style="position: absolute; top: 10px; right: 10px; width: 32px; height: 32px; border-radius: 50%; background-color: transparent; border: 1px solid #FFFFFF; color:#FFFFFF; display: flex; align-items: center; justify-content: center; font-size: 24px; cursor: pointer;">
    &times;
  </button>

  <div class="challenge-container row mx-0" style="background: transparent;">
    <div class="challenge-content text-center" style="display: flex; flex-direction: column; align-items: center;">
      <img src="assets/img/svg/banner/challenge-pop-bg.svg" style="height: 76px;width: 120px;position: relative;overflow: hidden;">
      <span class="challenge-title pb-2" style="color: #FFFFFF; font-size: 14px !important; font-weight: 500; margin-top: 12px !important;">{{capitalizeFirstLetter(dynamicMonth)}} Challenge Completed!</span>
      <span class="challenge-text" style="font-size: 40px; font-weight: 800; color: #EF6000; margin-top: 6px;">
        {{'$'+(business_challenge.need_to_create_contract * business_challenge.prize)}} unlocked
      </span>
      <span class="challenge-description p-2" style="color: #FFFFFF; max-width: 420px; text-align: center; opacity: .9;">
        You've nailed it! The<span style="font-weight: 700;"> {{'$'+(business_challenge.contract_this_month * business_challenge.prize)}} cashback</span> is yours for hitting<br>the {{business_challenge.contract_this_month}}-contract goal. But don't stop now — each extra <br>contract means more rewards!
      </span>
      <span class="row" style="margin: 1.5em 0 0;width: 100%;display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;gap: 16px;">
        <button class="challenge-button btn col-md-6" style="background-color: #FFFFFF; max-width: 215px;cursor: auto; border: 1px solid #FFFFFF;">
          <p style="color: #131921;">Avail in {{remaining_days}} days </p>
        </button>
        <button class="challenge-button btn col-md-6" style="background-color: #EF6000;max-width: 215px;" (click)="startChallenge()">
          <p style="color: #fff;">Continue To Earn More</p>
        </button>
      </span>
      <span class="challenge-timer d-flex align-items-center" style="margin-top: 25px;margin-bottom: 0;">
        <img src="assets/img/svg/clock.svg" class="me-1" style="width: 16px; filter: brightness(0) invert(1);">
        <span style="font-size: 13px;color: #FFFFFF;font-weight: 500;">{{timeRemaining}}</span>
      </span>
    </div>
  </div>
</div>

<div *ngIf="data.type == 804" style="position: relative; padding: 20px !important;font-family: Inter;">

  <!-- Close Button -->
  <button (click)="dialogRef.close()"
  style="position: absolute;top: 14px;right: 17px;width: 32px;height: 32px;background-color: transparent;display: flex;align-items: center;justify-content: center;font-size: 33px;cursor: pointer;font-weight: 200;">
    &times;
  </button>

  <div class="row" style="padding: 2em;">
    <div class="col-md-12 m-1">
      <span class="header-text">
        Choose your preferred way to get your reward:
      </span>
    </div>
    <div class="col-md-12 m-1">
      <span class="subheader-text">
        You've earned {{'$'+(business_challenge.amount_to_claim)}} for completing the Challenge.
      </span>
    </div>

    <!-- Option 1: Send via Payout -->
    <div class="col-md-12 m-1">
      <label class="option-card" [ngClass]="{'selected': selectedPayoutOption == 1}" for="payout">
        <div style="display: flex; align-items: center;">
          <img src="assets/img/svg/file-dollar.png" style="width: 44px;">
          <span class="option-details">
            <p class="option-title" style="color: #0C4C88;">Send via Payout</p>
            <!-- <p class="option-subTitle">Next Payout Date: 05/25/2024</p> -->
          </span>
        </div>
        <input id="payout" type="radio" value=1 [(ngModel)]="selectedPayoutOption" name="payout" style="position: static;">
      </label>
    </div>

    <!-- Option 2: Amazon Gift Card -->
    <div class="col-md-12 m-1">
      <label [ngClass]="{'selected': selectedPayoutOption == 2}" for="amazon" class="option-card">
        <img src="assets/img/svg/amazon.png" style="width: 44px;">
        <div style="display: flex;flex-direction: column;width: -webkit-fill-available;">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div style="display: flex; align-items: center;">
              <span class="option-details">
                <p class="option-title" style="color: #C97A00;">Amazon Gift Card</p>
                <!-- <p class="option-subTitle">Redeem as a {{'$'+(business_challenge.amount_to_claim)}}  Amazon Gift Card.</p> -->
              </span>
            </div>
            <input id="amazon" type="radio" value=2 [(ngModel)]="selectedPayoutOption" name="payout"
              style="position: static;">
          </div>
          <div class="col-12 mt-2" *ngIf="selectedPayoutOption == 2">
            <div  class="custom-form">
              <input class="input_field px-3"
                [(ngModel)]="amazonPayEmail" trim  placeholder="Email Address"
                style="background: #FFFFFF; border: 1px solid #C3C8CD; border-radius: 8px; width: -webkit-fill-available; padding-bottom: 12px;" />
            </div>
          </div>
        </div>
      </label>
    </div>

    <div class="col-md-12 m-2 mt-3">
      <button class="btn btn-primary" style="font-weight: 600; padding: 9px 46px;  border-radius: 8px; font-size: 18px;" (click)="claimReward();">Submit </button>
    </div>
  </div>
</div>
<div *ngIf="data.type == 805 && this.show100DollarChallange == 1"
  style="position: relative; padding: 20px !important; background-image: url('/assets/img/png/Frame_1410130827.png') !important; background-repeat: no-repeat; background-size: cover;">

  <!-- Close Button
  <button (click)="dialogRef.close()"
    style="position: absolute; top: 10px; right: 10px; width: 32px; height: 32px; border-radius: 50%; background-color: transparent; border: 1px solid white; color:white; display: flex; align-items: center; justify-content: center; font-size: 18px; cursor: pointer;">
    &times;
  </button> -->
  <div class="0-container row mx-0" style="background: transparent;">
    <div class="col-12 border_8  py-3 mb-3 border_cards bx-shadow  fm-inter">
      <div class="challenge-container w-100 row justify-content-between align-items-center p-4 mx-0" style="position: relative;">
        <div class="closee m-0" (click)="dialogRef.close()" style="position: absolute;right: 0;top: 0; ">
          <img src="assets\img\svg\close-circle.svg" alt="" style="width:50px">
        </div>
        <div>
          <p style="color: #0E5AFF; " class="fm-inter mb-1" *ngIf="business_challenge.current_month==1"><b>New User
              Special Offer!
            </b></p>
          <p style="color: #0E5AFF; " class="fm-inter mb-1" *ngIf="business_challenge.current_month==2"><b>Your Second
              Month with
              Denefits is Here! </b></p>
          <p style="color: #0E5AFF; " class="fm-inter mb-1" *ngIf="business_challenge.current_month==3"><b>Your Third
              Month with
              Denefits is Here! </b></p>
          <p style="font-size: 25px;font-weight: 700;" class="d-flex fm-inter mb-0"
            *ngIf="!business_challenge.reward_month">Earn $100 Cashback <img src="assets/img/svg/gift.svg" class="ms-2">
          </p>
          <p style="font-size: 25px;font-weight: 700;" class="d-flex fm-inter mb-0"
            *ngIf="business_challenge.reward_month">Keep Earning $100 Cashback! <img src="assets/img/svg/gift.svg"
              class="ms-2"> </p>
          <ng-container *ngIf="!business_challenge.reward_month">
            <p style="color: #727272;font-size: 14px;margin: 0; margin-bottom: 5px;" class="fm-inter">Unlock Now :</p>
            <p style="font-weight:700; font-size:21px" class="fm-inter"> Create Your First Contract</p>
          </ng-container>
        </div>

        <hr>
        <div class="col-12 py-1 p-0">
          <p style="font-size: 19px;" class="fm-inter" *ngIf="business_challenge.current_month==1">Welcome to Denefits!
            Earn $100 cashback each month for your first 3
            months. Start now and see how easy it is to
            unlock hidden revenue!</p>
          <ul style="list-style-type: disc;font-size: 15px;margin-left: 20px;" class="fm-inter"
            *ngIf="business_challenge.current_month!=1">
            <li>Create your first contract this month to earn another $100 cashback.</li>
            <li>Remember, you can earn $100 each month for your first 3 months!</li>
            <li>Create your first contract this month to earn another $100 cashback.</li>
          </ul>
          <div class="d-flex justify-content-between mb-3 mt-4">
            <button class=" btn active_btn me-2 fm-inter" (click)="startChallenge()" style="background: #04182A;color:white;padding: 13px 15px;font-weight: 600">Create A     Contract</button>
            <span class="challenge-timer d-flex" style=" margin-top: 14px;font-size: 14px;color: #C45D00;font-weight: 700;">
              <!-- {{daysRemaining}} left -->
            </span>
          </div>
          <p style="color:#727272;margin: 0;font-style: italic;font-size: 12px;">*T&C apply</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 807" style="max-width:500px;">
  <h2 mat-dialog-title
    class="text-start mb-0 px-0 pb-3 px-3 pb-md-0  mat-dialog-title d-flex align-items-center justify-content-between"
    style="font-size: 20px !important;">
    <span class="px-3 d-inline-block pot-trans fw-600" style="width: 90%;">
      Are you sure you want to remove this alternate contact's information?
    </span>
    <span class="px-1 pt-4 d-inline-block float-right"><mat-icon (click)="dialogRef.close()"
        class="close pull-right">close</mat-icon></span>
  </h2>
  <div mat-dialog-content class="py-3 w-100 ms-2">
    <div class="d-flex align-item-center">
      <button class="px-5 btn-wrap me-3 m-h-56" mat-raised-button (click)="dialogRef.close(1)">
        Yes, Remove
      </button>
      <button class="px-5 btn-wrap m-h-56" mat-raised-button
        style="background: white;color: #0a5fae !important;border: 1px solid #0a5fae" (click)="dialogRef.close(0)">
        Cancel
      </button>
    </div>
  </div>
</div>


<div *ngIf="data.type == 2001" style="color: white; font-family: 'Inter', sans-serif; position: relative; padding: 0; border-radius: 10px;">
  <!-- Dynamic Title -->
  <h2 [ngSwitch]="data.title" style="font-size: 18px; font-weight: 700; margin-bottom: 16px;">
    <span class="f-Inter" *ngSwitchCase="1">Customer Information</span>
    <span class="f-Inter" *ngSwitchCase="2">Debt Information</span>
    <span class="f-Inter" *ngSwitchCase="3">Debt Information</span>
    <span class="f-Inter" *ngSwitchDefault>Unknown Title</span>
  </h2>

  <!-- Dynamic Description -->
  <div [ngSwitch]="data.title" style="width: 208px; font-size: 14px; font-weight: 400; margin-bottom: 24px; color:#DFE5ED">
    <span class="f-Inter" *ngSwitchCase="1">
      Enter the customer's details, including their First Name, Last Name, Email Address or Phone Number, and SSN. Additionally, choose the preferred language for sending debt recovery emails to the customer.
    </span>
    <span class="f-Inter" *ngSwitchCase="2">
      Enter the debt owed, its age, the service provided, and the corresponding amount.
    </span>
    <span class="f-Inter" *ngSwitchCase="3">
      Offering discounts on older debt is highly recommended, as it greatly increases the chances of resolving it.
    </span>
    <span class="f-Inter" *ngSwitchDefault>No Description Available</span>
  </div>

  <!-- Navigation Buttons -->
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center;">
      <button (click)="dialogRef.close(1)" style="font-size: 12px; font-weight: 600; border-radius: 8px; padding: 8px 16px; background-color: white; color: #1581E5; border: 1px solid #1581E5;">
        <span class="f-Inter" *ngIf="data.title == '3'">Understood</span>
        <span class="f-Inter" *ngIf="data.title != '3'">Next</span>
      </button>
      <span class="f-Inter" style="font-size: 12px; color: #797F87; margin-left: 8px;">{{data.title}}/3</span>
    </div>
    <button class="f-Inter" *ngIf="data.title != '1'" (click)="dialogRef.close(2)" style="font-size: 12px; font-weight: 500; border-radius: 4px; padding: 8px 16px; background-color: transparent; color: #1167B6;">Back</button>
  </div>
</div>


<div *ngIf="data.type == 10001" style="color: white;font-family: 'Inter', sans-serif;padding: 1em;">
  <!-- Dynamic Title -->
  <h2 [ngSwitch]="data.title" style="font-size: 18px; font-weight: 700; margin-bottom: 16px;">
    <span class="f-Inter" *ngSwitchCase="1">Direct Enrollment</span>
    <span class="f-Inter" *ngSwitchCase="2">Send Proposal</span>
    <span class="f-Inter" *ngSwitchCase="3">Custom Plans</span>
    <span class="f-Inter" *ngSwitchDefault>Unknown Title</span>
  </h2>

  <!-- Dynamic Description -->
  <div [ngSwitch]="data.title"
    style="width: 208px; font-size: 14px; font-weight: 400; margin-bottom: 24px;color: #DFE5ED;">
    <span class="f-Inter" *ngSwitchCase="1">
      Select the best plan for you and your customer. You can directly assist with enrollment and accept payment.
    </span>
    <span class="f-Inter" *ngSwitchCase="2">
      Choose multiple payment plans and send a proposal link to your customer. They can review, enroll, and pay for the
      plan they prefer at their convenience.
    </span>
    <span class="f-Inter" *ngSwitchCase="3">
      Create your own payment plan by setting a specific recurring amount and/or terms.
    </span>
    <span class="f-Inter" *ngSwitchDefault>No Description Available</span>
  </div>

  <!-- Navigation Buttons -->
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center;">
      <button (click)="dialogRef.close(1)"
        style="font-size: 12px; font-weight: 600; border-radius: 8px; padding: 8px 16px; background-color: white; color: #1581E5; border: 1px solid #1581E5;">
        <span class="f-Inter" *ngIf="data.title == '3'">Understood</span>
        <span class="f-Inter" *ngIf="data.title != '3'">Next</span>
      </button>
      <span class="f-Inter" style="font-size: 12px; color: #797F87; margin-left: 8px;">{{data.title}}/3</span>
    </div>
    <button *ngIf="data.title != '1'" (click)="dialogRef.close(2)"
      style="font-size: 12px;font-weight: 600;border-radius: 4px;padding: 8px 16px;color: #1167B6;">Back</button>
  </div>
</div>

<div *ngIf="data.type == 1002" style="color: white; font-family: 'Inter', sans-serif; position: relative; padding: 1.5em;">
  <button class="m-4" (click)="dialogRef.close()"
    style="position: absolute; top: 10px; right: 10px; width: 32px; height: 32px; border: 1px solid black; border-radius: 50%; background-color: transparent; display: flex; align-items: center; justify-content: center; font-size: 18px; cursor: pointer; color: black;">
    &times;
  </button>
  <div style="display: flex; flex-direction: column;">
    <div style="display: flex; flex-direction: column;">
      <img src="assets/img/png/warning.png" style="width: 66px; margin-bottom: 0.5em;" />
      <span class="f-Inter"
        style="padding: 5px 10px; font-size: 20px; color: #04182A; font-weight: 500; max-width: 90%;">
        Select a single plan to create a financing contract. Multiple plans can only be sent as a proposal.
      </span>
    </div>
    <div style="margin-top: 1em;">
      <button (click)="dialogRef.close()"
        style="width: 133px; height: 56px; background-color: #1581E5; font-size: 16px; color: #fff; font-weight: 700; border: none; cursor: pointer; border-radius: 4px;">
        Understood
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.type === 1003"
  style="overflow: hidden auto;height: calc(100% - 60px);padding-right: 2em;background: rgb(25 25 25);"
  class="previewModal mb-3">
  <div class="close-icon" (click)="dialogRef.close()">&times;</div>
  <div class="row" style="min-height: 59px; box-shadow: 0px 1px 3px 0px #00000026; background: #728AF6;
        ">
    <div class="col-md-12"
      style="display: flex;justify-content: space-around;align-items: center;color: white;font-size: 16px;font-weight: 600;font-family: Inter;">
      <div style="display: flex;align-items: center;">
        <img [src]="selectedProfileImage" style="width: 40px;border-radius: 50%;">
        <span class="ms-2" style="display: flex;flex-direction: column;">
          <p class="f-Inter notranslate mb-0" style="font-size: 16px; font-weight: 700;">{{data.doctor_data.doctorName}}</p>
          <span class="f-Inter" style="font-size: 9px;font-weight: 400;display: flex;align-items: center;">Powered By <img src="assets/img/svg/denefits_logo_vector.svg" style="width: 60px;" class="ms-2"></span>
        </span>
      </div>
      <div style="font-weight: 400; display: flex;">
        <span class="f-Inter"><i style="color: #fff; font-size: 14px; transform: scaleX(-1)" class="ps-2 fa fa-phone" aria-hidden="true"></i>{{ formatPhoneNumber(data.doctor_data.doctorMobile) }}</span>
        <span class="ms-3">|</span>
        <span class="ms-3 f-Inter"><i style="color: #fff; font-size: 14px;" class="pe-2 fa fa-envelope" aria-hidden="true"></i>{{data.doctor_data.doctorEmail}}</span>
      </div>
      <div style="display: flex;justify-content: space-between;align-items: center;cursor: pointer;"
        (click)="dialogRef.close()" class="f-Inter">
        <img src="assets/img/svg/disableCustomer.svg" class="me-2"> Disable Customer View
      </div>
    </div>
  </div>
  <div class="row" style="min-height: 396px; background: linear-gradient(90deg, #3B66F0 0%, #5F88FD 47.5%, #5C71F1 100%);
        ;justify-content: center;">
    <div class="col-md-6 mt-5"
      style="display: flex; flex-direction: column; align-items: center; margin-bottom: 140px;">
      <span class="f-Inter" style="color: white; font-size: 42px; font-weight: 700; text-align: center;">
        Discover Your Tailored <br>Credit Boosting Payment Plan
      </span>
      <span class="f-Inter mt-4"
        style="color: white; font-size: 20px; font-weight: 600; background-color: #4173EF; border-radius: 12px; height: 48px; padding: auto; min-width: 341px; align-content: center; text-align: center;">
        Financing Amount <span class="notranslate ms-1">${{(data.estimatedServiceCost
            - data.downpayment.value.downpaymentCost) | number:'1.2-2' }}</span>
      </span>
    </div>
  </div>
  <div class="row preview_footer"
    style="background-color: white; border-top-left-radius: 115px; border-top-right-radius: 115px;margin-top: -110px; box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);">
    <div class="col-xl-8 col-lg-12">
      <span class="f-Inter" style="font-size: 22px; font-weight: 400; color: #131921;">{{data.selectedPlans.length}}
        plans
        available for
        financing</span>
      <div class="row">
        <div class="col-md-6 my-2" *ngFor="let item of data.selectedPlans; let i=index">
          <div class="plan-card">
            <div class="price">
              <span class="amount f-Inter notranslate">
                <sup class="currency f-Inter notranslate" style="top:-1em">$</sup>
                {{item.recurring_amount | number:'1.2-2'}}</span>
              <span class="per-month f-Inter">/mo.</span>
            </div>

            <div>
              <span class="duration f-Inter">For {{item.month}} Months</span>
            </div>

            <div class="interest-rate">
              <span class="f-Inter">Interest Rate:
                <span class="notranslate">
                  {{(item.interest_rate_to_show ? item.interest_rate_to_show : item.interest_rate) | number:'0.2-2'}}%
                  <sup *ngIf="data.paymentType=='noFee' || data.paymentType=='easyFinance'">
                    {{(item.interest_rate_to_show == item.interest_rate ? 'C' : 'F')}}
                  </sup>
                  <sup *ngIf="data.paymentType=='inHouse'">C</sup>
                </span>
              </span>
            </div>

            <div class="transaction-fee" style="font-size: 0.8em;">
              <span class="f-Inter" style="font-weight: 400;">Transaction Fee</span>
              <span class="f-Inter" style="font-weight: 600; color: #131921;"
                class="fee-value notranslate">{{getTransactionFee(data.validateInputData[0].transaction_settings,item.recurring_amount)}}
                /payment</span>
            </div>

            <div class="payable-today" style="font-size: 0.9em;">
              <span class="f-Inter" style="font-weight: 500;">Payable Today</span>
              <span class="f-Inter notranslate"
                style="font-weight: 700; color: #131921;">${{item.to_pay_today | number:'1.2-2'}}</span>
            </div>

            <button class="select-plan" style="background: #1581E5;">Select Plan</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-12" style="display: flex; flex-direction: column; justify-content: flex-start;">
      <span class="f-Inter" style="font-size: 1.4em; font-weight: 600; color: #131921;">Unlock Benefits</span>
      <span class="f-Inter mt-2" style="font-size: 0.9em; font-weight: 600; color: #272D35;">Denefits is a unique
        financing platform, designed to help you access the services you need from <span class="notranslate ms-1">{{data.doctor_data.doctorName}}</span>. </span>
      <span class="f-Inter mt-2" style="font-size: 0.8em; font-weight: 400; color: #656B73;font-style: italic;">Here’s
        why a Denefits payment plan stands out:</span>
      <span class="mt-2"
        style="display: flex;align-items: center;min-height: 82px; width: 364px; border-radius: 12px; background: linear-gradient(90deg, #81EEAD 0%, #CAFFDF 31.52%, #D7FFE7 100%);">
        <img src="assets\img\svg\credit-check.svg" style="width: 79px;height: 82px;">
        <span style="width:238px; display: flex;flex-direction: column;">
          <p style="color: #131921; font-size: 0.9em; font-weight: 600;" class="f-Inter m-0">No Credit Check</p>
          <p style="color: #656B73; font-size: 0.8em; font-weight: 400;" class="f-Inter m-0">Don't worry about your
            credit
            score
            -everyone qualifies.</p>
        </span>
      </span>
      <span class="mt-2"
        style="display: flex;align-items: center;min-height: 82px; width: 364px; border-radius: 12px; background: linear-gradient(90deg, #DEB4FF 0%, #F1DFFF 31.52%, #F4E7FF 100%);">
        <img src="assets\img\svg\penalties.svg" style="width: 79px;height: 82px;">
        <span style="width:238px; display: flex;flex-direction: column;">
          <p style="color: #131921; font-size: 0.9em; font-weight: 600;" class="f-Inter m-0">No Pre Payment
            Penalties</p>
          <p style="color: #656B73; font-size: 0.8em; font-weight: 400;" class="f-Inter m-0">No interest if you
            decide to
            pay off contract early</p>
        </span>
      </span>
      <span class="mt-2"
        style="display: flex;align-items: center;min-height: 82px; width: 364px; border-radius: 12px; background: linear-gradient(90deg, #9BE4FF 0%, #D1F3FF 31.52%, #E9F9FF 100%);">
        <img src="assets\img\svg\percentage.svg" style="width: 79px;height: 82px;">
        <span style="width:238px; display: flex;flex-direction: column;">
          <p style="color: #131921; font-size: 0.9em; font-weight: 600;" class="f-Inter m-0">No Accrued Interest</p>
          <p style="color: #656B73; font-size: 0.8em; font-weight: 400;" class="f-Inter m-0">If a payment is late,
            you’ll
            not accrue interest on the remaining balance.</p>
        </span>
      </span>
      <span class="mt-2"
        style="display: flex;align-items: center;min-height: 82px; width: 364px; border-radius: 12px; background: linear-gradient(90deg, #FFD3A8 0%, #FFECDA 31.52%, #FFF2E4 100%);">
        <img src="assets\img\svg\credit-score.svg" style="width: 79px;height: 82px;">
        <span style="width:238px; display: flex;flex-direction: column;">
          <p style="color: #131921; font-size: 0.9em; font-weight: 600;" class="f-Inter m-0">Improve Your Credit
            Score</p>
          <p style="color: #656B73; font-size: 0.8em; font-weight: 400;" class="f-Inter m-0">We improve credit score
            by
            working with you to report your on time payments</p>
        </span>
      </span>
    </div>
  </div>
  <div class="row preview_footer">
    <div class="col-md-12">
      <span class="f-Inter preview_footer__title">Proposal Services Details</span>
    </div>
    <div class="col-md-4 preview_footer__column" style="border-right: 1px solid rgba(0,0,0,.1);">
      <span class="f-Inter preview_footer__section-title">Proposed By</span>
      <span style="display: flex;flex-direction: column;">
        <span class="f-Inter preview_footer__name notranslate">{{data.doctor_data.doctorName}}</span>
        <span class="f-Inter preview_footer__contact mt-2"><i style="color: #1167B6; font-size: 14px;" class="pe-2 fa fa-envelope" aria-hidden="true"></i>{{data.doctor_data.doctorEmail}}</span>
          <span class="f-Inter preview_footer__contact mt-2"><i style="color: #1167B6; font-size: 14px; transform: scaleX(-1)" class="ps-2 fa fa-phone" aria-hidden="true"></i>
            {{ formatPhoneNumber(data.doctor_data.doctorMobile) }}
          </span>
      </span>
      <div style="display: flex;align-items: center;cursor: pointer; font-size: 16px; font-weight: 600; color: #1581E5;"
      (click)="dialogRef.close()">
      <img src="assets/img/svg/disableCustomer_blue.svg" class="me-2"> Disable Customer View
    </div>
    </div>
    <div class="col-md-8 preview_footer__column px-5">
      <span class="f-Inter preview_footer__section-title">Financing Amount</span>
      <div class="preview_footer__amount-details">
        <span class="f-Inter preview_footer__amount notranslate">${{(data.estimatedServiceCost
            - data.downpayment.value.downpaymentCost) | number:'1.2-2' }}</span>
        <span class="preview_footer__column">
          <p class="f-Inter preview_footer__label">Total Service Cost</p>
          <p class="f-Inter preview_footer__price notranslate">${{data.totalServAmt | number: '1.2-2'}}</p>
        </span>
        <span class="preview_footer__column">
          <p class="f-Inter preview_footer__label">Down Payment</p>
          <p class="f-Inter preview_footer__price notranslate">${{data.downpayment.value.downpaymentCost | number: '1.2-2'}}</p>
        </span>
      </div>
      <hr>
      <span class="f-Inter preview_footer__breakdown-title">Service Breakdown</span>
      <div class="preview_footer__breakdown-item" *ngFor="let service of data.service_block">
        <p class="f-Inter preview_footer__service-description notranslate">{{service.service}}</p>
        <p class="f-Inter preview_footer__service-price notranslate">${{service.price | number: '1.2-2'}}</p>
      </div>
    </div>
  </div>
  <div class="row preview_footer bg-white">
    <div class="col-md-12"
      style="display: flex; justify-content: space-between; font-size: 12px; font-weight: 500; color: #656B73;">
      <span class="f-Inter">Need Help? <a class="anchor-cls" [routerLink]="['/app/help/support']" (click)="dialogRef.close()" style="color: #1581E5;">Click Here</a> to contact Denefits Support © {{currentYear}} - Denefits</span>
      <span class="f-Inter" style="display: flex;">Powered by
        <img src="assets/img/svg/denefits-logo.svg" class="ms-2">
      </span>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 944">
  <div style="position: relative;">
    <img src="assets\img\png\pp_image2.png" alt=""
      style="position: fixed;z-index: 99999;margin-top: -42px;/* margin-left: 163px; */transform: translate(170%, 10px);">
  </div>
  <div class="align-items-center d-flex justify-content-between" style="padding: 15px;margin-top: 10px;">
    <h2 mat-dialog-title class="px-0 mb-0 pt-0" style="text-transform: none !important;max-width: calc(100% - 50px);">
    </h2>
    <mat-icon (click)="dialogRef.close(0);this.mainService.getTrainingsList()"
      class="close pull-right close-sign pointer">close</mat-icon>
  </div>
  <div style="width: 100%;max-width: 431px;margin: 0px auto;padding: 16px;text-align: center;padding-top: 15px;">
    <h3>Your verification is currently in process. Please wait a moment. If you encounter any issues, please don't
      hesitate to <span class="underline f-c-p-5 pointer" (click)="dialogRef.close(0);"
        [routerLink]="['/app/help/support']"><u>contact our support </u></span>team.</h3>
  </div>
</div>
<!-- payout data -->
<div class="dialog-header lendee-popup" *ngIf="data.type == 943">
  <div mat-dialog-content>
    <button (click)="dialogRef.close()" style="cursor: pointer;color: #596775;float: right;font-size: 26px;">
      &times;
    </button>
    <div class="w-auto text-center mt-4 mb-0">
      <p  style="font-size: 16px; font-weight: 600;">
        <span class="bg-yellow-2 mb-0 mt-4 px-4 py-2 rounded-5 text-center text-new-color w-auto">
          ⚡Let Denefits purchase your payments!
        </span>
      </p>
    </div>
    <div class="py-2">
      <p class="text-center fs-16 training_sub mb-0">Early Buyout</p>
      <p class="text-center mb-0" style="font-size: 48px; font-weight: 800;">{{data.loan_amount||'0' | currency}}</p>
      <p class="text-center fs-18 fw-500">in Next Payout (Guaranteed)</p>
      <p class="training_sub fs-14 text-center">Contract ID: {{getLendeeOfferData().offers[0].contract_code}}</p>
    </div>

    <p class="mb-0 text-center fs-18" *ngIf="getLendeeOfferData().total_offers == 1">
      This account has shown <span class="text-danger">late payments before</span>, you’re just one step away from receiving your funds.
    </p>

    <p class="mb-0 text-center fs-18" *ngIf="getLendeeOfferData().total_offers > 1">Your {{getLendeeOfferData().total_offers}} contract has shown
      <span class="text-danger">late payments before</span>, you’re just one step away from receiving your funds.</p>

      <div class="px-0 mt-3">
        <div class="border rounded-4 p-4 glass">
          <div class="mb-3 pb-1">
            <p class="text-center">Denefits values your business</p>
          </div>

          <div class="row gx-0 align-items-center justify-content-between column-gap-2">
            <div class="relative col fs-14 text-center bg-white rounded-4 px-3 py-2" style="min-height: 78px;">
              <div style="margin-top: -24px;" class="align-items-center mb-1 d-flex justify-content-center text-center">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="16" fill="#A5F3C4" />
                  <g clip-path="url(#clip0_19824_22936)">
                    <path
                      d="M14.2009 8.24704C10.7113 9.02334 8.20086 11.6167 7.38914 15.2679C7.33894 15.4982 7.3222 15.5068 6.76153 15.5068C6.33475 15.5068 6.15902 15.5409 6.07534 15.6432C5.93308 15.8139 5.95818 15.8565 7.07115 17.2897C7.64856 18.0404 7.98329 18.4072 8.09207 18.4072C8.20086 18.4072 8.57743 18.0148 9.20504 17.247C9.7155 16.6072 10.1758 16.0186 10.2176 15.9248C10.3515 15.6347 10.1423 15.5068 9.5063 15.5068C9.18831 15.5068 8.92889 15.4982 8.92889 15.4812C8.92889 15.4726 9.00421 15.2167 9.08789 14.9096C9.78245 12.4868 11.59 10.6783 14.0837 9.91054C14.7364 9.7058 14.9707 9.68021 16 9.68021C16.9456 9.68021 17.2971 9.71434 17.8327 9.85936C19.1716 10.2347 20.477 11.0366 21.3808 12.0432C21.8327 12.5551 22.6527 13.8347 22.6527 14.0395C22.6527 14.1162 22.703 14.1418 22.8034 14.1077C23.6737 13.775 24.0753 13.5873 24.0753 13.4935C24.0753 13.4338 23.9414 13.1267 23.7741 12.8025C22.6695 10.6698 20.6946 9.06599 18.3348 8.36647C17.3055 8.06789 15.272 8.00817 14.2009 8.24704Z"
                      fill="#175530" />
                    <path
                      d="M15.2051 12.7684C15.2051 13.1778 15.2051 13.1864 14.8955 13.2461C14.4771 13.3229 13.8745 13.647 13.5984 13.9456C13.2386 14.3295 13.113 14.739 13.113 15.5238C13.113 16.4878 13.2218 16.8461 13.6486 17.2641C14.1089 17.7077 14.7281 17.8954 15.7574 17.8954C16.3013 17.8954 16.5607 17.9295 16.6946 18.0319C16.9289 18.2025 16.9373 18.5864 16.703 18.7996C16.544 18.9447 16.385 18.9617 14.862 18.9532L13.1967 18.9447V19.6868V20.429L13.6821 20.5314C13.9415 20.5826 14.3934 20.6508 14.6863 20.6764L15.2051 20.7361V21.1883V21.6489H15.9164H16.6277V21.1968V20.7361L17.2804 20.5996C18.4687 20.3352 18.9038 19.7466 18.9122 18.3646C18.9206 17.7418 18.8871 17.5285 18.7448 17.2556C18.3264 16.4366 17.8076 16.1807 16.4436 16.1124C15.657 16.0698 15.431 16.0271 15.2971 15.8992C15.0712 15.6859 15.0712 15.3191 15.2971 15.1143C15.4561 14.9693 15.6151 14.9522 17.0126 14.9608L18.5524 14.9693V14.2271V13.4764L17.9917 13.3826C17.6737 13.3314 17.2386 13.2546 17.0043 13.2205L16.5858 13.1608L16.5607 12.7513L16.5356 12.3503H15.8662H15.2051V12.7684Z"
                      fill="#175530" />
                    <path
                      d="M23.682 15.4898C23.523 15.5922 21.7322 17.9979 21.7322 18.1003C21.7322 18.3221 21.9498 18.4074 22.5355 18.4074H23.1464L22.9874 18.9704C22.251 21.5808 20.2427 23.5088 17.5816 24.1827C16.7364 24.3875 15.113 24.3704 14.2427 24.1315C12.0586 23.5429 10.1171 21.8623 9.34726 19.8832C9.23848 19.6102 9.14642 19.3799 9.13806 19.3714C9.12969 19.3543 8.20919 19.6529 7.78241 19.815C7.62341 19.8747 8.15898 21.0946 8.72801 21.9562C9.9163 23.7903 11.7238 25.0785 13.9247 25.6671C14.954 25.9486 16.6025 25.9827 17.7071 25.7439C21.1297 25.0273 23.6987 22.5363 24.5272 19.1325L24.7196 18.3647L25.2468 18.3391C25.7824 18.3135 26 18.2197 26 18.0235C26 17.9211 24.1422 15.6093 23.9581 15.4898C23.841 15.4045 23.8075 15.4045 23.682 15.4898Z"
                      fill="#175530" />
                  </g>
                  <defs>
                    <clipPath id="clip0_19824_22936">
                      <rect width="20" height="18" fill="white" transform="translate(6 8)" />
                    </clipPath>
                  </defs>
                </svg>

              </div>
              <div>Protect Cash Flow</div>
            </div>
            <div
             class="relative col fs-14 text-center bg-white rounded-4 p-3">
              <div style="margin-top: -32px;" class="align-items-center mb-1 d-flex justify-content-center text-center">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="16" fill="#D1C9FF" />
                  <circle cx="16" cy="16" r="8" stroke="#3A2B94" stroke-width="2" />
                  <path d="M16 11V16.9845L19 19" stroke="#3A2B94" stroke-width="2" />
                </svg>
              </div>
              <div><!-- Get Paid in 5 Days --> Get Paid in Next Payout</div>
            </div>
            <div
             class="relative col fs-14 text-center bg-white rounded-4 p-3">
              <div style="margin-top: -32px;" class="align-items-center mb-1 d-flex justify-content-center text-center">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="16" fill="#F0DFAE" />
                  <path
                    d="M18.2266 12.3174L18.4375 12.6455L18.8145 12.7441L22.7988 13.79L20.1904 16.9795L19.9434 17.2812L19.9658 17.6709L20.2021 21.7842L16.3633 20.2881L16 20.1465L15.6367 20.2881L11.7969 21.7842L12.0342 17.6699L12.0566 17.2812L11.8096 16.9795L9.2002 13.79L13.1855 12.7441L13.5625 12.6455L13.7734 12.3174L16 8.85059L18.2266 12.3174Z"
                    stroke="#624B09" stroke-width="2" />
                </svg>
              </div>
              <div>Claim Process Not Required</div>
            </div>
          </div>
        </div>
      </div>

    <!-- <p class="text-center" style="font-size: 22px; font-weight: 700; color: #131921">Early Payout!</p>
    <p class="mb-0 text-center" style="font-size: 16px; font-weight: 500; color: #131921">No need to wait months—get your share now</p>
    <p class="text-center" style="font-size: 16px; font-weight: 500; color: #131921">and enjoy faster access to your funds.</p>
    <hr> -->
  </div>
  <div class="col text-center mt-2 pb-2">
    <button class="btn btn-default mb-2 py-3" style="color: #FFFFFF; font-size: 16px; font-weight: 600; line-height: 26px; width: 220px; background-color: #066FD0;" routerLink="/app/contract/list" [queryParams]=data.queryParam (click)="dialogRef.close()">Review and Accept Offer</button>
  </div>
  <p class="text-center mb-0 pb-2 fw-700" style="font-size: 14px; font-weight: 500; color: #D50000">
    <ng-container *ngIf="getLendeeOfferData().total_offers == 1">
      <!-- {{timerDisplay || "23 Hours : 51 Mins : 24 Secs" }} -->
      Valid For a Limited Period
    </ng-container>
    <ng-container *ngIf="getLendeeOfferData().total_offers > 1">
      Valid For a Limited Period
    </ng-container>
  </p>
</div>

<div class="instantPayModal" *ngIf="data.type == 945" [style.background-image]="'url(' + data.bgImage + ')'">
  <div mat-dialog-content style="position: relative; padding: 16px; display: flex; align-items: center; justify-content: center; overflow: hidden; max-height: unset;">

    <button (click)="dialogRef.close()"
      style="cursor: pointer; color: #FFFFFF; position: absolute; top: 2px; right: 16px; background: none; border: none; font-size: 35px;">
      &times;
    </button>

    <div class="mt-4" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 12px; max-width: 100%; padding-bottom: 40px;">

      <span class="bolt_logo" style="margin-bottom: 10px;">
        <img src="assets/img/png/Vector.png" alt="Instant Payout">
      </span>
      <div style="max-width: 466px;">
        <img src="assets/img/svg/rocket.svg" style="display: inline; width: 28px; height: 28px; margin-top: -10px; margin-right: 5px;"/>
        <h2 style="color: #FFFFFF; margin: 0; font-family: Inter; font-size: 28px; font-weight: 700; line-height: 140%; display: inline;">Get Paid in 30 Minutes or Less
          Anytime, Anywhere!</h2>
      </div>

      <div class="d-flex flex-column align-item-center" style="max-width: 427px; text-align: center; margin-bottom: 25px;">
        <span style="color: #81EEAD; margin: 0; font-family: Inter; margin-top: 16px; font-size: 18px;font-weight: 500; line-height: 170%;">You’ve earned it — why wait?</span>
        <p style="color: #FFFFFF; width: 100%; font-family: Inter; font-size: 17px; font-weight: 400; line-height: 170%;">
        Transfer your available balance now and see the cash hit your card or bank in 30 minutes or less, 24/7—even on weekends and holidays.
        </p>
      </div>
      <!-- <p style="color: #81EEAD; margin: 0; font-family: Inter; margin-top: 16px; font-size: 18px;font-weight: 500;">You’ve earned it — why wait?</p> -->


      <button style="background: #04182A;color: #FFFFFF;border-radius: 7px;cursor: pointer;font-family: Inter;width: 232px;height: 56px;padding-right: 16px;padding-left: 16px;font-size: 16px;font-weight: 600;"
        (click)="goToInstantPayComponent()">
        Transfer My Money Now
      </button>

      <p style="color: #FFFFFF; margin: 0; font-family: Inter; font-size: 16px; font-weight: 400;">Instant Payout Available: <span class="notranslate" style="color: #FFFFFF; margin: 0; font-family: Inter; font-size: 16px; font-weight: 400;">{{instant_payout_config.total_payout | currency: '$'}}</span></p>

    </div>
  </div>
</div>

<div class="instantCardModal" *ngIf="data.type == 946">
  <div mat-dialog-content style="position: relative; padding: 16px;">
    <button (click)="dialogRef.close()"
      style="cursor: pointer; color: #3c4a5d; position: absolute; top: -3px; right: 12px; background: none; border: none; font-size: 35px;">
      &times;
    </button>
    <div class="mt-4">
      <h4 class="mb-2" style="font-family: Inter; font-weight: 700; font-style: Bold; font-size: 20px; color: #04182A;">Set Up Instant Payouts to Your Debit Card</h4>
      <p style="font-family: Inter; font-weight: 400; font-style: Regular; font-size: 14px; color: #797F87; max-width: 424px;">
        Add a supported debit card to receive your payouts instantly—24/7, even on weekends and holidays.
      </p>
      <form #instantPayoutCard="ngForm" class="w-100 mt-4" (ngSubmit)="addInstantCard(instantPayoutCard)">
        <div class="row m-0 w-100 input__wrapper mb-4">
            <input class="name_input" name="cardholder_name" [(ngModel)]="cardholderName" (keypress)="mainService.handleInputSpace($event)"
              placeholder="Name on card" trim="true" required>
        </div>
        <div class="row m-0 w-100">
          <div class="stripe-card" id="add_instant_card"></div>
        </div>
        <div class="mt-4 d-flex">
          <button class="confirm-btn" type="submit" style="font-family: Inter; font-weight: 600; font-style: Semi Bold; font-size: 15px; color: #FFFFFF;" [disabled]="!instantPayoutCard.valid || !cardComplete">Confirm and Continue</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="instantPayoutConfirmedModal" *ngIf="data.type == 947">
  <div mat-dialog-content style="position: relative; padding: 16px;">
    <div class="d-flex align-item-center justify-content-center" style="position: absolute;cursor: pointer;top: 9px;height: 32px;width: 32px;border-radius: 50%;border: 1px solid #CBD1D9;right: 12px;">
      <button (click)="closeInstantPayoutConfirmedModal()"
        style="background: none;border: none;font-size: 20px;position: absolute;top: 3px;right: 8.5px;">
        &times;
      </button>
    </div>
    <div class="instant_progress_container" style="background: none; padding-bottom: 25px;">
      <div class="progress_container">
        <div class="mb-3 bolt_logo_1" style="width: 72px; height: 72px;">
          <img src="assets/img/png/Vector.png" style="width: 32px; height: 42px;" />
        </div>
        <h2 class="mb-4" style="font-family: Inter;font-weight: 600;font-size: 24px;color: #131921;">Instant Payout In Progress</h2>
        <p class="mt-1" style="font-family: Inter;font-weight: 400;font-size: 16px;color:#131921; margin: 0; max-width: 465px;">Your
          request for <span class="notranslate" style="font-family: Inter;font-weight: 400;font-size: 16px;color:#131921;">${{data.send_data.payoutAmount.toFixed(2)}}</span> has been successfully submitted. Funds will be deposited to ••••
          {{data.send_data.last4}}
          within 30 minutes.</p>
          <div class="dashboard-btn d-flex align-item-center justify-content-center">
            <button id="dashboard_btn" (click)="goToPayouts()" style="color: #131921; font-weight: 600;">Go to Payouts</button>
          </div>
        <p class="payout_note">Note: A {{data.send_data.payout_fee_percentage}}% fee will be deducted from your Denefits
          account separately.</p>
      </div>
    </div>
  </div>
</div>
